/**
 * Yle Design System
 * v1.2.4
 */

const BORDER_SM = '1px';
const BORDER_MD = '2px';

var border = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BORDER_MD: BORDER_MD,
  BORDER_SM: BORDER_SM
});

/**
 * Yle Design System
 * v1.2.4
 */

const NONE = 0;
const MEDIUM = '4px';
const LARGE = '8px';
const FULL = '400px';

var borderRadius = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FULL: FULL,
  LARGE: LARGE,
  MEDIUM: MEDIUM,
  NONE: NONE
});

/**
 * Yle Design System
 * v1.2.4
 */

const GRAY_5 = '#f8f9fa';
const GRAY_10 = '#f1f2f4';
const GRAY_20 = '#e8e9eb';
const GRAY_30 = '#d8d9db';
const GRAY_40 = '#b4b6b7';
const GRAY_50 = '#949697';
const GRAY_60 = '#4a4f54';
const GRAY_70 = '#323639';
const GRAY_80 = '#292b2d';
const GRAY_90 = '#1f2123';
const GRAY_95 = '#131415';
const BLACK_OPACITY_5 = 'rgba(0, 0, 0, 0.02)';
const BLACK_OPACITY_10 = 'rgba(0, 0, 0, 0.05)';
const BLACK_OPACITY_20 = 'rgba(0, 0, 0, 0.09)';
const BLACK_OPACITY_30 = 'rgba(0, 0, 0, 0.15)';
const BLACK_OPACITY_40 = 'rgba(0, 0, 0, 0.29)';
const BLACK_OPACITY_50 = 'rgba(0, 0, 0, 0.41)';
const BLACK_OPACITY_60 = 'rgba(0, 0, 0, 0.7)';
const BLACK_OPACITY_70 = 'rgba(0, 0, 0, 0.79)';
const BLACK_OPACITY_80 = 'rgba(0, 0, 0, 0.83)';
const BLACK_OPACITY_90 = 'rgba(0, 0, 0, 0.87)';
const BLACK_OPACITY_95 = 'rgba(0, 0, 0, 0.92)';
const WHITE_OPACITY_5 = 'rgba(255, 255, 255, 0.08)';
const WHITE_OPACITY_10 = 'rgba(255, 255, 255, 0.13)';
const WHITE_OPACITY_20 = 'rgba(255, 255, 255, 0.17)';
const WHITE_OPACITY_30 = 'rgba(255, 255, 255, 0.21)';
const WHITE_OPACITY_40 = 'rgba(255, 255, 255, 0.3)';
const WHITE_OPACITY_50 = 'rgba(255, 255, 255, 0.59)';
const WHITE_OPACITY_60 = 'rgba(255, 255, 255, 0.71)';
const WHITE_OPACITY_70 = 'rgba(255, 255, 255, 0.85)';
const WHITE_OPACITY_80 = 'rgba(255, 255, 255, 0.91)';
const WHITE_OPACITY_90 = 'rgba(255, 255, 255, 0.95)';
const WHITE_OPACITY_95 = 'rgba(255, 255, 255, 0.98)';
const WHITE = '#ffffff';
const BLACK = '#000000';
const TURQUOISE_5 = '#e5fdff';
const TURQUOISE_10 = '#c7f4fa';
const TURQUOISE_20 = '#9cebf4';
const TURQUOISE_30 = '#5ddbe9';
const TURQUOISE_40 = '#29ccde';
const TURQUOISE_50 = '#00b4c8';
const TURQUOISE_60 = '#009cb5';
const TURQUOISE_70 = '#00809c';
const TURQUOISE_80 = '#00637d';
const TURQUOISE_90 = '#00475e';
const TURQUOISE_95 = '#0b3f4b';
const NEWS_VIOLET_5 = '#e6e5ff';
const NEWS_VIOLET_10 = '#d3cbfb';
const NEWS_VIOLET_20 = '#b7a8fa';
const NEWS_VIOLET_30 = '#9479fb';
const NEWS_VIOLET_40 = '#7c59fa';
const NEWS_VIOLET_50 = '#694bd7';
const NEWS_VIOLET_60 = '#553db4';
const NEWS_VIOLET_70 = '#413091';
const NEWS_VIOLET_80 = '#2f2372';
const NEWS_VIOLET_90 = '#1e1753';
const NEWS_VIOLET_95 = '#120e3e';
const NEWS_ORANGE_5 = '#fff2f2';
const NEWS_ORANGE_10 = '#fdd6d3';
const NEWS_ORANGE_20 = '#fab8b3';
const NEWS_ORANGE_30 = '#f79c94';
const NEWS_ORANGE_40 = '#f57f74';
const NEWS_ORANGE_50 = '#f26659';
const NEWS_ORANGE_60 = '#d24f45';
const NEWS_ORANGE_70 = '#b83c35';
const NEWS_ORANGE_80 = '#9b2823';
const NEWS_ORANGE_90 = '#7f1412';
const NEWS_ORANGE_95 = '#650101';
const SPORTS_VIOLET_5 = '#eeeeff';
const SPORTS_VIOLET_10 = '#ddd9fc';
const SPORTS_VIOLET_20 = '#b3abf7';
const SPORTS_VIOLET_30 = '#8578f2';
const SPORTS_VIOLET_40 = '#6553ef';
const SPORTS_VIOLET_50 = '#5541ed';
const SPORTS_VIOLET_60 = '#372bb1';
const SPORTS_VIOLET_70 = '#292094';
const SPORTS_VIOLET_80 = '#1a1476';
const SPORTS_VIOLET_90 = '#0d0a5c';
const SPORTS_VIOLET_95 = '#030349';
const SPORTS_LIME_5 = '#fdfde7';
const SPORTS_LIME_10 = '#f9ffc6';
const SPORTS_LIME_20 = '#ebfe8d';
const SPORTS_LIME_30 = '#d4ff42';
const SPORTS_LIME_40 = '#caf53e';
const SPORTS_LIME_50 = '#b0d934';
const SPORTS_LIME_60 = '#91ae42';
const SPORTS_LIME_70 = '#7a9a2c';
const SPORTS_LIME_80 = '#618515';
const SPORTS_LIME_90 = '#46690b';
const SPORTS_LIME_95 = '#2c4d01';
const SPORTS_PINK_5 = '#fff5f9';
const SPORTS_PINK_10 = '#fcd9e8';
const SPORTS_PINK_20 = '#f7abcb';
const SPORTS_PINK_30 = '#f273a8';
const SPORTS_PINK_40 = '#ea3e85';
const SPORTS_PINK_50 = '#e60060';
const SPORTS_PINK_60 = '#c50152';
const SPORTS_PINK_70 = '#a70146';
const SPORTS_PINK_80 = '#880139';
const SPORTS_PINK_90 = '#6b012c';
const SPORTS_PINK_95 = '#4d0120';
const INFO_ORANGE_5 = '#fff3e2';
const INFO_ORANGE_10 = '#ffe3bf';
const INFO_ORANGE_20 = '#ffd199';
const INFO_ORANGE_30 = '#fec075';
const INFO_ORANGE_40 = '#feb054';
const INFO_ORANGE_50 = '#ff8f33';
const INFO_ORANGE_60 = '#f56a1b';
const INFO_ORANGE_70 = '#e65a27';
const INFO_ORANGE_80 = '#e04312';
const INFO_ORANGE_90 = '#c93c11';
const INFO_ORANGE_95 = '#9b2e0d';
const INFO_YELLOW_5 = '#fff8e0';
const INFO_YELLOW_10 = '#ffeeb2';
const INFO_YELLOW_20 = '#ffe387';
const INFO_YELLOW_30 = '#ffd959';
const INFO_YELLOW_40 = '#ffcf2d';
const INFO_YELLOW_50 = '#ffc400';
const INFO_YELLOW_60 = '#f1b601';
const INFO_YELLOW_70 = '#cc9601';
const INFO_YELLOW_80 = '#ae7b01';
const INFO_YELLOW_90 = '#926201';
const INFO_YELLOW_95 = '#764901';
const INFO_GREEN_5 = '#e0fff4';
const INFO_GREEN_10 = '#b4f5de';
const INFO_GREEN_20 = '#88eac7';
const INFO_GREEN_30 = '#5fe0b2';
const INFO_GREEN_40 = '#33d59b';
const INFO_GREEN_50 = '#07ca84';
const INFO_GREEN_60 = '#07b577';
const INFO_GREEN_70 = '#06a26a';
const INFO_GREEN_80 = '#068e5d';
const INFO_GREEN_90 = '#05794f';
const INFO_GREEN_95 = '#046542';
const INFO_BLUE_5 = '#e0f2ff';
const INFO_BLUE_10 = '#bbdcff';
const INFO_BLUE_20 = '#95c6ff';
const INFO_BLUE_30 = '#71b0ff';
const INFO_BLUE_40 = '#4b9aff';
const INFO_BLUE_50 = '#2684ff';
const INFO_BLUE_60 = '#2078ed';
const INFO_BLUE_70 = '#196dda';
const INFO_BLUE_80 = '#1260c7';
const INFO_BLUE_90 = '#0b54b4';
const INFO_BLUE_95 = '#0448a1';
const INFO_DEEP_BLUE_5 = '#e3eaf3';
const INFO_DEEP_BLUE_10 = '#c9d5e6';
const INFO_DEEP_BLUE_20 = '#b0c1da';
const INFO_DEEP_BLUE_30 = '#99aece';
const INFO_DEEP_BLUE_40 = '#738ab5';
const INFO_DEEP_BLUE_50 = '#546d9c';
const INFO_DEEP_BLUE_60 = '#3d5483';
const INFO_DEEP_BLUE_70 = '#1e2e52';
const INFO_DEEP_BLUE_80 = '#131e39';
const INFO_DEEP_BLUE_90 = '#131625';
const INFO_DEEP_BLUE_95 = '#020408';
const INFO_PURPLE_5 = '#fcf5ff';
const INFO_PURPLE_10 = '#e8d0f1';
const INFO_PURPLE_20 = '#d9b0e8';
const INFO_PURPLE_30 = '#ca91de';
const INFO_PURPLE_40 = '#ba72d5';
const INFO_PURPLE_50 = '#9436b5';
const INFO_PURPLE_60 = '#80259f';
const INFO_PURPLE_70 = '#620579';
const INFO_PURPLE_80 = '#4b075b';
const INFO_PURPLE_90 = '#30063a';
const INFO_PURPLE_95 = '#1c0222';
const RED_5 = '#fff5f8';
const RED_10 = '#fcc5d3';
const RED_20 = '#f99fb5';
const RED_30 = '#f77898';
const RED_40 = '#f5517a';
const RED_50 = '#e90e43';
const RED_60 = '#d10b3d';
const RED_70 = '#9a092d';
const RED_80 = '#740722';
const RED_90 = '#4d0417';
const GREEN_5 = '#e5fff9';
const GREEN_10 = '#a1f9dd';
const GREEN_20 = '#62f9c2';
const GREEN_30 = '#1ff0a4';
const GREEN_40 = '#03e592';
const GREEN_50 = '#07ca84';
const GREEN_60 = '#06b173';
const GREEN_70 = '#058657';
const GREEN_80 = '#046240';
const GREEN_90 = '#023b26';
const ORANGE_5 = '#fff3e2';
const ORANGE_10 = '#ffe1b8';
const ORANGE_20 = '#ffce8b';
const ORANGE_30 = '#ffb95f';
const ORANGE_40 = '#ff9c31';
const ORANGE_50 = '#ff8f33';
const ORANGE_60 = '#f1722a';
const ORANGE_70 = '#e65a27';
const ORANGE_80 = '#e04312';
const ORANGE_90 = '#c93c11';
const BLUE_5 = '#e0f2ff';
const BLUE_10 = '#ccdef5';
const BLUE_20 = '#9fc8ee';
const BLUE_30 = '#88b3e7';
const BLUE_40 = '#669de1';
const BLUE_50 = '#2975d0';
const BLUE_60 = '#1163b0';
const BLUE_70 = '#234c93';
const BLUE_80 = '#0a3276';
const BLUE_90 = '#00284e';
const YELLOW_5 = '#fffce2';
const YELLOW_10 = '#fcf0c5';
const YELLOW_20 = '#fae69e';
const YELLOW_30 = '#f9dc77';
const YELLOW_40 = '#f7d350';
const YELLOW_50 = '#f4c722';
const YELLOW_60 = '#dab013';
const YELLOW_70 = '#b18e0c';
const YELLOW_80 = '#725a07';
const YELLOW_90 = '#493b06';
const PURPLE_5 = '#fcf5ff';
const PURPLE_10 = '#e8d0f1';
const PURPLE_20 = '#d9b0e8';
const PURPLE_30 = '#ca91de';
const PURPLE_40 = '#ba72d5';
const PURPLE_50 = '#9436b5';
const PURPLE_60 = '#80259f';
const PURPLE_70 = '#620579';
const PURPLE_80 = '#4b075b';
const PURPLE_90 = '#30063a';
const BRAND = '#00b4c8'; // deprecated: use theme colors instead

var colors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BLACK: BLACK,
  BLACK_OPACITY_10: BLACK_OPACITY_10,
  BLACK_OPACITY_20: BLACK_OPACITY_20,
  BLACK_OPACITY_30: BLACK_OPACITY_30,
  BLACK_OPACITY_40: BLACK_OPACITY_40,
  BLACK_OPACITY_5: BLACK_OPACITY_5,
  BLACK_OPACITY_50: BLACK_OPACITY_50,
  BLACK_OPACITY_60: BLACK_OPACITY_60,
  BLACK_OPACITY_70: BLACK_OPACITY_70,
  BLACK_OPACITY_80: BLACK_OPACITY_80,
  BLACK_OPACITY_90: BLACK_OPACITY_90,
  BLACK_OPACITY_95: BLACK_OPACITY_95,
  BLUE_10: BLUE_10,
  BLUE_20: BLUE_20,
  BLUE_30: BLUE_30,
  BLUE_40: BLUE_40,
  BLUE_5: BLUE_5,
  BLUE_50: BLUE_50,
  BLUE_60: BLUE_60,
  BLUE_70: BLUE_70,
  BLUE_80: BLUE_80,
  BLUE_90: BLUE_90,
  BRAND: BRAND,
  GRAY_10: GRAY_10,
  GRAY_20: GRAY_20,
  GRAY_30: GRAY_30,
  GRAY_40: GRAY_40,
  GRAY_5: GRAY_5,
  GRAY_50: GRAY_50,
  GRAY_60: GRAY_60,
  GRAY_70: GRAY_70,
  GRAY_80: GRAY_80,
  GRAY_90: GRAY_90,
  GRAY_95: GRAY_95,
  GREEN_10: GREEN_10,
  GREEN_20: GREEN_20,
  GREEN_30: GREEN_30,
  GREEN_40: GREEN_40,
  GREEN_5: GREEN_5,
  GREEN_50: GREEN_50,
  GREEN_60: GREEN_60,
  GREEN_70: GREEN_70,
  GREEN_80: GREEN_80,
  GREEN_90: GREEN_90,
  INFO_BLUE_10: INFO_BLUE_10,
  INFO_BLUE_20: INFO_BLUE_20,
  INFO_BLUE_30: INFO_BLUE_30,
  INFO_BLUE_40: INFO_BLUE_40,
  INFO_BLUE_5: INFO_BLUE_5,
  INFO_BLUE_50: INFO_BLUE_50,
  INFO_BLUE_60: INFO_BLUE_60,
  INFO_BLUE_70: INFO_BLUE_70,
  INFO_BLUE_80: INFO_BLUE_80,
  INFO_BLUE_90: INFO_BLUE_90,
  INFO_BLUE_95: INFO_BLUE_95,
  INFO_DEEP_BLUE_10: INFO_DEEP_BLUE_10,
  INFO_DEEP_BLUE_20: INFO_DEEP_BLUE_20,
  INFO_DEEP_BLUE_30: INFO_DEEP_BLUE_30,
  INFO_DEEP_BLUE_40: INFO_DEEP_BLUE_40,
  INFO_DEEP_BLUE_5: INFO_DEEP_BLUE_5,
  INFO_DEEP_BLUE_50: INFO_DEEP_BLUE_50,
  INFO_DEEP_BLUE_60: INFO_DEEP_BLUE_60,
  INFO_DEEP_BLUE_70: INFO_DEEP_BLUE_70,
  INFO_DEEP_BLUE_80: INFO_DEEP_BLUE_80,
  INFO_DEEP_BLUE_90: INFO_DEEP_BLUE_90,
  INFO_DEEP_BLUE_95: INFO_DEEP_BLUE_95,
  INFO_GREEN_10: INFO_GREEN_10,
  INFO_GREEN_20: INFO_GREEN_20,
  INFO_GREEN_30: INFO_GREEN_30,
  INFO_GREEN_40: INFO_GREEN_40,
  INFO_GREEN_5: INFO_GREEN_5,
  INFO_GREEN_50: INFO_GREEN_50,
  INFO_GREEN_60: INFO_GREEN_60,
  INFO_GREEN_70: INFO_GREEN_70,
  INFO_GREEN_80: INFO_GREEN_80,
  INFO_GREEN_90: INFO_GREEN_90,
  INFO_GREEN_95: INFO_GREEN_95,
  INFO_ORANGE_10: INFO_ORANGE_10,
  INFO_ORANGE_20: INFO_ORANGE_20,
  INFO_ORANGE_30: INFO_ORANGE_30,
  INFO_ORANGE_40: INFO_ORANGE_40,
  INFO_ORANGE_5: INFO_ORANGE_5,
  INFO_ORANGE_50: INFO_ORANGE_50,
  INFO_ORANGE_60: INFO_ORANGE_60,
  INFO_ORANGE_70: INFO_ORANGE_70,
  INFO_ORANGE_80: INFO_ORANGE_80,
  INFO_ORANGE_90: INFO_ORANGE_90,
  INFO_ORANGE_95: INFO_ORANGE_95,
  INFO_PURPLE_10: INFO_PURPLE_10,
  INFO_PURPLE_20: INFO_PURPLE_20,
  INFO_PURPLE_30: INFO_PURPLE_30,
  INFO_PURPLE_40: INFO_PURPLE_40,
  INFO_PURPLE_5: INFO_PURPLE_5,
  INFO_PURPLE_50: INFO_PURPLE_50,
  INFO_PURPLE_60: INFO_PURPLE_60,
  INFO_PURPLE_70: INFO_PURPLE_70,
  INFO_PURPLE_80: INFO_PURPLE_80,
  INFO_PURPLE_90: INFO_PURPLE_90,
  INFO_PURPLE_95: INFO_PURPLE_95,
  INFO_YELLOW_10: INFO_YELLOW_10,
  INFO_YELLOW_20: INFO_YELLOW_20,
  INFO_YELLOW_30: INFO_YELLOW_30,
  INFO_YELLOW_40: INFO_YELLOW_40,
  INFO_YELLOW_5: INFO_YELLOW_5,
  INFO_YELLOW_50: INFO_YELLOW_50,
  INFO_YELLOW_60: INFO_YELLOW_60,
  INFO_YELLOW_70: INFO_YELLOW_70,
  INFO_YELLOW_80: INFO_YELLOW_80,
  INFO_YELLOW_90: INFO_YELLOW_90,
  INFO_YELLOW_95: INFO_YELLOW_95,
  NEWS_ORANGE_10: NEWS_ORANGE_10,
  NEWS_ORANGE_20: NEWS_ORANGE_20,
  NEWS_ORANGE_30: NEWS_ORANGE_30,
  NEWS_ORANGE_40: NEWS_ORANGE_40,
  NEWS_ORANGE_5: NEWS_ORANGE_5,
  NEWS_ORANGE_50: NEWS_ORANGE_50,
  NEWS_ORANGE_60: NEWS_ORANGE_60,
  NEWS_ORANGE_70: NEWS_ORANGE_70,
  NEWS_ORANGE_80: NEWS_ORANGE_80,
  NEWS_ORANGE_90: NEWS_ORANGE_90,
  NEWS_ORANGE_95: NEWS_ORANGE_95,
  NEWS_VIOLET_10: NEWS_VIOLET_10,
  NEWS_VIOLET_20: NEWS_VIOLET_20,
  NEWS_VIOLET_30: NEWS_VIOLET_30,
  NEWS_VIOLET_40: NEWS_VIOLET_40,
  NEWS_VIOLET_5: NEWS_VIOLET_5,
  NEWS_VIOLET_50: NEWS_VIOLET_50,
  NEWS_VIOLET_60: NEWS_VIOLET_60,
  NEWS_VIOLET_70: NEWS_VIOLET_70,
  NEWS_VIOLET_80: NEWS_VIOLET_80,
  NEWS_VIOLET_90: NEWS_VIOLET_90,
  NEWS_VIOLET_95: NEWS_VIOLET_95,
  ORANGE_10: ORANGE_10,
  ORANGE_20: ORANGE_20,
  ORANGE_30: ORANGE_30,
  ORANGE_40: ORANGE_40,
  ORANGE_5: ORANGE_5,
  ORANGE_50: ORANGE_50,
  ORANGE_60: ORANGE_60,
  ORANGE_70: ORANGE_70,
  ORANGE_80: ORANGE_80,
  ORANGE_90: ORANGE_90,
  PURPLE_10: PURPLE_10,
  PURPLE_20: PURPLE_20,
  PURPLE_30: PURPLE_30,
  PURPLE_40: PURPLE_40,
  PURPLE_5: PURPLE_5,
  PURPLE_50: PURPLE_50,
  PURPLE_60: PURPLE_60,
  PURPLE_70: PURPLE_70,
  PURPLE_80: PURPLE_80,
  PURPLE_90: PURPLE_90,
  RED_10: RED_10,
  RED_20: RED_20,
  RED_30: RED_30,
  RED_40: RED_40,
  RED_5: RED_5,
  RED_50: RED_50,
  RED_60: RED_60,
  RED_70: RED_70,
  RED_80: RED_80,
  RED_90: RED_90,
  SPORTS_LIME_10: SPORTS_LIME_10,
  SPORTS_LIME_20: SPORTS_LIME_20,
  SPORTS_LIME_30: SPORTS_LIME_30,
  SPORTS_LIME_40: SPORTS_LIME_40,
  SPORTS_LIME_5: SPORTS_LIME_5,
  SPORTS_LIME_50: SPORTS_LIME_50,
  SPORTS_LIME_60: SPORTS_LIME_60,
  SPORTS_LIME_70: SPORTS_LIME_70,
  SPORTS_LIME_80: SPORTS_LIME_80,
  SPORTS_LIME_90: SPORTS_LIME_90,
  SPORTS_LIME_95: SPORTS_LIME_95,
  SPORTS_PINK_10: SPORTS_PINK_10,
  SPORTS_PINK_20: SPORTS_PINK_20,
  SPORTS_PINK_30: SPORTS_PINK_30,
  SPORTS_PINK_40: SPORTS_PINK_40,
  SPORTS_PINK_5: SPORTS_PINK_5,
  SPORTS_PINK_50: SPORTS_PINK_50,
  SPORTS_PINK_60: SPORTS_PINK_60,
  SPORTS_PINK_70: SPORTS_PINK_70,
  SPORTS_PINK_80: SPORTS_PINK_80,
  SPORTS_PINK_90: SPORTS_PINK_90,
  SPORTS_PINK_95: SPORTS_PINK_95,
  SPORTS_VIOLET_10: SPORTS_VIOLET_10,
  SPORTS_VIOLET_20: SPORTS_VIOLET_20,
  SPORTS_VIOLET_30: SPORTS_VIOLET_30,
  SPORTS_VIOLET_40: SPORTS_VIOLET_40,
  SPORTS_VIOLET_5: SPORTS_VIOLET_5,
  SPORTS_VIOLET_50: SPORTS_VIOLET_50,
  SPORTS_VIOLET_60: SPORTS_VIOLET_60,
  SPORTS_VIOLET_70: SPORTS_VIOLET_70,
  SPORTS_VIOLET_80: SPORTS_VIOLET_80,
  SPORTS_VIOLET_90: SPORTS_VIOLET_90,
  SPORTS_VIOLET_95: SPORTS_VIOLET_95,
  TURQUOISE_10: TURQUOISE_10,
  TURQUOISE_20: TURQUOISE_20,
  TURQUOISE_30: TURQUOISE_30,
  TURQUOISE_40: TURQUOISE_40,
  TURQUOISE_5: TURQUOISE_5,
  TURQUOISE_50: TURQUOISE_50,
  TURQUOISE_60: TURQUOISE_60,
  TURQUOISE_70: TURQUOISE_70,
  TURQUOISE_80: TURQUOISE_80,
  TURQUOISE_90: TURQUOISE_90,
  TURQUOISE_95: TURQUOISE_95,
  WHITE: WHITE,
  WHITE_OPACITY_10: WHITE_OPACITY_10,
  WHITE_OPACITY_20: WHITE_OPACITY_20,
  WHITE_OPACITY_30: WHITE_OPACITY_30,
  WHITE_OPACITY_40: WHITE_OPACITY_40,
  WHITE_OPACITY_5: WHITE_OPACITY_5,
  WHITE_OPACITY_50: WHITE_OPACITY_50,
  WHITE_OPACITY_60: WHITE_OPACITY_60,
  WHITE_OPACITY_70: WHITE_OPACITY_70,
  WHITE_OPACITY_80: WHITE_OPACITY_80,
  WHITE_OPACITY_90: WHITE_OPACITY_90,
  WHITE_OPACITY_95: WHITE_OPACITY_95,
  YELLOW_10: YELLOW_10,
  YELLOW_20: YELLOW_20,
  YELLOW_30: YELLOW_30,
  YELLOW_40: YELLOW_40,
  YELLOW_5: YELLOW_5,
  YELLOW_50: YELLOW_50,
  YELLOW_60: YELLOW_60,
  YELLOW_70: YELLOW_70,
  YELLOW_80: YELLOW_80,
  YELLOW_90: YELLOW_90
});

/**
 * Yle Design System
 * v1.2.4
 */

const SHADOW_SM$2 = '0 0 8px 0 rgba(0, 0, 0, 0.70)';
const SHADOW_MD$2 = '0 0 16px 0 rgba(0, 0, 0, 0.70)';
const SHADOW_LG$2 = '0 0 24px 0 rgba(0, 0, 0, 0.87)';

var shadowDark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SHADOW_LG: SHADOW_LG$2,
  SHADOW_MD: SHADOW_MD$2,
  SHADOW_SM: SHADOW_SM$2
});

/**
 * Yle Design System
 * v1.2.4
 */

const SHADOW_SM$1 = '0 0 8px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_MD$1 = '0 0 16px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_LG$1 = '0 0 24px 0 rgba(0, 0, 0, 0.41)';

var shadowDefault = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SHADOW_LG: SHADOW_LG$1,
  SHADOW_MD: SHADOW_MD$1,
  SHADOW_SM: SHADOW_SM$1
});

/**
 * Yle Design System
 * v1.2.4
 */

const SHADOW_SM = '0 0 8px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_MD = '0 0 16px 0 rgba(0, 0, 0, 0.15)';
const SHADOW_LG = '0 0 24px 0 rgba(0, 0, 0, 0.41)';

var shadowLight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SHADOW_LG: SHADOW_LG,
  SHADOW_MD: SHADOW_MD,
  SHADOW_SM: SHADOW_SM
});

/**
 * Yle Design System
 * v1.2.4
 */

const SPACING_2 = '2px';
const SPACING_4 = '4px';
const SPACING_8 = '8px';
const SPACING_12 = '12px';
const SPACING_16 = '16px';
const SPACING_24 = '24px';
const SPACING_32 = '32px';
const SPACING_40 = '40px';
const SPACING_48 = '48px';
const SPACING_56 = '56px';
const SPACING_64 = '64px';
const SPACING_72 = '72px';

var spacing = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SPACING_12: SPACING_12,
  SPACING_16: SPACING_16,
  SPACING_2: SPACING_2,
  SPACING_24: SPACING_24,
  SPACING_32: SPACING_32,
  SPACING_4: SPACING_4,
  SPACING_40: SPACING_40,
  SPACING_48: SPACING_48,
  SPACING_56: SPACING_56,
  SPACING_64: SPACING_64,
  SPACING_72: SPACING_72,
  SPACING_8: SPACING_8
});

/**
 * Yle Design System
 * v1.2.4
 */

const BACKGROUND$5 = '#131415'; // gray-95
const BACKGROUND_VARIANT$2 = '#1f2123'; // gray-90
const BACKGROUND_NEGATIVE$2 = '#ffffff'; // white
const BACKGROUND_NAVIGATION$2 = '#000000'; // black
const BACKGROUND_CONTROL$2 = 'rgba(255, 255, 255, 0.59)'; // white-opacity-50
const BACKGROUND_CONTROL_DISABLED$2 = 'rgba(255, 255, 255, 0.21)'; // white-opacity-30
const BACKGROUND_INPUT$2 = '#131415'; // gray-95
const BACKGROUND_HIGHLIGHT$2 = '#0b3f4b'; // turquoise-95
const BACKGROUND_INTERACTIVE$2 = '#292b2d'; // gray-80
const BACKGROUND_DIALOG$2 = '#1f2123'; // gray-90
const BACKGROUND_DIALOG_OVERLAY$2 = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const BACKGROUND_INFO_PRIMARY$2 = '#d8d9db'; // gray-30
const BACKGROUND_INFO_SECONDARY$2 = '#292b2d'; // gray-80
const BACKGROUND_SUCCESS$2 = '#33d59b'; // info-green-40
const BACKGROUND_WARNING$2 = '#feb054'; // info-orange-40
const BACKGROUND_ERROR$2 = '#f5517a'; // red-40
const BACKGROUND_OPINION_ARTICLE$2 = '#3d5483'; // info-deep-blue-60
const TEXT_DEFAULT$5 = '#f8f9fa'; // gray-5
const TEXT_NEGATIVE$5 = '#131415'; // gray-95
const TEXT_INPUT_PLACEHOLDER$2 = '#949697'; // gray-50
const TEXT_HIGH_EMPHASIS$2 = 'rgba(255, 255, 255, 0.85)'; // white-opacity-70
const TEXT_MEDIUM_EMPHASIS$2 = 'rgba(255, 255, 255, 0.71)'; // white-opacity-60
const TEXT_DISABLED$2 = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const TEXT_LIGHT$5 = '#f8f9fa'; // gray-5
const TEXT_DARK$5 = '#131415'; // gray-95
const ACTION_PRIMARY$2 = '#f8f9fa'; // gray-5
const ACTION_PRIMARY_VARIANT$2 = 'rgba(255, 255, 255, 0.71)'; // white-opacity-60
const ACTION_SECONDARY$2 = 'rgba(255, 255, 255, 0.08)'; // white-opacity-5
const ACTION_SECONDARY_VARIANT$2 = 'rgba(255, 255, 255, 0.17)'; // white-opacity-20
const ACTION_DISABLED$2 = 'rgba(255, 255, 255, 0.21)'; // white-opacity-30
const BORDER$2 = '#f8f9fa'; // gray-5
const BORDER_DISABLED$2 = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const BORDER_PRIMARY_FOCUS$2 = '#29ccde'; // turquoise-40
const BORDER_SECONDARY_FOCUS$2 = '#f8f9fa'; // gray-5
const BORDER_SEPARATOR$2 = '#4a4f54'; // gray-60
const ILLUSTRATIVE_ICONS_ICON_PRIMARY$2 = '#f8f9fa'; // gray-5
const ILLUSTRATIVE_ICONS_ICON_SECONDARY$2 = '#009cb5'; // turquoise-60
const PLAYER_PROGRESS_BAR$2 = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const PLAYER_PROGRESS_INDICATOR$2 = '#29ccde'; // turquoise-40
const SPINNER_DEFAULT$2 = '#ffffff'; // white
const SPINNER_NEGATIVE$2 = '#131415'; // gray-95
const SPINNER_HIGHLIGHT_DEFAULT$2 = '#29ccde'; // turquoise-40
const SPINNER_HIGHLIGHT_NEGATIVE$2 = '#009cb5'; // turquoise-60
const SPINNER_BACKGROUND_DEFAULT$2 = '#292b2d'; // gray-80
const SPINNER_BACKGROUND_NEGATIVE$2 = '#d8d9db'; // gray-30
const FEEDBACK_HIGHLIGHT$2 = '#29ccde'; // turquoise-40
const FEEDBACK_ERROR$2 = '#f5517a'; // red-40
const FEEDBACK_WARNING$2 = '#ff9c31'; // orange-40
const FEEDBACK_SUCCESS$2 = '#03e592'; // green-40
const FEEDBACK_LIVE$2 = '#e90e43'; // red-50
const LOGO_YLE$2 = '#f8f9fa'; // gray-5
const LOGO_TV1$2 = '#008ac7'; // yle-tv-1
const LOGO_TV_2$2 = '#cb0fd0'; // yle-tv-2
const LOGO_YLE_TEEMA$2 = '#fe8300'; // yle-teema
const LOGO_YLE_FEM$2 = '#a3bd2f'; // yle-fem
const LOGO_LASTENAREENA$2 = '#feb500'; // lastenareena
const LOGO_YLE_RADIO_1$2 = '#dc006a'; // yle-radio-1
const LOGO_YLE_RADIO_SUOMI$2 = '#00b9eb'; // yle-radio-suomi-2
const LOGO_YLE_X$2 = '#fd2b77'; // yle-x
const LOGO_YLE_X3M$2 = '#ff4c20'; // yle-x3m
const LOGO_YLE_VEGA$2 = '#169bd4'; // yle-vega
const LOGO_YLE_KLASSINEN$2 = '#0f7b87'; // yle-klassinen
const LOGO_YLE_SAMI_RADIO$2 = '#0049bf'; // yle-sami-radio
const LOGO_AREENA$2 = '#29ccde'; // turquoise-40
const BRAND_YLE$2 = '#00b4c8'; // turquoise-50
const TAG_LIVE$2 = '#e90e43'; // red-50
const TAG_DEFAULT$2 = '#ffffff'; // white
const TAG_OPINION$2 = '#3d5483'; // info-deep-blue-60
const TAG_YLE_CORPORATE$2 = '#00809c'; // turquoise-70
const TAG_PRIMARY_ACTION$2 = '#f8f9fa'; // gray-5
const TAG_PRIMARY_ACTION_VARIANT$2 = 'rgba(255, 255, 255, 0.71)'; // white-opacity-60
const TAG_SECONDARY_ACTION$2 = 'rgba(255, 255, 255, 0.13)'; // white-opacity-10
const TAG_SECONDARY_ACTION_VARIANT$2 = 'rgba(255, 255, 255, 0.08)'; // white-opacity-5

var themeDark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DISABLED: ACTION_DISABLED$2,
  ACTION_PRIMARY: ACTION_PRIMARY$2,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT$2,
  ACTION_SECONDARY: ACTION_SECONDARY$2,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT$2,
  BACKGROUND: BACKGROUND$5,
  BACKGROUND_CONTROL: BACKGROUND_CONTROL$2,
  BACKGROUND_CONTROL_DISABLED: BACKGROUND_CONTROL_DISABLED$2,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG$2,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY$2,
  BACKGROUND_ERROR: BACKGROUND_ERROR$2,
  BACKGROUND_HIGHLIGHT: BACKGROUND_HIGHLIGHT$2,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY$2,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY$2,
  BACKGROUND_INPUT: BACKGROUND_INPUT$2,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE$2,
  BACKGROUND_NAVIGATION: BACKGROUND_NAVIGATION$2,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE$2,
  BACKGROUND_OPINION_ARTICLE: BACKGROUND_OPINION_ARTICLE$2,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS$2,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT$2,
  BACKGROUND_WARNING: BACKGROUND_WARNING$2,
  BORDER: BORDER$2,
  BORDER_DISABLED: BORDER_DISABLED$2,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS$2,
  BORDER_SECONDARY_FOCUS: BORDER_SECONDARY_FOCUS$2,
  BORDER_SEPARATOR: BORDER_SEPARATOR$2,
  BRAND_YLE: BRAND_YLE$2,
  FEEDBACK_ERROR: FEEDBACK_ERROR$2,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT$2,
  FEEDBACK_LIVE: FEEDBACK_LIVE$2,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS$2,
  FEEDBACK_WARNING: FEEDBACK_WARNING$2,
  ILLUSTRATIVE_ICONS_ICON_PRIMARY: ILLUSTRATIVE_ICONS_ICON_PRIMARY$2,
  ILLUSTRATIVE_ICONS_ICON_SECONDARY: ILLUSTRATIVE_ICONS_ICON_SECONDARY$2,
  LOGO_AREENA: LOGO_AREENA$2,
  LOGO_LASTENAREENA: LOGO_LASTENAREENA$2,
  LOGO_TV1: LOGO_TV1$2,
  LOGO_TV_2: LOGO_TV_2$2,
  LOGO_YLE: LOGO_YLE$2,
  LOGO_YLE_FEM: LOGO_YLE_FEM$2,
  LOGO_YLE_KLASSINEN: LOGO_YLE_KLASSINEN$2,
  LOGO_YLE_RADIO_1: LOGO_YLE_RADIO_1$2,
  LOGO_YLE_RADIO_SUOMI: LOGO_YLE_RADIO_SUOMI$2,
  LOGO_YLE_SAMI_RADIO: LOGO_YLE_SAMI_RADIO$2,
  LOGO_YLE_TEEMA: LOGO_YLE_TEEMA$2,
  LOGO_YLE_VEGA: LOGO_YLE_VEGA$2,
  LOGO_YLE_X: LOGO_YLE_X$2,
  LOGO_YLE_X3M: LOGO_YLE_X3M$2,
  PLAYER_PROGRESS_BAR: PLAYER_PROGRESS_BAR$2,
  PLAYER_PROGRESS_INDICATOR: PLAYER_PROGRESS_INDICATOR$2,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT$2,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE$2,
  SPINNER_DEFAULT: SPINNER_DEFAULT$2,
  SPINNER_HIGHLIGHT_DEFAULT: SPINNER_HIGHLIGHT_DEFAULT$2,
  SPINNER_HIGHLIGHT_NEGATIVE: SPINNER_HIGHLIGHT_NEGATIVE$2,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE$2,
  TAG_DEFAULT: TAG_DEFAULT$2,
  TAG_LIVE: TAG_LIVE$2,
  TAG_OPINION: TAG_OPINION$2,
  TAG_PRIMARY_ACTION: TAG_PRIMARY_ACTION$2,
  TAG_PRIMARY_ACTION_VARIANT: TAG_PRIMARY_ACTION_VARIANT$2,
  TAG_SECONDARY_ACTION: TAG_SECONDARY_ACTION$2,
  TAG_SECONDARY_ACTION_VARIANT: TAG_SECONDARY_ACTION_VARIANT$2,
  TAG_YLE_CORPORATE: TAG_YLE_CORPORATE$2,
  TEXT_DARK: TEXT_DARK$5,
  TEXT_DEFAULT: TEXT_DEFAULT$5,
  TEXT_DISABLED: TEXT_DISABLED$2,
  TEXT_HIGH_EMPHASIS: TEXT_HIGH_EMPHASIS$2,
  TEXT_INPUT_PLACEHOLDER: TEXT_INPUT_PLACEHOLDER$2,
  TEXT_LIGHT: TEXT_LIGHT$5,
  TEXT_MEDIUM_EMPHASIS: TEXT_MEDIUM_EMPHASIS$2,
  TEXT_NEGATIVE: TEXT_NEGATIVE$5
});

/**
 * Yle Design System
 * v1.2.4
 */

const BACKGROUND$4 = 'var(--yds-color-background, #ffffff)'; // white
const BACKGROUND_VARIANT$1 = 'var(--yds-color-background-variant, #f8f9fa)'; // gray-5
const BACKGROUND_NEGATIVE$1 = 'var(--yds-color-background-negative, #131415)'; // gray-95
const BACKGROUND_NAVIGATION$1 = 'var(--yds-color-background-navigation, #ffffff)'; // white
const BACKGROUND_CONTROL$1 = 'var(--yds-color-background-control, rgba(0, 0, 0, 0.41))'; // black-opacity-50
const BACKGROUND_CONTROL_DISABLED$1 =
  'var(--yds-color-background-control-disabled, rgba(0, 0, 0, 0.15))'; // black-opacity-30
const BACKGROUND_INPUT$1 = 'var(--yds-color-background-input, #ffffff)'; // white
const BACKGROUND_HIGHLIGHT$1 = 'var(--yds-color-background-highlight, #e8e9eb)'; // gray-20
const BACKGROUND_INTERACTIVE$1 = 'var(--yds-color-background-interactive, #f1f2f4)'; // gray-10
const BACKGROUND_DIALOG$1 = 'var(--yds-color-background-dialog, #ffffff)'; // white
const BACKGROUND_DIALOG_OVERLAY$1 =
  'var(--yds-color-background-dialog-overlay, rgba(0, 0, 0, 0.41))'; // black-opacity-50
const BACKGROUND_INFO_PRIMARY$1 = 'var(--yds-color-background-info-primary, #9fc8ee)'; // blue-20
const BACKGROUND_INFO_SECONDARY$1 = 'var(--yds-color-background-info-secondary, #f1f2f4)'; // gray-10
const BACKGROUND_SUCCESS$1 = 'var(--yds-color-background-success, #62f9c2)'; // green-20
const BACKGROUND_WARNING$1 = 'var(--yds-color-background-warning, #ffd199)'; // info-orange-20
const BACKGROUND_ERROR$1 = 'var(--yds-color-background-error, #f99fb5)'; // red-20
const BACKGROUND_OPINION_ARTICLE$1 = 'var(--yds-color-background-opinion-article, #3d5483)'; // info-deep-blue-60
const TEXT_DEFAULT$4 = 'var(--yds-color-text-default, #131415)'; // gray-95
const TEXT_NEGATIVE$4 = 'var(--yds-color-text-negative, #f8f9fa)'; // gray-5
const TEXT_INPUT_PLACEHOLDER$1 = 'var(--yds-color-text-input-placeholder, #4a4f54)'; // gray-60
const TEXT_HIGH_EMPHASIS$1 = 'var(--yds-color-text-high-emphasis, rgba(0, 0, 0, 0.79))'; // black-opacity-70
const TEXT_MEDIUM_EMPHASIS$1 = 'var(--yds-color-text-medium-emphasis, rgba(0, 0, 0, 0.7))'; // black-opacity-60
const TEXT_DISABLED$1 = 'var(--yds-color-text-disabled, rgba(0, 0, 0, 0.29))'; // black-opacity-40
const TEXT_LIGHT$4 = 'var(--yds-color-text-light, #f8f9fa)'; // gray-5
const TEXT_DARK$4 = 'var(--yds-color-text-dark, #131415)'; // gray-95
const ACTION_PRIMARY$1 = 'var(--yds-color-action-primary, #131415)'; // gray-95
const ACTION_PRIMARY_VARIANT$1 = 'var(--yds-color-action-primary-variant, rgba(0, 0, 0, 0.7))'; // black-opacity-60
const ACTION_SECONDARY$1 = 'var(--yds-color-action-secondary, rgba(0, 0, 0, 0.05))'; // black-opacity-10
const ACTION_SECONDARY_VARIANT$1 =
  'var(--yds-color-action-secondary-variant, rgba(0, 0, 0, 0.09))'; // black-opacity-20
const ACTION_DISABLED$1 = 'var(--yds-color-action-disabled, rgba(0, 0, 0, 0.15))'; // black-opacity-30
const BORDER$1 = 'var(--yds-color-border, #131415)'; // gray-95
const BORDER_DISABLED$1 = 'var(--yds-color-border-disabled, rgba(0, 0, 0, 0.29))'; // black-opacity-40
const BORDER_PRIMARY_FOCUS$1 = 'var(--yds-color-border-primary-focus, #009cb5)'; // turquoise-60
const BORDER_SECONDARY_FOCUS$1 = 'var(--yds-color-border-secondary-focus, #131415)'; // gray-95
const BORDER_SEPARATOR$1 = 'var(--yds-color-border-separator, #e8e9eb)'; // gray-20
const ILLUSTRATIVE_ICONS_ICON_PRIMARY$1 =
  'var(--yds-color-illustrative-icons-icon-primary, #131415)'; // gray-95
const ILLUSTRATIVE_ICONS_ICON_SECONDARY$1 =
  'var(--yds-color-illustrative-icons-icon-secondary, #5ddbe9)'; // turquoise-30
const PLAYER_PROGRESS_BAR$1 = 'var(--yds-color-player-progress-bar, rgba(255, 255, 255, 0.3))'; // white-opacity-40
const PLAYER_PROGRESS_INDICATOR$1 = 'var(--yds-color-player-progress-indicator, #29ccde)'; // turquoise-40
const SPINNER_DEFAULT$1 = 'var(--yds-color-spinner-default, #131415)'; // gray-95
const SPINNER_NEGATIVE$1 = 'var(--yds-color-spinner-negative, #ffffff)'; // white
const SPINNER_HIGHLIGHT_DEFAULT$1 = 'var(--yds-color-spinner-highlight-default, #009cb5)'; // turquoise-60
const SPINNER_HIGHLIGHT_NEGATIVE$1 = 'var(--yds-color-spinner-highlight-negative, #29ccde)'; // turquoise-40
const SPINNER_BACKGROUND_DEFAULT$1 = 'var(--yds-color-spinner-background-default, #d8d9db)'; // gray-30
const SPINNER_BACKGROUND_NEGATIVE$1 = 'var(--yds-color-spinner-background-negative, #292b2d)'; // gray-80
const FEEDBACK_HIGHLIGHT$1 = 'var(--yds-color-feedback-highlight, #009cb5)'; // turquoise-60
const FEEDBACK_ERROR$1 = 'var(--yds-color-feedback-error, #d10b3d)'; // red-60
const FEEDBACK_WARNING$1 = 'var(--yds-color-feedback-warning, #f1722a)'; // orange-60
const FEEDBACK_SUCCESS$1 = 'var(--yds-color-feedback-success, #058657)'; // green-70
const FEEDBACK_LIVE$1 = 'var(--yds-color-feedback-live, #e90e43)'; // red-50
const LOGO_YLE$1 = 'var(--yds-color-logo-yle, #00b4c8)'; // turquoise-50
const LOGO_TV1$1 = 'var(--yds-color-logo-tv1, #008ac7)'; // yle-tv-1
const LOGO_TV_2$1 = 'var(--yds-color-logo-tv-2, #cb0fd0)'; // yle-tv-2
const LOGO_YLE_TEEMA$1 = 'var(--yds-color-logo-yle-teema, #fe8300)'; // yle-teema
const LOGO_YLE_FEM$1 = 'var(--yds-color-logo-yle-fem, #a3bd2f)'; // yle-fem
const LOGO_LASTENAREENA$1 = 'var(--yds-color-logo-lastenareena, #feb500)'; // lastenareena
const LOGO_YLE_RADIO_1$1 = 'var(--yds-color-logo-yle-radio-1, #dc006a)'; // yle-radio-1
const LOGO_YLE_RADIO_SUOMI$1 = 'var(--yds-color-logo-yle-radio-suomi, #0000e6)'; // yle-radio-suomi
const LOGO_YLE_X$1 = 'var(--yds-color-logo-yle-x, #fd2b77)'; // yle-x
const LOGO_YLE_X3M$1 = 'var(--yds-color-logo-yle-x3-m, #ff4c20)'; // yle-x3m
const LOGO_YLE_VEGA$1 = 'var(--yds-color-logo-yle-vega, #169bd4)'; // yle-vega
const LOGO_YLE_KLASSINEN$1 = 'var(--yds-color-logo-yle-klassinen, #0f7b87)'; // yle-klassinen
const LOGO_YLE_SAMI_RADIO$1 = 'var(--yds-color-logo-yle-sami-radio, #0049bf)'; // yle-sami-radio
const LOGO_AREENA$1 = 'var(--yds-color-logo-areena, #29ccde)'; // turquoise-40
const BRAND_YLE$1 = 'var(--yds-color-brand-yle, #00b4c8)'; // turquoise-50
const TAG_LIVE$1 = 'var(--yds-color-tag-live, #e90e43)'; // red-50
const TAG_DEFAULT$1 = 'var(--yds-color-tag-default, #131415)'; // gray-95
const TAG_OPINION$1 = 'var(--yds-color-tag-opinion, #3d5483)'; // info-deep-blue-60
const TAG_YLE_CORPORATE$1 = 'var(--yds-color-tag-yle-corporate, #00809c)'; // turquoise-70
const TAG_PRIMARY_ACTION$1 = 'var(--yds-color-tag-primary-action, #131415)'; // gray-95
const TAG_PRIMARY_ACTION_VARIANT$1 =
  'var(--yds-color-tag-primary-action-variant, rgba(0, 0, 0, 0.7))'; // black-opacity-60
const TAG_SECONDARY_ACTION$1 = 'var(--yds-color-tag-secondary-action, rgba(0, 0, 0, 0.05))'; // black-opacity-10
const TAG_SECONDARY_ACTION_VARIANT$1 =
  'var(--yds-color-tag-secondary-action-variant, rgba(0, 0, 0, 0.02))'; // black-opacity-5

var themeDefault = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DISABLED: ACTION_DISABLED$1,
  ACTION_PRIMARY: ACTION_PRIMARY$1,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT$1,
  ACTION_SECONDARY: ACTION_SECONDARY$1,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT$1,
  BACKGROUND: BACKGROUND$4,
  BACKGROUND_CONTROL: BACKGROUND_CONTROL$1,
  BACKGROUND_CONTROL_DISABLED: BACKGROUND_CONTROL_DISABLED$1,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG$1,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY$1,
  BACKGROUND_ERROR: BACKGROUND_ERROR$1,
  BACKGROUND_HIGHLIGHT: BACKGROUND_HIGHLIGHT$1,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY$1,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY$1,
  BACKGROUND_INPUT: BACKGROUND_INPUT$1,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE$1,
  BACKGROUND_NAVIGATION: BACKGROUND_NAVIGATION$1,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE$1,
  BACKGROUND_OPINION_ARTICLE: BACKGROUND_OPINION_ARTICLE$1,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS$1,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT$1,
  BACKGROUND_WARNING: BACKGROUND_WARNING$1,
  BORDER: BORDER$1,
  BORDER_DISABLED: BORDER_DISABLED$1,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS$1,
  BORDER_SECONDARY_FOCUS: BORDER_SECONDARY_FOCUS$1,
  BORDER_SEPARATOR: BORDER_SEPARATOR$1,
  BRAND_YLE: BRAND_YLE$1,
  FEEDBACK_ERROR: FEEDBACK_ERROR$1,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT$1,
  FEEDBACK_LIVE: FEEDBACK_LIVE$1,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS$1,
  FEEDBACK_WARNING: FEEDBACK_WARNING$1,
  ILLUSTRATIVE_ICONS_ICON_PRIMARY: ILLUSTRATIVE_ICONS_ICON_PRIMARY$1,
  ILLUSTRATIVE_ICONS_ICON_SECONDARY: ILLUSTRATIVE_ICONS_ICON_SECONDARY$1,
  LOGO_AREENA: LOGO_AREENA$1,
  LOGO_LASTENAREENA: LOGO_LASTENAREENA$1,
  LOGO_TV1: LOGO_TV1$1,
  LOGO_TV_2: LOGO_TV_2$1,
  LOGO_YLE: LOGO_YLE$1,
  LOGO_YLE_FEM: LOGO_YLE_FEM$1,
  LOGO_YLE_KLASSINEN: LOGO_YLE_KLASSINEN$1,
  LOGO_YLE_RADIO_1: LOGO_YLE_RADIO_1$1,
  LOGO_YLE_RADIO_SUOMI: LOGO_YLE_RADIO_SUOMI$1,
  LOGO_YLE_SAMI_RADIO: LOGO_YLE_SAMI_RADIO$1,
  LOGO_YLE_TEEMA: LOGO_YLE_TEEMA$1,
  LOGO_YLE_VEGA: LOGO_YLE_VEGA$1,
  LOGO_YLE_X: LOGO_YLE_X$1,
  LOGO_YLE_X3M: LOGO_YLE_X3M$1,
  PLAYER_PROGRESS_BAR: PLAYER_PROGRESS_BAR$1,
  PLAYER_PROGRESS_INDICATOR: PLAYER_PROGRESS_INDICATOR$1,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT$1,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE$1,
  SPINNER_DEFAULT: SPINNER_DEFAULT$1,
  SPINNER_HIGHLIGHT_DEFAULT: SPINNER_HIGHLIGHT_DEFAULT$1,
  SPINNER_HIGHLIGHT_NEGATIVE: SPINNER_HIGHLIGHT_NEGATIVE$1,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE$1,
  TAG_DEFAULT: TAG_DEFAULT$1,
  TAG_LIVE: TAG_LIVE$1,
  TAG_OPINION: TAG_OPINION$1,
  TAG_PRIMARY_ACTION: TAG_PRIMARY_ACTION$1,
  TAG_PRIMARY_ACTION_VARIANT: TAG_PRIMARY_ACTION_VARIANT$1,
  TAG_SECONDARY_ACTION: TAG_SECONDARY_ACTION$1,
  TAG_SECONDARY_ACTION_VARIANT: TAG_SECONDARY_ACTION_VARIANT$1,
  TAG_YLE_CORPORATE: TAG_YLE_CORPORATE$1,
  TEXT_DARK: TEXT_DARK$4,
  TEXT_DEFAULT: TEXT_DEFAULT$4,
  TEXT_DISABLED: TEXT_DISABLED$1,
  TEXT_HIGH_EMPHASIS: TEXT_HIGH_EMPHASIS$1,
  TEXT_INPUT_PLACEHOLDER: TEXT_INPUT_PLACEHOLDER$1,
  TEXT_LIGHT: TEXT_LIGHT$4,
  TEXT_MEDIUM_EMPHASIS: TEXT_MEDIUM_EMPHASIS$1,
  TEXT_NEGATIVE: TEXT_NEGATIVE$4
});

/**
 * Yle Design System
 * v1.2.4
 */

const BACKGROUND$3 = '#ffffff'; // white
const BACKGROUND_VARIANT = '#f8f9fa'; // gray-5
const BACKGROUND_NEGATIVE = '#131415'; // gray-95
const BACKGROUND_NAVIGATION = '#ffffff'; // white
const BACKGROUND_CONTROL = 'rgba(0, 0, 0, 0.41)'; // black-opacity-50
const BACKGROUND_CONTROL_DISABLED = 'rgba(0, 0, 0, 0.15)'; // black-opacity-30
const BACKGROUND_INPUT = '#ffffff'; // white
const BACKGROUND_HIGHLIGHT = '#e8e9eb'; // gray-20
const BACKGROUND_INTERACTIVE = '#f1f2f4'; // gray-10
const BACKGROUND_DIALOG = '#ffffff'; // white
const BACKGROUND_DIALOG_OVERLAY = 'rgba(0, 0, 0, 0.41)'; // black-opacity-50
const BACKGROUND_INFO_PRIMARY = '#9fc8ee'; // blue-20
const BACKGROUND_INFO_SECONDARY = '#f1f2f4'; // gray-10
const BACKGROUND_SUCCESS = '#62f9c2'; // green-20
const BACKGROUND_WARNING = '#ffd199'; // info-orange-20
const BACKGROUND_ERROR = '#f99fb5'; // red-20
const BACKGROUND_OPINION_ARTICLE = '#3d5483'; // info-deep-blue-60
const TEXT_DEFAULT$3 = '#131415'; // gray-95
const TEXT_NEGATIVE$3 = '#f8f9fa'; // gray-5
const TEXT_INPUT_PLACEHOLDER = '#4a4f54'; // gray-60
const TEXT_HIGH_EMPHASIS = 'rgba(0, 0, 0, 0.79)'; // black-opacity-70
const TEXT_MEDIUM_EMPHASIS = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const TEXT_DISABLED = 'rgba(0, 0, 0, 0.29)'; // black-opacity-40
const TEXT_LIGHT$3 = '#f8f9fa'; // gray-5
const TEXT_DARK$3 = '#131415'; // gray-95
const ACTION_PRIMARY = '#131415'; // gray-95
const ACTION_PRIMARY_VARIANT = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const ACTION_SECONDARY = 'rgba(0, 0, 0, 0.05)'; // black-opacity-10
const ACTION_SECONDARY_VARIANT = 'rgba(0, 0, 0, 0.09)'; // black-opacity-20
const ACTION_DISABLED = 'rgba(0, 0, 0, 0.15)'; // black-opacity-30
const BORDER = '#131415'; // gray-95
const BORDER_DISABLED = 'rgba(0, 0, 0, 0.29)'; // black-opacity-40
const BORDER_PRIMARY_FOCUS = '#009cb5'; // turquoise-60
const BORDER_SECONDARY_FOCUS = '#131415'; // gray-95
const BORDER_SEPARATOR = '#e8e9eb'; // gray-20
const ILLUSTRATIVE_ICONS_ICON_PRIMARY = '#131415'; // gray-95
const ILLUSTRATIVE_ICONS_ICON_SECONDARY = '#5ddbe9'; // turquoise-30
const PLAYER_PROGRESS_BAR = 'rgba(255, 255, 255, 0.3)'; // white-opacity-40
const PLAYER_PROGRESS_INDICATOR = '#29ccde'; // turquoise-40
const SPINNER_DEFAULT = '#131415'; // gray-95
const SPINNER_NEGATIVE = '#ffffff'; // white
const SPINNER_HIGHLIGHT_DEFAULT = '#009cb5'; // turquoise-60
const SPINNER_HIGHLIGHT_NEGATIVE = '#29ccde'; // turquoise-40
const SPINNER_BACKGROUND_DEFAULT = '#d8d9db'; // gray-30
const SPINNER_BACKGROUND_NEGATIVE = '#292b2d'; // gray-80
const FEEDBACK_HIGHLIGHT = '#009cb5'; // turquoise-60
const FEEDBACK_ERROR = '#d10b3d'; // red-60
const FEEDBACK_WARNING = '#f1722a'; // orange-60
const FEEDBACK_SUCCESS = '#058657'; // green-70
const FEEDBACK_LIVE = '#e90e43'; // red-50
const LOGO_YLE = '#00b4c8'; // turquoise-50
const LOGO_TV1 = '#008ac7'; // yle-tv-1
const LOGO_TV_2 = '#cb0fd0'; // yle-tv-2
const LOGO_YLE_TEEMA = '#fe8300'; // yle-teema
const LOGO_YLE_FEM = '#a3bd2f'; // yle-fem
const LOGO_LASTENAREENA = '#feb500'; // lastenareena
const LOGO_YLE_RADIO_1 = '#dc006a'; // yle-radio-1
const LOGO_YLE_RADIO_SUOMI = '#0000e6'; // yle-radio-suomi
const LOGO_YLE_X = '#fd2b77'; // yle-x
const LOGO_YLE_X3M = '#ff4c20'; // yle-x3m
const LOGO_YLE_VEGA = '#169bd4'; // yle-vega
const LOGO_YLE_KLASSINEN = '#0f7b87'; // yle-klassinen
const LOGO_YLE_SAMI_RADIO = '#0049bf'; // yle-sami-radio
const LOGO_AREENA = '#29ccde'; // turquoise-40
const BRAND_YLE = '#00b4c8'; // turquoise-50
const TAG_LIVE = '#e90e43'; // red-50
const TAG_DEFAULT = '#131415'; // gray-95
const TAG_OPINION = '#3d5483'; // info-deep-blue-60
const TAG_YLE_CORPORATE = '#00809c'; // turquoise-70
const TAG_PRIMARY_ACTION = '#131415'; // gray-95
const TAG_PRIMARY_ACTION_VARIANT = 'rgba(0, 0, 0, 0.7)'; // black-opacity-60
const TAG_SECONDARY_ACTION = 'rgba(0, 0, 0, 0.05)'; // black-opacity-10
const TAG_SECONDARY_ACTION_VARIANT = 'rgba(0, 0, 0, 0.02)'; // black-opacity-5

var themeLight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACTION_DISABLED: ACTION_DISABLED,
  ACTION_PRIMARY: ACTION_PRIMARY,
  ACTION_PRIMARY_VARIANT: ACTION_PRIMARY_VARIANT,
  ACTION_SECONDARY: ACTION_SECONDARY,
  ACTION_SECONDARY_VARIANT: ACTION_SECONDARY_VARIANT,
  BACKGROUND: BACKGROUND$3,
  BACKGROUND_CONTROL: BACKGROUND_CONTROL,
  BACKGROUND_CONTROL_DISABLED: BACKGROUND_CONTROL_DISABLED,
  BACKGROUND_DIALOG: BACKGROUND_DIALOG,
  BACKGROUND_DIALOG_OVERLAY: BACKGROUND_DIALOG_OVERLAY,
  BACKGROUND_ERROR: BACKGROUND_ERROR,
  BACKGROUND_HIGHLIGHT: BACKGROUND_HIGHLIGHT,
  BACKGROUND_INFO_PRIMARY: BACKGROUND_INFO_PRIMARY,
  BACKGROUND_INFO_SECONDARY: BACKGROUND_INFO_SECONDARY,
  BACKGROUND_INPUT: BACKGROUND_INPUT,
  BACKGROUND_INTERACTIVE: BACKGROUND_INTERACTIVE,
  BACKGROUND_NAVIGATION: BACKGROUND_NAVIGATION,
  BACKGROUND_NEGATIVE: BACKGROUND_NEGATIVE,
  BACKGROUND_OPINION_ARTICLE: BACKGROUND_OPINION_ARTICLE,
  BACKGROUND_SUCCESS: BACKGROUND_SUCCESS,
  BACKGROUND_VARIANT: BACKGROUND_VARIANT,
  BACKGROUND_WARNING: BACKGROUND_WARNING,
  BORDER: BORDER,
  BORDER_DISABLED: BORDER_DISABLED,
  BORDER_PRIMARY_FOCUS: BORDER_PRIMARY_FOCUS,
  BORDER_SECONDARY_FOCUS: BORDER_SECONDARY_FOCUS,
  BORDER_SEPARATOR: BORDER_SEPARATOR,
  BRAND_YLE: BRAND_YLE,
  FEEDBACK_ERROR: FEEDBACK_ERROR,
  FEEDBACK_HIGHLIGHT: FEEDBACK_HIGHLIGHT,
  FEEDBACK_LIVE: FEEDBACK_LIVE,
  FEEDBACK_SUCCESS: FEEDBACK_SUCCESS,
  FEEDBACK_WARNING: FEEDBACK_WARNING,
  ILLUSTRATIVE_ICONS_ICON_PRIMARY: ILLUSTRATIVE_ICONS_ICON_PRIMARY,
  ILLUSTRATIVE_ICONS_ICON_SECONDARY: ILLUSTRATIVE_ICONS_ICON_SECONDARY,
  LOGO_AREENA: LOGO_AREENA,
  LOGO_LASTENAREENA: LOGO_LASTENAREENA,
  LOGO_TV1: LOGO_TV1,
  LOGO_TV_2: LOGO_TV_2,
  LOGO_YLE: LOGO_YLE,
  LOGO_YLE_FEM: LOGO_YLE_FEM,
  LOGO_YLE_KLASSINEN: LOGO_YLE_KLASSINEN,
  LOGO_YLE_RADIO_1: LOGO_YLE_RADIO_1,
  LOGO_YLE_RADIO_SUOMI: LOGO_YLE_RADIO_SUOMI,
  LOGO_YLE_SAMI_RADIO: LOGO_YLE_SAMI_RADIO,
  LOGO_YLE_TEEMA: LOGO_YLE_TEEMA,
  LOGO_YLE_VEGA: LOGO_YLE_VEGA,
  LOGO_YLE_X: LOGO_YLE_X,
  LOGO_YLE_X3M: LOGO_YLE_X3M,
  PLAYER_PROGRESS_BAR: PLAYER_PROGRESS_BAR,
  PLAYER_PROGRESS_INDICATOR: PLAYER_PROGRESS_INDICATOR,
  SPINNER_BACKGROUND_DEFAULT: SPINNER_BACKGROUND_DEFAULT,
  SPINNER_BACKGROUND_NEGATIVE: SPINNER_BACKGROUND_NEGATIVE,
  SPINNER_DEFAULT: SPINNER_DEFAULT,
  SPINNER_HIGHLIGHT_DEFAULT: SPINNER_HIGHLIGHT_DEFAULT,
  SPINNER_HIGHLIGHT_NEGATIVE: SPINNER_HIGHLIGHT_NEGATIVE,
  SPINNER_NEGATIVE: SPINNER_NEGATIVE,
  TAG_DEFAULT: TAG_DEFAULT,
  TAG_LIVE: TAG_LIVE,
  TAG_OPINION: TAG_OPINION,
  TAG_PRIMARY_ACTION: TAG_PRIMARY_ACTION,
  TAG_PRIMARY_ACTION_VARIANT: TAG_PRIMARY_ACTION_VARIANT,
  TAG_SECONDARY_ACTION: TAG_SECONDARY_ACTION,
  TAG_SECONDARY_ACTION_VARIANT: TAG_SECONDARY_ACTION_VARIANT,
  TAG_YLE_CORPORATE: TAG_YLE_CORPORATE,
  TEXT_DARK: TEXT_DARK$3,
  TEXT_DEFAULT: TEXT_DEFAULT$3,
  TEXT_DISABLED: TEXT_DISABLED,
  TEXT_HIGH_EMPHASIS: TEXT_HIGH_EMPHASIS,
  TEXT_INPUT_PLACEHOLDER: TEXT_INPUT_PLACEHOLDER,
  TEXT_LIGHT: TEXT_LIGHT$3,
  TEXT_MEDIUM_EMPHASIS: TEXT_MEDIUM_EMPHASIS,
  TEXT_NEGATIVE: TEXT_NEGATIVE$3
});

/**
 * Yle Design System
 * v1.2.4
 */

const DEFAULT_XL_ITALIC_FONT_SIZE = '20px';
const DEFAULT_XL_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_XL_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_XL_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_XL_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_XL_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XL_ITALIC_LETTER_SPACING = 0;
const DEFAULT_XL_ITALIC_LINE_HEIGHT = '150%';
const DEFAULT_XL_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_ITALIC_PARAGRAPH_SPACING = '20px';
const DEFAULT_XL_ITALIC_TEXT_CASE = 'none';
const DEFAULT_L_ITALIC_FONT_SIZE = '18px';
const DEFAULT_L_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_L_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_L_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_L_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_L_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_L_ITALIC_LETTER_SPACING = 0;
const DEFAULT_L_ITALIC_LINE_HEIGHT = '150%';
const DEFAULT_L_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_L_ITALIC_PARAGRAPH_SPACING = '18px';
const DEFAULT_L_ITALIC_TEXT_CASE = 'none';
const DEFAULT_M_ITALIC_FONT_SIZE = '16px';
const DEFAULT_M_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_M_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_M_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_M_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_M_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_M_ITALIC_LETTER_SPACING = 0;
const DEFAULT_M_ITALIC_LINE_HEIGHT = '150%';
const DEFAULT_M_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_M_ITALIC_PARAGRAPH_SPACING = '16px';
const DEFAULT_M_ITALIC_TEXT_CASE = 'none';
const DEFAULT_S_ITALIC_FONT_SIZE = '14px';
const DEFAULT_S_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_S_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_S_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_S_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_S_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_S_ITALIC_LETTER_SPACING = 0;
const DEFAULT_S_ITALIC_LINE_HEIGHT = '150%';
const DEFAULT_S_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_S_ITALIC_PARAGRAPH_SPACING = '14px';
const DEFAULT_S_ITALIC_TEXT_CASE = 'none';
const DEFAULT_XS_ITALIC_FONT_SIZE = '12px';
const DEFAULT_XS_ITALIC_TEXT_DECORATION = 'none';
const DEFAULT_XS_ITALIC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_ITALIC_FONT_WEIGHT = 400;
const DEFAULT_XS_ITALIC_FONT_STYLE = 'italic';
const DEFAULT_XS_ITALIC_FONT_STRETCH = 'normal';
const DEFAULT_XS_ITALIC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XS_ITALIC_LETTER_SPACING = 0;
const DEFAULT_XS_ITALIC_LINE_HEIGHT = '150%';
const DEFAULT_XS_ITALIC_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_ITALIC_PARAGRAPH_SPACING = '12px';
const DEFAULT_XS_ITALIC_TEXT_CASE = 'none';
const DEFAULT_7XL_BOLD_FONT_SIZE = '56px';
const DEFAULT_7XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_7XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_7XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_7XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_7XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_7XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_7XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_7XL_BOLD_LINE_HEIGHT = '130%';
const DEFAULT_7XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_7XL_BOLD_PARAGRAPH_SPACING = '56px';
const DEFAULT_7XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_7XL_HEAVY_FONT_SIZE = '56px';
const DEFAULT_7XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_7XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_7XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_7XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_7XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_7XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_7XL_HEAVY_LINE_HEIGHT = '130%';
const DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING = '56px';
const DEFAULT_7XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_6XL_BOLD_FONT_SIZE = '48px';
const DEFAULT_6XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_6XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_6XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_6XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_6XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_6XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_6XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_6XL_BOLD_LINE_HEIGHT = '130%';
const DEFAULT_6XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_6XL_BOLD_PARAGRAPH_SPACING = '48px';
const DEFAULT_6XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_6XL_HEAVY_FONT_SIZE = '48px';
const DEFAULT_6XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_6XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_6XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_6XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_6XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_6XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_6XL_HEAVY_LINE_HEIGHT = '130%';
const DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING = '48px';
const DEFAULT_6XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_5XL_BOLD_FONT_SIZE = '40px';
const DEFAULT_5XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_5XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_5XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_5XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_5XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_5XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_5XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_5XL_BOLD_LINE_HEIGHT = '130%';
const DEFAULT_5XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_5XL_BOLD_PARAGRAPH_SPACING = '40px';
const DEFAULT_5XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_5XL_HEAVY_FONT_SIZE = '40px';
const DEFAULT_5XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_5XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_5XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_5XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_5XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_5XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_5XL_HEAVY_LINE_HEIGHT = '130%';
const DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING = '40px';
const DEFAULT_5XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_4XL_BOLD_FONT_SIZE = '32px';
const DEFAULT_4XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_4XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_4XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_4XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_4XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_4XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_4XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_4XL_BOLD_LINE_HEIGHT = '140%';
const DEFAULT_4XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_4XL_BOLD_PARAGRAPH_SPACING = '32px';
const DEFAULT_4XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_4XL_HEAVY_FONT_SIZE = '32px';
const DEFAULT_4XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_4XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_4XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_4XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_4XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_4XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_4XL_HEAVY_LINE_HEIGHT = '140%';
const DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING = '32px';
const DEFAULT_4XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_3XL_BOLD_FONT_SIZE = '28px';
const DEFAULT_3XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_3XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_3XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_3XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_3XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_3XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_3XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_3XL_BOLD_LINE_HEIGHT = '130%';
const DEFAULT_3XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_3XL_BOLD_PARAGRAPH_SPACING = '28px';
const DEFAULT_3XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_3XL_HEAVY_FONT_SIZE = '28px';
const DEFAULT_3XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_3XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_3XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_3XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_3XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_3XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_3XL_HEAVY_LINE_HEIGHT = '130%';
const DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING = '28px';
const DEFAULT_3XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_2XL_FONT_SIZE = '24px';
const DEFAULT_2XL_TEXT_DECORATION = 'none';
const DEFAULT_2XL_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_FONT_WEIGHT = 400;
const DEFAULT_2XL_FONT_STYLE = 'normal';
const DEFAULT_2XL_FONT_STRETCH = 'normal';
const DEFAULT_2XL_FONT_STYLE_OLD = 'Regular';
const DEFAULT_2XL_LETTER_SPACING = 0;
const DEFAULT_2XL_LINE_HEIGHT = '140%';
const DEFAULT_2XL_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_PARAGRAPH_SPACING = '24px';
const DEFAULT_2XL_TEXT_CASE = 'none';
const DEFAULT_2XL_BOLD_FONT_SIZE = '24px';
const DEFAULT_2XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_2XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_2XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_2XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_2XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_2XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_2XL_BOLD_LINE_HEIGHT = '140%';
const DEFAULT_2XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_BOLD_PARAGRAPH_SPACING = '24px';
const DEFAULT_2XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_2XL_HEAVY_FONT_SIZE = '24px';
const DEFAULT_2XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_2XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_2XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_2XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_2XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_2XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_2XL_HEAVY_LINE_HEIGHT = '140%';
const DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING = '24px';
const DEFAULT_2XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_XL_FONT_SIZE = '20px';
const DEFAULT_XL_TEXT_DECORATION = 'none';
const DEFAULT_XL_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_FONT_WEIGHT = 400;
const DEFAULT_XL_FONT_STYLE = 'normal';
const DEFAULT_XL_FONT_STRETCH = 'normal';
const DEFAULT_XL_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XL_LETTER_SPACING = 0;
const DEFAULT_XL_LINE_HEIGHT = '150%';
const DEFAULT_XL_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_PARAGRAPH_SPACING = '20px';
const DEFAULT_XL_TEXT_CASE = 'none';
const DEFAULT_XL_BOLD_FONT_SIZE = '20px';
const DEFAULT_XL_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_XL_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_BOLD_FONT_WEIGHT = 700;
const DEFAULT_XL_BOLD_FONT_STYLE = 'normal';
const DEFAULT_XL_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_XL_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XL_BOLD_LETTER_SPACING = 0;
const DEFAULT_XL_BOLD_LINE_HEIGHT = '150%';
const DEFAULT_XL_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_BOLD_PARAGRAPH_SPACING = '20px';
const DEFAULT_XL_BOLD_TEXT_CASE = 'none';
const DEFAULT_XL_HEAVY_FONT_SIZE = '20px';
const DEFAULT_XL_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_XL_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_XL_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_XL_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_XL_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_XL_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_XL_HEAVY_LETTER_SPACING = 0;
const DEFAULT_XL_HEAVY_LINE_HEIGHT = '150%';
const DEFAULT_XL_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_XL_HEAVY_PARAGRAPH_SPACING = '20px';
const DEFAULT_XL_HEAVY_TEXT_CASE = 'none';
const DEFAULT_L_FONT_SIZE = '18px';
const DEFAULT_L_TEXT_DECORATION = 'none';
const DEFAULT_L_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_FONT_WEIGHT = 400;
const DEFAULT_L_FONT_STYLE = 'normal';
const DEFAULT_L_FONT_STRETCH = 'normal';
const DEFAULT_L_FONT_STYLE_OLD = 'Regular';
const DEFAULT_L_LETTER_SPACING = 0;
const DEFAULT_L_LINE_HEIGHT = '150%';
const DEFAULT_L_PARAGRAPH_INDENT = 0;
const DEFAULT_L_PARAGRAPH_SPACING = '18px';
const DEFAULT_L_TEXT_CASE = 'none';
const DEFAULT_L_BOLD_FONT_SIZE = '18px';
const DEFAULT_L_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_L_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_BOLD_FONT_WEIGHT = 700;
const DEFAULT_L_BOLD_FONT_STYLE = 'normal';
const DEFAULT_L_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_L_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_L_BOLD_LETTER_SPACING = 0;
const DEFAULT_L_BOLD_LINE_HEIGHT = '150%';
const DEFAULT_L_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_L_BOLD_PARAGRAPH_SPACING = '18px';
const DEFAULT_L_BOLD_TEXT_CASE = 'none';
const DEFAULT_L_HEAVY_FONT_SIZE = '18px';
const DEFAULT_L_HEAVY_TEXT_DECORATION = 'none';
const DEFAULT_L_HEAVY_FONT_FAMILY = 'Yle Next';
const DEFAULT_L_HEAVY_FONT_WEIGHT = 900;
const DEFAULT_L_HEAVY_FONT_STYLE = 'normal';
const DEFAULT_L_HEAVY_FONT_STRETCH = 'normal';
const DEFAULT_L_HEAVY_FONT_STYLE_OLD = 'Black';
const DEFAULT_L_HEAVY_LETTER_SPACING = 0;
const DEFAULT_L_HEAVY_LINE_HEIGHT = '150%';
const DEFAULT_L_HEAVY_PARAGRAPH_INDENT = 0;
const DEFAULT_L_HEAVY_PARAGRAPH_SPACING = '18px';
const DEFAULT_L_HEAVY_TEXT_CASE = 'none';
const DEFAULT_M_FONT_SIZE = '16px';
const DEFAULT_M_TEXT_DECORATION = 'none';
const DEFAULT_M_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_FONT_WEIGHT = 400;
const DEFAULT_M_FONT_STYLE = 'normal';
const DEFAULT_M_FONT_STRETCH = 'normal';
const DEFAULT_M_FONT_STYLE_OLD = 'Regular';
const DEFAULT_M_LETTER_SPACING = 0;
const DEFAULT_M_LINE_HEIGHT = '150%';
const DEFAULT_M_PARAGRAPH_INDENT = 0;
const DEFAULT_M_PARAGRAPH_SPACING = '16px';
const DEFAULT_M_TEXT_CASE = 'none';
const DEFAULT_M_AC_FONT_SIZE = '16px';
const DEFAULT_M_AC_TEXT_DECORATION = 'none';
const DEFAULT_M_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_AC_FONT_WEIGHT = 400;
const DEFAULT_M_AC_FONT_STYLE = 'normal';
const DEFAULT_M_AC_FONT_STRETCH = 'normal';
const DEFAULT_M_AC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_M_AC_LETTER_SPACING = '0.01em';
const DEFAULT_M_AC_LINE_HEIGHT = '150%';
const DEFAULT_M_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_M_AC_PARAGRAPH_SPACING = '16px';
const DEFAULT_M_AC_TEXT_CASE = 'uppercase';
const DEFAULT_M_MEDIUM_FONT_SIZE = '16px';
const DEFAULT_M_MEDIUM_TEXT_DECORATION = 'none';
const DEFAULT_M_MEDIUM_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_MEDIUM_FONT_WEIGHT = 500;
const DEFAULT_M_MEDIUM_FONT_STYLE = 'normal';
const DEFAULT_M_MEDIUM_FONT_STRETCH = 'normal';
const DEFAULT_M_MEDIUM_FONT_STYLE_OLD = 'Medium';
const DEFAULT_M_MEDIUM_LETTER_SPACING = 0;
const DEFAULT_M_MEDIUM_LINE_HEIGHT = '150%';
const DEFAULT_M_MEDIUM_PARAGRAPH_INDENT = 0;
const DEFAULT_M_MEDIUM_PARAGRAPH_SPACING = '16px';
const DEFAULT_M_MEDIUM_TEXT_CASE = 'none';
const DEFAULT_M_BOLD_FONT_SIZE = '16px';
const DEFAULT_M_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_M_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_BOLD_FONT_WEIGHT = 700;
const DEFAULT_M_BOLD_FONT_STYLE = 'normal';
const DEFAULT_M_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_M_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_M_BOLD_LETTER_SPACING = 0;
const DEFAULT_M_BOLD_LINE_HEIGHT = '150%';
const DEFAULT_M_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_M_BOLD_PARAGRAPH_SPACING = '16px';
const DEFAULT_M_BOLD_TEXT_CASE = 'none';
const DEFAULT_M_BOLD_AC_FONT_SIZE = '16px';
const DEFAULT_M_BOLD_AC_TEXT_DECORATION = 'none';
const DEFAULT_M_BOLD_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_M_BOLD_AC_FONT_WEIGHT = 700;
const DEFAULT_M_BOLD_AC_FONT_STYLE = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STRETCH = 'normal';
const DEFAULT_M_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const DEFAULT_M_BOLD_AC_LETTER_SPACING = '0.01em';
const DEFAULT_M_BOLD_AC_LINE_HEIGHT = '150%';
const DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING = '16px';
const DEFAULT_M_BOLD_AC_TEXT_CASE = 'uppercase';
const DEFAULT_S_FONT_SIZE = '14px';
const DEFAULT_S_TEXT_DECORATION = 'none';
const DEFAULT_S_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_FONT_WEIGHT = 400;
const DEFAULT_S_FONT_STYLE = 'normal';
const DEFAULT_S_FONT_STRETCH = 'normal';
const DEFAULT_S_FONT_STYLE_OLD = 'Regular';
const DEFAULT_S_LETTER_SPACING = 0;
const DEFAULT_S_LINE_HEIGHT = '150%';
const DEFAULT_S_PARAGRAPH_INDENT = 0;
const DEFAULT_S_PARAGRAPH_SPACING = '14px';
const DEFAULT_S_TEXT_CASE = 'none';
const DEFAULT_S_AC_FONT_SIZE = '14px';
const DEFAULT_S_AC_TEXT_DECORATION = 'none';
const DEFAULT_S_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_AC_FONT_WEIGHT = 400;
const DEFAULT_S_AC_FONT_STYLE = 'normal';
const DEFAULT_S_AC_FONT_STRETCH = 'normal';
const DEFAULT_S_AC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_S_AC_LETTER_SPACING = '0.01em';
const DEFAULT_S_AC_LINE_HEIGHT = '150%';
const DEFAULT_S_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_S_AC_PARAGRAPH_SPACING = '14px';
const DEFAULT_S_AC_TEXT_CASE = 'uppercase';
const DEFAULT_S_BOLD_FONT_SIZE = '14px';
const DEFAULT_S_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_S_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_BOLD_FONT_WEIGHT = 700;
const DEFAULT_S_BOLD_FONT_STYLE = 'normal';
const DEFAULT_S_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_S_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_S_BOLD_LETTER_SPACING = 0;
const DEFAULT_S_BOLD_LINE_HEIGHT = '150%';
const DEFAULT_S_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_S_BOLD_PARAGRAPH_SPACING = '14px';
const DEFAULT_S_BOLD_TEXT_CASE = 'none';
const DEFAULT_S_BOLD_AC_FONT_SIZE = '14px';
const DEFAULT_S_BOLD_AC_TEXT_DECORATION = 'none';
const DEFAULT_S_BOLD_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_S_BOLD_AC_FONT_WEIGHT = 700;
const DEFAULT_S_BOLD_AC_FONT_STYLE = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STRETCH = 'normal';
const DEFAULT_S_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const DEFAULT_S_BOLD_AC_LETTER_SPACING = '0.01em';
const DEFAULT_S_BOLD_AC_LINE_HEIGHT = '150%';
const DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING = '14px';
const DEFAULT_S_BOLD_AC_TEXT_CASE = 'uppercase';
const DEFAULT_XS_FONT_SIZE = '12px';
const DEFAULT_XS_TEXT_DECORATION = 'none';
const DEFAULT_XS_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_FONT_WEIGHT = 400;
const DEFAULT_XS_FONT_STYLE = 'normal';
const DEFAULT_XS_FONT_STRETCH = 'normal';
const DEFAULT_XS_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XS_LETTER_SPACING = 0;
const DEFAULT_XS_LINE_HEIGHT = '150%';
const DEFAULT_XS_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_PARAGRAPH_SPACING = '12px';
const DEFAULT_XS_TEXT_CASE = 'none';
const DEFAULT_XS_AC_FONT_SIZE = '12px';
const DEFAULT_XS_AC_TEXT_DECORATION = 'none';
const DEFAULT_XS_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_AC_FONT_WEIGHT = 400;
const DEFAULT_XS_AC_FONT_STYLE = 'normal';
const DEFAULT_XS_AC_FONT_STRETCH = 'normal';
const DEFAULT_XS_AC_FONT_STYLE_OLD = 'Regular';
const DEFAULT_XS_AC_LETTER_SPACING = '0.01em';
const DEFAULT_XS_AC_LINE_HEIGHT = '150%';
const DEFAULT_XS_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_AC_PARAGRAPH_SPACING = '12px';
const DEFAULT_XS_AC_TEXT_CASE = 'uppercase';
const DEFAULT_XS_BOLD_FONT_SIZE = '12px';
const DEFAULT_XS_BOLD_TEXT_DECORATION = 'none';
const DEFAULT_XS_BOLD_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_BOLD_FONT_WEIGHT = 700;
const DEFAULT_XS_BOLD_FONT_STYLE = 'normal';
const DEFAULT_XS_BOLD_FONT_STRETCH = 'normal';
const DEFAULT_XS_BOLD_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XS_BOLD_LETTER_SPACING = 0;
const DEFAULT_XS_BOLD_LINE_HEIGHT = '150%';
const DEFAULT_XS_BOLD_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_BOLD_PARAGRAPH_SPACING = '12px';
const DEFAULT_XS_BOLD_TEXT_CASE = 'none';
const DEFAULT_XS_BOLD_AC_FONT_SIZE = '12px';
const DEFAULT_XS_BOLD_AC_TEXT_DECORATION = 'none';
const DEFAULT_XS_BOLD_AC_FONT_FAMILY = 'Yle Next';
const DEFAULT_XS_BOLD_AC_FONT_WEIGHT = 700;
const DEFAULT_XS_BOLD_AC_FONT_STYLE = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STRETCH = 'normal';
const DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const DEFAULT_XS_BOLD_AC_LETTER_SPACING = '0.01em';
const DEFAULT_XS_BOLD_AC_LINE_HEIGHT = '150%';
const DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT = 0;
const DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING = '12px';
const DEFAULT_XS_BOLD_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_XL_ITALIC_FONT_SIZE = '20px';
const YLE_NEXT_XL_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_XL_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_XL_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XL_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_XL_ITALIC_LINE_HEIGHT = '150%';
const YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING = '20px';
const YLE_NEXT_XL_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_L_ITALIC_FONT_SIZE = '18px';
const YLE_NEXT_L_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_L_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_L_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_L_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_L_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_L_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_L_ITALIC_LINE_HEIGHT = '150%';
const YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING = '18px';
const YLE_NEXT_L_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_M_ITALIC_FONT_SIZE = '16px';
const YLE_NEXT_M_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_M_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_M_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_M_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_M_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_M_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_M_ITALIC_LINE_HEIGHT = '150%';
const YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING = '16px';
const YLE_NEXT_M_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_S_ITALIC_FONT_SIZE = '14px';
const YLE_NEXT_S_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_S_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_S_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_S_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_S_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_S_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_S_ITALIC_LINE_HEIGHT = '150%';
const YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING = '14px';
const YLE_NEXT_S_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_XS_ITALIC_FONT_SIZE = '12px';
const YLE_NEXT_XS_ITALIC_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_ITALIC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_ITALIC_FONT_WEIGHT = 400;
const YLE_NEXT_XS_ITALIC_FONT_STYLE = 'italic';
const YLE_NEXT_XS_ITALIC_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XS_ITALIC_LETTER_SPACING = 0;
const YLE_NEXT_XS_ITALIC_LINE_HEIGHT = '150%';
const YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING = '12px';
const YLE_NEXT_XS_ITALIC_TEXT_CASE = 'none';
const YLE_NEXT_7XL_BOLD_FONT_SIZE = '56px';
const YLE_NEXT_7XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_7XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_7XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_7XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_7XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_7XL_BOLD_LINE_HEIGHT = '130%';
const YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING = '56px';
const YLE_NEXT_7XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_SIZE = '56px';
const YLE_NEXT_7XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_7XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_7XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_7XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_7XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_7XL_HEAVY_LINE_HEIGHT = '130%';
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING = '56px';
const YLE_NEXT_7XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_6XL_BOLD_FONT_SIZE = '48px';
const YLE_NEXT_6XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_6XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_6XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_6XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_6XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_6XL_BOLD_LINE_HEIGHT = '130%';
const YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING = '48px';
const YLE_NEXT_6XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_SIZE = '48px';
const YLE_NEXT_6XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_6XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_6XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_6XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_6XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_6XL_HEAVY_LINE_HEIGHT = '130%';
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING = '48px';
const YLE_NEXT_6XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_5XL_BOLD_FONT_SIZE = '40px';
const YLE_NEXT_5XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_5XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_5XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_5XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_5XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_5XL_BOLD_LINE_HEIGHT = '130%';
const YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING = '40px';
const YLE_NEXT_5XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_SIZE = '40px';
const YLE_NEXT_5XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_5XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_5XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_5XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_5XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_5XL_HEAVY_LINE_HEIGHT = '130%';
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING = '40px';
const YLE_NEXT_5XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_4XL_BOLD_FONT_SIZE = '32px';
const YLE_NEXT_4XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_4XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_4XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_4XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_4XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_4XL_BOLD_LINE_HEIGHT = '140%';
const YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING = '32px';
const YLE_NEXT_4XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_SIZE = '32px';
const YLE_NEXT_4XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_4XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_4XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_4XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_4XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_4XL_HEAVY_LINE_HEIGHT = '140%';
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING = '32px';
const YLE_NEXT_4XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_3XL_BOLD_FONT_SIZE = '28px';
const YLE_NEXT_3XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_3XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_3XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_3XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_3XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_3XL_BOLD_LINE_HEIGHT = '130%';
const YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING = '28px';
const YLE_NEXT_3XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_SIZE = '28px';
const YLE_NEXT_3XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_3XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_3XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_3XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_3XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_3XL_HEAVY_LINE_HEIGHT = '130%';
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING = '28px';
const YLE_NEXT_3XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_2XL_FONT_SIZE = '24px';
const YLE_NEXT_2XL_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_FONT_WEIGHT = 400;
const YLE_NEXT_2XL_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_FONT_STRETCH = 'normal';
const YLE_NEXT_2XL_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_2XL_LETTER_SPACING = 0;
const YLE_NEXT_2XL_LINE_HEIGHT = '140%';
const YLE_NEXT_2XL_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_PARAGRAPH_SPACING = '24px';
const YLE_NEXT_2XL_TEXT_CASE = 'none';
const YLE_NEXT_2XL_BOLD_FONT_SIZE = '24px';
const YLE_NEXT_2XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_2XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_2XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_2XL_BOLD_LINE_HEIGHT = '140%';
const YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING = '24px';
const YLE_NEXT_2XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_SIZE = '24px';
const YLE_NEXT_2XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_2XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_2XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_2XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_2XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_2XL_HEAVY_LINE_HEIGHT = '140%';
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING = '24px';
const YLE_NEXT_2XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_XL_FONT_SIZE = '20px';
const YLE_NEXT_XL_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_FONT_WEIGHT = 400;
const YLE_NEXT_XL_FONT_STYLE = 'normal';
const YLE_NEXT_XL_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XL_LETTER_SPACING = 0;
const YLE_NEXT_XL_LINE_HEIGHT = '150%';
const YLE_NEXT_XL_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_PARAGRAPH_SPACING = '20px';
const YLE_NEXT_XL_TEXT_CASE = 'none';
const YLE_NEXT_XL_BOLD_FONT_SIZE = '20px';
const YLE_NEXT_XL_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_XL_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XL_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_XL_BOLD_LINE_HEIGHT = '150%';
const YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING = '20px';
const YLE_NEXT_XL_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_XL_HEAVY_FONT_SIZE = '20px';
const YLE_NEXT_XL_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_XL_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XL_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_XL_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_XL_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_XL_HEAVY_LINE_HEIGHT = '150%';
const YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING = '20px';
const YLE_NEXT_XL_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_L_FONT_SIZE = '18px';
const YLE_NEXT_L_TEXT_DECORATION = 'none';
const YLE_NEXT_L_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_FONT_WEIGHT = 400;
const YLE_NEXT_L_FONT_STYLE = 'normal';
const YLE_NEXT_L_FONT_STRETCH = 'normal';
const YLE_NEXT_L_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_L_LETTER_SPACING = 0;
const YLE_NEXT_L_LINE_HEIGHT = '150%';
const YLE_NEXT_L_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_PARAGRAPH_SPACING = '18px';
const YLE_NEXT_L_TEXT_CASE = 'none';
const YLE_NEXT_L_BOLD_FONT_SIZE = '18px';
const YLE_NEXT_L_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_L_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_L_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_L_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_L_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_L_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_L_BOLD_LINE_HEIGHT = '150%';
const YLE_NEXT_L_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_BOLD_PARAGRAPH_SPACING = '18px';
const YLE_NEXT_L_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_L_HEAVY_FONT_SIZE = '18px';
const YLE_NEXT_L_HEAVY_TEXT_DECORATION = 'none';
const YLE_NEXT_L_HEAVY_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_L_HEAVY_FONT_WEIGHT = 900;
const YLE_NEXT_L_HEAVY_FONT_STYLE = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STRETCH = 'normal';
const YLE_NEXT_L_HEAVY_FONT_STYLE_OLD = 'Black';
const YLE_NEXT_L_HEAVY_LETTER_SPACING = 0;
const YLE_NEXT_L_HEAVY_LINE_HEIGHT = '150%';
const YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT = 0;
const YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING = '18px';
const YLE_NEXT_L_HEAVY_TEXT_CASE = 'none';
const YLE_NEXT_M_FONT_SIZE = '16px';
const YLE_NEXT_M_TEXT_DECORATION = 'none';
const YLE_NEXT_M_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_FONT_WEIGHT = 400;
const YLE_NEXT_M_FONT_STYLE = 'normal';
const YLE_NEXT_M_FONT_STRETCH = 'normal';
const YLE_NEXT_M_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_M_LETTER_SPACING = 0;
const YLE_NEXT_M_LINE_HEIGHT = '150%';
const YLE_NEXT_M_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_PARAGRAPH_SPACING = '16px';
const YLE_NEXT_M_TEXT_CASE = 'none';
const YLE_NEXT_M_AC_FONT_SIZE = '16px';
const YLE_NEXT_M_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_M_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_AC_FONT_WEIGHT = 400;
const YLE_NEXT_M_AC_FONT_STYLE = 'normal';
const YLE_NEXT_M_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_M_AC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_M_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_M_AC_LINE_HEIGHT = '150%';
const YLE_NEXT_M_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_AC_PARAGRAPH_SPACING = '16px';
const YLE_NEXT_M_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_M_MEDIUM_FONT_SIZE = '16px';
const YLE_NEXT_M_MEDIUM_TEXT_DECORATION = 'none';
const YLE_NEXT_M_MEDIUM_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_MEDIUM_FONT_WEIGHT = 500;
const YLE_NEXT_M_MEDIUM_FONT_STYLE = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STRETCH = 'normal';
const YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD = 'Medium';
const YLE_NEXT_M_MEDIUM_LETTER_SPACING = 0;
const YLE_NEXT_M_MEDIUM_LINE_HEIGHT = '150%';
const YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING = '16px';
const YLE_NEXT_M_MEDIUM_TEXT_CASE = 'none';
const YLE_NEXT_M_BOLD_FONT_SIZE = '16px';
const YLE_NEXT_M_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_M_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_M_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_M_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_M_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_M_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_M_BOLD_LINE_HEIGHT = '150%';
const YLE_NEXT_M_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_BOLD_PARAGRAPH_SPACING = '16px';
const YLE_NEXT_M_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_SIZE = '16px';
const YLE_NEXT_M_BOLD_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_M_BOLD_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_M_BOLD_AC_FONT_WEIGHT = 700;
const YLE_NEXT_M_BOLD_AC_FONT_STYLE = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_M_BOLD_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_M_BOLD_AC_LINE_HEIGHT = '150%';
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING = '16px';
const YLE_NEXT_M_BOLD_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_S_FONT_SIZE = '14px';
const YLE_NEXT_S_TEXT_DECORATION = 'none';
const YLE_NEXT_S_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_FONT_WEIGHT = 400;
const YLE_NEXT_S_FONT_STYLE = 'normal';
const YLE_NEXT_S_FONT_STRETCH = 'normal';
const YLE_NEXT_S_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_S_LETTER_SPACING = 0;
const YLE_NEXT_S_LINE_HEIGHT = '150%';
const YLE_NEXT_S_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_PARAGRAPH_SPACING = '14px';
const YLE_NEXT_S_TEXT_CASE = 'none';
const YLE_NEXT_S_AC_FONT_SIZE = '14px';
const YLE_NEXT_S_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_S_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_AC_FONT_WEIGHT = 400;
const YLE_NEXT_S_AC_FONT_STYLE = 'normal';
const YLE_NEXT_S_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_S_AC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_S_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_S_AC_LINE_HEIGHT = '150%';
const YLE_NEXT_S_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_AC_PARAGRAPH_SPACING = '14px';
const YLE_NEXT_S_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_S_BOLD_FONT_SIZE = '14px';
const YLE_NEXT_S_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_S_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_S_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_S_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_S_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_S_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_S_BOLD_LINE_HEIGHT = '150%';
const YLE_NEXT_S_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_BOLD_PARAGRAPH_SPACING = '14px';
const YLE_NEXT_S_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_SIZE = '14px';
const YLE_NEXT_S_BOLD_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_S_BOLD_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_S_BOLD_AC_FONT_WEIGHT = 700;
const YLE_NEXT_S_BOLD_AC_FONT_STYLE = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_S_BOLD_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_S_BOLD_AC_LINE_HEIGHT = '150%';
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING = '14px';
const YLE_NEXT_S_BOLD_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_XS_FONT_SIZE = '12px';
const YLE_NEXT_XS_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_FONT_WEIGHT = 400;
const YLE_NEXT_XS_FONT_STYLE = 'normal';
const YLE_NEXT_XS_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XS_LETTER_SPACING = 0;
const YLE_NEXT_XS_LINE_HEIGHT = '150%';
const YLE_NEXT_XS_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_PARAGRAPH_SPACING = '12px';
const YLE_NEXT_XS_TEXT_CASE = 'none';
const YLE_NEXT_XS_AC_FONT_SIZE = '12px';
const YLE_NEXT_XS_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_AC_FONT_WEIGHT = 400;
const YLE_NEXT_XS_AC_FONT_STYLE = 'normal';
const YLE_NEXT_XS_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_AC_FONT_STYLE_OLD = 'Regular';
const YLE_NEXT_XS_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_XS_AC_LINE_HEIGHT = '150%';
const YLE_NEXT_XS_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_AC_PARAGRAPH_SPACING = '12px';
const YLE_NEXT_XS_AC_TEXT_CASE = 'uppercase';
const YLE_NEXT_XS_BOLD_FONT_SIZE = '12px';
const YLE_NEXT_XS_BOLD_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_BOLD_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_BOLD_FONT_WEIGHT = 700;
const YLE_NEXT_XS_BOLD_FONT_STYLE = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XS_BOLD_LETTER_SPACING = 0;
const YLE_NEXT_XS_BOLD_LINE_HEIGHT = '150%';
const YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING = '12px';
const YLE_NEXT_XS_BOLD_TEXT_CASE = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_SIZE = '12px';
const YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION = 'none';
const YLE_NEXT_XS_BOLD_AC_FONT_FAMILY = 'Yle Next';
const YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT = 700;
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STRETCH = 'normal';
const YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const YLE_NEXT_XS_BOLD_AC_LETTER_SPACING = '0.01em';
const YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT = '150%';
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT = 0;
const YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING = '12px';
const YLE_NEXT_XS_BOLD_AC_TEXT_CASE = 'uppercase';
const OPEN_SANS_7XL_BOLD_FONT_SIZE = '56px';
const OPEN_SANS_7XL_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_7XL_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_7XL_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_7XL_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_7XL_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_7XL_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_7XL_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_7XL_BOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_7XL_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_7XL_BOLD_PARAGRAPH_SPACING = '56px';
const OPEN_SANS_7XL_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_7XL_EXTRABOLD_FONT_SIZE = '56px';
const OPEN_SANS_7XL_EXTRABOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_7XL_EXTRABOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_7XL_EXTRABOLD_FONT_WEIGHT = 800;
const OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE = 'normal';
const OPEN_SANS_7XL_EXTRABOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE_OLD = 'ExtraBold';
const OPEN_SANS_7XL_EXTRABOLD_LETTER_SPACING = 0;
const OPEN_SANS_7XL_EXTRABOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_SPACING = '56px';
const OPEN_SANS_7XL_EXTRABOLD_TEXT_CASE = 'none';
const OPEN_SANS_6XL_BOLD_FONT_SIZE = '48px';
const OPEN_SANS_6XL_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_6XL_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_6XL_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_6XL_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_6XL_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_6XL_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_6XL_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_6XL_BOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_6XL_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_6XL_BOLD_PARAGRAPH_SPACING = '48px';
const OPEN_SANS_6XL_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_6XL_EXTRABOLD_FONT_SIZE = '48px';
const OPEN_SANS_6XL_EXTRABOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_6XL_EXTRABOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_6XL_EXTRABOLD_FONT_WEIGHT = 800;
const OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE = 'normal';
const OPEN_SANS_6XL_EXTRABOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE_OLD = 'ExtraBold';
const OPEN_SANS_6XL_EXTRABOLD_LETTER_SPACING = 0;
const OPEN_SANS_6XL_EXTRABOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_SPACING = '48px';
const OPEN_SANS_6XL_EXTRABOLD_TEXT_CASE = 'none';
const OPEN_SANS_5XL_BOLD_FONT_SIZE = '40px';
const OPEN_SANS_5XL_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_5XL_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_5XL_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_5XL_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_5XL_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_5XL_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_5XL_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_5XL_BOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_5XL_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_5XL_BOLD_PARAGRAPH_SPACING = '40px';
const OPEN_SANS_5XL_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_5XL_EXTRABOLD_FONT_SIZE = '40px';
const OPEN_SANS_5XL_EXTRABOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_5XL_EXTRABOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_5XL_EXTRABOLD_FONT_WEIGHT = 800;
const OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE = 'normal';
const OPEN_SANS_5XL_EXTRABOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE_OLD = 'ExtraBold';
const OPEN_SANS_5XL_EXTRABOLD_LETTER_SPACING = 0;
const OPEN_SANS_5XL_EXTRABOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_SPACING = '40px';
const OPEN_SANS_5XL_EXTRABOLD_TEXT_CASE = 'none';
const OPEN_SANS_4XL_BOLD_FONT_SIZE = '32px';
const OPEN_SANS_4XL_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_4XL_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_4XL_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_4XL_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_4XL_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_4XL_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_4XL_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_4XL_BOLD_LINE_HEIGHT = '140%';
const OPEN_SANS_4XL_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_4XL_BOLD_PARAGRAPH_SPACING = '32px';
const OPEN_SANS_4XL_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_4XL_EXTRABOLD_FONT_SIZE = '32px';
const OPEN_SANS_4XL_EXTRABOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_4XL_EXTRABOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_4XL_EXTRABOLD_FONT_WEIGHT = 800;
const OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE = 'normal';
const OPEN_SANS_4XL_EXTRABOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE_OLD = 'ExtraBold';
const OPEN_SANS_4XL_EXTRABOLD_LETTER_SPACING = 0;
const OPEN_SANS_4XL_EXTRABOLD_LINE_HEIGHT = '140%';
const OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_SPACING = '32px';
const OPEN_SANS_4XL_EXTRABOLD_TEXT_CASE = 'none';
const OPEN_SANS_3XL_BOLD_FONT_SIZE = '28px';
const OPEN_SANS_3XL_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_3XL_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_3XL_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_3XL_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_3XL_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_3XL_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_3XL_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_3XL_BOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_3XL_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_3XL_BOLD_PARAGRAPH_SPACING = '28px';
const OPEN_SANS_3XL_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_3XL_EXTRABOLD_FONT_SIZE = '28px';
const OPEN_SANS_3XL_EXTRABOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_3XL_EXTRABOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_3XL_EXTRABOLD_FONT_WEIGHT = 800;
const OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE = 'normal';
const OPEN_SANS_3XL_EXTRABOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE_OLD = 'ExtraBold';
const OPEN_SANS_3XL_EXTRABOLD_LETTER_SPACING = 0;
const OPEN_SANS_3XL_EXTRABOLD_LINE_HEIGHT = '130%';
const OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_SPACING = '28px';
const OPEN_SANS_3XL_EXTRABOLD_TEXT_CASE = 'none';
const OPEN_SANS_2XL_FONT_SIZE = '24px';
const OPEN_SANS_2XL_TEXT_DECORATION = 'none';
const OPEN_SANS_2XL_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_2XL_FONT_WEIGHT = 400;
const OPEN_SANS_2XL_FONT_STYLE = 'normal';
const OPEN_SANS_2XL_FONT_STRETCH = 'normal';
const OPEN_SANS_2XL_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_2XL_LETTER_SPACING = 0;
const OPEN_SANS_2XL_LINE_HEIGHT = '140%';
const OPEN_SANS_2XL_PARAGRAPH_INDENT = 0;
const OPEN_SANS_2XL_PARAGRAPH_SPACING = '24px';
const OPEN_SANS_2XL_TEXT_CASE = 'none';
const OPEN_SANS_2XL_BOLD_FONT_SIZE = '24px';
const OPEN_SANS_2XL_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_2XL_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_2XL_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_2XL_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_2XL_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_2XL_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_2XL_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_2XL_BOLD_LINE_HEIGHT = '140%';
const OPEN_SANS_2XL_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_2XL_BOLD_PARAGRAPH_SPACING = '24px';
const OPEN_SANS_2XL_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_2XL_EXTRABOLD_FONT_SIZE = '24px';
const OPEN_SANS_2XL_EXTRABOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_2XL_EXTRABOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_2XL_EXTRABOLD_FONT_WEIGHT = 800;
const OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE = 'normal';
const OPEN_SANS_2XL_EXTRABOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE_OLD = 'ExtraBold';
const OPEN_SANS_2XL_EXTRABOLD_LETTER_SPACING = 0;
const OPEN_SANS_2XL_EXTRABOLD_LINE_HEIGHT = '140%';
const OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_SPACING = '24px';
const OPEN_SANS_2XL_EXTRABOLD_TEXT_CASE = 'none';
const OPEN_SANS_XL_FONT_SIZE = '20px';
const OPEN_SANS_XL_TEXT_DECORATION = 'none';
const OPEN_SANS_XL_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_XL_FONT_WEIGHT = 400;
const OPEN_SANS_XL_FONT_STYLE = 'normal';
const OPEN_SANS_XL_FONT_STRETCH = 'normal';
const OPEN_SANS_XL_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_XL_LETTER_SPACING = 0;
const OPEN_SANS_XL_LINE_HEIGHT = '150%';
const OPEN_SANS_XL_PARAGRAPH_INDENT = 0;
const OPEN_SANS_XL_PARAGRAPH_SPACING = '20px';
const OPEN_SANS_XL_TEXT_CASE = 'none';
const OPEN_SANS_XL_BOLD_FONT_SIZE = '20px';
const OPEN_SANS_XL_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_XL_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_XL_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_XL_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_XL_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_XL_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_XL_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_XL_BOLD_LINE_HEIGHT = '150%';
const OPEN_SANS_XL_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_XL_BOLD_PARAGRAPH_SPACING = '20px';
const OPEN_SANS_XL_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_L_FONT_SIZE = '18px';
const OPEN_SANS_L_TEXT_DECORATION = 'none';
const OPEN_SANS_L_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_L_FONT_WEIGHT = 400;
const OPEN_SANS_L_FONT_STYLE = 'normal';
const OPEN_SANS_L_FONT_STRETCH = 'normal';
const OPEN_SANS_L_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_L_LETTER_SPACING = 0;
const OPEN_SANS_L_LINE_HEIGHT = '150%';
const OPEN_SANS_L_PARAGRAPH_INDENT = 0;
const OPEN_SANS_L_PARAGRAPH_SPACING = '18px';
const OPEN_SANS_L_TEXT_CASE = 'none';
const OPEN_SANS_L_BOLD_FONT_SIZE = '18px';
const OPEN_SANS_L_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_L_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_L_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_L_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_L_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_L_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_L_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_L_BOLD_LINE_HEIGHT = '150%';
const OPEN_SANS_L_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_L_BOLD_PARAGRAPH_SPACING = '18px';
const OPEN_SANS_L_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_M_FONT_SIZE = '16px';
const OPEN_SANS_M_TEXT_DECORATION = 'none';
const OPEN_SANS_M_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_M_FONT_WEIGHT = 400;
const OPEN_SANS_M_FONT_STYLE = 'normal';
const OPEN_SANS_M_FONT_STRETCH = 'normal';
const OPEN_SANS_M_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_M_LETTER_SPACING = 0;
const OPEN_SANS_M_LINE_HEIGHT = '150%';
const OPEN_SANS_M_PARAGRAPH_INDENT = 0;
const OPEN_SANS_M_PARAGRAPH_SPACING = '16px';
const OPEN_SANS_M_TEXT_CASE = 'none';
const OPEN_SANS_M_BOLD_FONT_SIZE = '16px';
const OPEN_SANS_M_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_M_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_M_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_M_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_M_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_M_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_M_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_M_BOLD_LINE_HEIGHT = '150%';
const OPEN_SANS_M_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_M_BOLD_PARAGRAPH_SPACING = '16px';
const OPEN_SANS_M_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_M_AC_FONT_SIZE = '16px';
const OPEN_SANS_M_AC_TEXT_DECORATION = 'none';
const OPEN_SANS_M_AC_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_M_AC_FONT_WEIGHT = 400;
const OPEN_SANS_M_AC_FONT_STYLE = 'normal';
const OPEN_SANS_M_AC_FONT_STRETCH = 'normal';
const OPEN_SANS_M_AC_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_M_AC_LETTER_SPACING = '0.01em';
const OPEN_SANS_M_AC_LINE_HEIGHT = '150%';
const OPEN_SANS_M_AC_PARAGRAPH_INDENT = 0;
const OPEN_SANS_M_AC_PARAGRAPH_SPACING = '16px';
const OPEN_SANS_M_AC_TEXT_CASE = 'uppercase';
const OPEN_SANS_M_BOLD_AC_FONT_SIZE = '16px';
const OPEN_SANS_M_BOLD_AC_TEXT_DECORATION = 'none';
const OPEN_SANS_M_BOLD_AC_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_M_BOLD_AC_FONT_WEIGHT = 700;
const OPEN_SANS_M_BOLD_AC_FONT_STYLE = 'normal';
const OPEN_SANS_M_BOLD_AC_FONT_STRETCH = 'normal';
const OPEN_SANS_M_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_M_BOLD_AC_LETTER_SPACING = '0.01em';
const OPEN_SANS_M_BOLD_AC_LINE_HEIGHT = '150%';
const OPEN_SANS_M_BOLD_AC_PARAGRAPH_INDENT = 0;
const OPEN_SANS_M_BOLD_AC_PARAGRAPH_SPACING = '16px';
const OPEN_SANS_M_BOLD_AC_TEXT_CASE = 'uppercase';
const OPEN_SANS_S_FONT_SIZE = '14px';
const OPEN_SANS_S_TEXT_DECORATION = 'none';
const OPEN_SANS_S_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_S_FONT_WEIGHT = 400;
const OPEN_SANS_S_FONT_STYLE = 'normal';
const OPEN_SANS_S_FONT_STRETCH = 'normal';
const OPEN_SANS_S_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_S_LETTER_SPACING = 0;
const OPEN_SANS_S_LINE_HEIGHT = '150%';
const OPEN_SANS_S_PARAGRAPH_INDENT = 0;
const OPEN_SANS_S_PARAGRAPH_SPACING = '14px';
const OPEN_SANS_S_TEXT_CASE = 'none';
const OPEN_SANS_S_BOLD_FONT_SIZE = '14px';
const OPEN_SANS_S_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_S_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_S_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_S_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_S_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_S_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_S_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_S_BOLD_LINE_HEIGHT = '150%';
const OPEN_SANS_S_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_S_BOLD_PARAGRAPH_SPACING = '14px';
const OPEN_SANS_S_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_S_AC_FONT_SIZE = '14px';
const OPEN_SANS_S_AC_TEXT_DECORATION = 'none';
const OPEN_SANS_S_AC_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_S_AC_FONT_WEIGHT = 400;
const OPEN_SANS_S_AC_FONT_STYLE = 'normal';
const OPEN_SANS_S_AC_FONT_STRETCH = 'normal';
const OPEN_SANS_S_AC_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_S_AC_LETTER_SPACING = '0.01em';
const OPEN_SANS_S_AC_LINE_HEIGHT = '150%';
const OPEN_SANS_S_AC_PARAGRAPH_INDENT = 0;
const OPEN_SANS_S_AC_PARAGRAPH_SPACING = '14px';
const OPEN_SANS_S_AC_TEXT_CASE = 'uppercase';
const OPEN_SANS_S_BOLD_AC_FONT_SIZE = '14px';
const OPEN_SANS_S_BOLD_AC_TEXT_DECORATION = 'none';
const OPEN_SANS_S_BOLD_AC_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_S_BOLD_AC_FONT_WEIGHT = 700;
const OPEN_SANS_S_BOLD_AC_FONT_STYLE = 'normal';
const OPEN_SANS_S_BOLD_AC_FONT_STRETCH = 'normal';
const OPEN_SANS_S_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_S_BOLD_AC_LETTER_SPACING = '0.01em';
const OPEN_SANS_S_BOLD_AC_LINE_HEIGHT = '150%';
const OPEN_SANS_S_BOLD_AC_PARAGRAPH_INDENT = 0;
const OPEN_SANS_S_BOLD_AC_PARAGRAPH_SPACING = '14px';
const OPEN_SANS_S_BOLD_AC_TEXT_CASE = 'uppercase';
const OPEN_SANS_XS_FONT_SIZE = '12px';
const OPEN_SANS_XS_TEXT_DECORATION = 'none';
const OPEN_SANS_XS_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_XS_FONT_WEIGHT = 400;
const OPEN_SANS_XS_FONT_STYLE = 'normal';
const OPEN_SANS_XS_FONT_STRETCH = 'normal';
const OPEN_SANS_XS_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_XS_LETTER_SPACING = 0;
const OPEN_SANS_XS_LINE_HEIGHT = '150%';
const OPEN_SANS_XS_PARAGRAPH_INDENT = 0;
const OPEN_SANS_XS_PARAGRAPH_SPACING = '12px';
const OPEN_SANS_XS_TEXT_CASE = 'none';
const OPEN_SANS_XS_BOLD_FONT_SIZE = '12px';
const OPEN_SANS_XS_BOLD_TEXT_DECORATION = 'none';
const OPEN_SANS_XS_BOLD_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_XS_BOLD_FONT_WEIGHT = 700;
const OPEN_SANS_XS_BOLD_FONT_STYLE = 'normal';
const OPEN_SANS_XS_BOLD_FONT_STRETCH = 'normal';
const OPEN_SANS_XS_BOLD_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_XS_BOLD_LETTER_SPACING = 0;
const OPEN_SANS_XS_BOLD_LINE_HEIGHT = '150%';
const OPEN_SANS_XS_BOLD_PARAGRAPH_INDENT = 0;
const OPEN_SANS_XS_BOLD_PARAGRAPH_SPACING = '12px';
const OPEN_SANS_XS_BOLD_TEXT_CASE = 'none';
const OPEN_SANS_XS_AC_FONT_SIZE = '12px';
const OPEN_SANS_XS_AC_TEXT_DECORATION = 'none';
const OPEN_SANS_XS_AC_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_XS_AC_FONT_WEIGHT = 400;
const OPEN_SANS_XS_AC_FONT_STYLE = 'normal';
const OPEN_SANS_XS_AC_FONT_STRETCH = 'normal';
const OPEN_SANS_XS_AC_FONT_STYLE_OLD = 'Regular';
const OPEN_SANS_XS_AC_LETTER_SPACING = '0.01em';
const OPEN_SANS_XS_AC_LINE_HEIGHT = '150%';
const OPEN_SANS_XS_AC_PARAGRAPH_INDENT = 0;
const OPEN_SANS_XS_AC_PARAGRAPH_SPACING = '12px';
const OPEN_SANS_XS_AC_TEXT_CASE = 'uppercase';
const OPEN_SANS_XS_BOLD_AC_FONT_SIZE = '12px';
const OPEN_SANS_XS_BOLD_AC_TEXT_DECORATION = 'none';
const OPEN_SANS_XS_BOLD_AC_FONT_FAMILY = 'Open Sans';
const OPEN_SANS_XS_BOLD_AC_FONT_WEIGHT = 700;
const OPEN_SANS_XS_BOLD_AC_FONT_STYLE = 'normal';
const OPEN_SANS_XS_BOLD_AC_FONT_STRETCH = 'normal';
const OPEN_SANS_XS_BOLD_AC_FONT_STYLE_OLD = 'Bold';
const OPEN_SANS_XS_BOLD_AC_LETTER_SPACING = '0.01em';
const OPEN_SANS_XS_BOLD_AC_LINE_HEIGHT = '150%';
const OPEN_SANS_XS_BOLD_AC_PARAGRAPH_INDENT = 0;
const OPEN_SANS_XS_BOLD_AC_PARAGRAPH_SPACING = '12px';
const OPEN_SANS_XS_BOLD_AC_TEXT_CASE = 'uppercase';
const YLE_SANS_7XL_BLACK_FONT_SIZE = '56px';
const YLE_SANS_7XL_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_7XL_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_7XL_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_7XL_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_7XL_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_7XL_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_7XL_BLACK_LETTER_SPACING = 0;
const YLE_SANS_7XL_BLACK_LINE_HEIGHT = '120%';
const YLE_SANS_7XL_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_7XL_BLACK_PARAGRAPH_SPACING = '56px';
const YLE_SANS_7XL_BLACK_TEXT_CASE = 'none';
const YLE_SANS_6XL_BLACK_FONT_SIZE = '48px';
const YLE_SANS_6XL_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_6XL_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_6XL_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_6XL_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_6XL_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_6XL_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_6XL_BLACK_LETTER_SPACING = 0;
const YLE_SANS_6XL_BLACK_LINE_HEIGHT = '120%';
const YLE_SANS_6XL_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_6XL_BLACK_PARAGRAPH_SPACING = '48px';
const YLE_SANS_6XL_BLACK_TEXT_CASE = 'none';
const YLE_SANS_5XL_BLACK_FONT_SIZE = '40px';
const YLE_SANS_5XL_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_5XL_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_5XL_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_5XL_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_5XL_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_5XL_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_5XL_BLACK_LETTER_SPACING = 0;
const YLE_SANS_5XL_BLACK_LINE_HEIGHT = '120%';
const YLE_SANS_5XL_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_5XL_BLACK_PARAGRAPH_SPACING = '40px';
const YLE_SANS_5XL_BLACK_TEXT_CASE = 'none';
const YLE_SANS_4XL_BOLD_FONT_SIZE = '32px';
const YLE_SANS_4XL_BOLD_TEXT_DECORATION = 'none';
const YLE_SANS_4XL_BOLD_FONT_FAMILY = 'Yle';
const YLE_SANS_4XL_BOLD_FONT_WEIGHT = 700;
const YLE_SANS_4XL_BOLD_FONT_STYLE = 'normal';
const YLE_SANS_4XL_BOLD_FONT_STRETCH = 'normal';
const YLE_SANS_4XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_SANS_4XL_BOLD_LETTER_SPACING = 0;
const YLE_SANS_4XL_BOLD_LINE_HEIGHT = '120%';
const YLE_SANS_4XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_SANS_4XL_BOLD_PARAGRAPH_SPACING = '32px';
const YLE_SANS_4XL_BOLD_TEXT_CASE = 'none';
const YLE_SANS_4XL_BLACK_FONT_SIZE = '32px';
const YLE_SANS_4XL_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_4XL_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_4XL_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_4XL_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_4XL_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_4XL_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_4XL_BLACK_LETTER_SPACING = 0;
const YLE_SANS_4XL_BLACK_LINE_HEIGHT = '120%';
const YLE_SANS_4XL_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_4XL_BLACK_PARAGRAPH_SPACING = '32px';
const YLE_SANS_4XL_BLACK_TEXT_CASE = 'none';
const YLE_SANS_3XL_BOLD_FONT_SIZE = '28px';
const YLE_SANS_3XL_BOLD_TEXT_DECORATION = 'none';
const YLE_SANS_3XL_BOLD_FONT_FAMILY = 'Yle';
const YLE_SANS_3XL_BOLD_FONT_WEIGHT = 700;
const YLE_SANS_3XL_BOLD_FONT_STYLE = 'normal';
const YLE_SANS_3XL_BOLD_FONT_STRETCH = 'normal';
const YLE_SANS_3XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_SANS_3XL_BOLD_LETTER_SPACING = 0;
const YLE_SANS_3XL_BOLD_LINE_HEIGHT = '130%';
const YLE_SANS_3XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_SANS_3XL_BOLD_PARAGRAPH_SPACING = '28px';
const YLE_SANS_3XL_BOLD_TEXT_CASE = 'none';
const YLE_SANS_3XL_BLACK_FONT_SIZE = '28px';
const YLE_SANS_3XL_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_3XL_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_3XL_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_3XL_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_3XL_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_3XL_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_3XL_BLACK_LETTER_SPACING = 0;
const YLE_SANS_3XL_BLACK_LINE_HEIGHT = '130%';
const YLE_SANS_3XL_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_3XL_BLACK_PARAGRAPH_SPACING = '28px';
const YLE_SANS_3XL_BLACK_TEXT_CASE = 'none';
const YLE_SANS_2XL_BOLD_FONT_SIZE = '24px';
const YLE_SANS_2XL_BOLD_TEXT_DECORATION = 'none';
const YLE_SANS_2XL_BOLD_FONT_FAMILY = 'Yle';
const YLE_SANS_2XL_BOLD_FONT_WEIGHT = 700;
const YLE_SANS_2XL_BOLD_FONT_STYLE = 'normal';
const YLE_SANS_2XL_BOLD_FONT_STRETCH = 'normal';
const YLE_SANS_2XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_SANS_2XL_BOLD_LETTER_SPACING = 0;
const YLE_SANS_2XL_BOLD_LINE_HEIGHT = '130%';
const YLE_SANS_2XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_SANS_2XL_BOLD_PARAGRAPH_SPACING = '24px';
const YLE_SANS_2XL_BOLD_TEXT_CASE = 'none';
const YLE_SANS_2XL_BLACK_FONT_SIZE = '24px';
const YLE_SANS_2XL_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_2XL_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_2XL_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_2XL_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_2XL_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_2XL_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_2XL_BLACK_LETTER_SPACING = 0;
const YLE_SANS_2XL_BLACK_LINE_HEIGHT = '130%';
const YLE_SANS_2XL_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_2XL_BLACK_PARAGRAPH_SPACING = '24px';
const YLE_SANS_2XL_BLACK_TEXT_CASE = 'none';
const YLE_SANS_XL_BOLD_FONT_SIZE = '20px';
const YLE_SANS_XL_BOLD_TEXT_DECORATION = 'none';
const YLE_SANS_XL_BOLD_FONT_FAMILY = 'Yle';
const YLE_SANS_XL_BOLD_FONT_WEIGHT = 700;
const YLE_SANS_XL_BOLD_FONT_STYLE = 'normal';
const YLE_SANS_XL_BOLD_FONT_STRETCH = 'normal';
const YLE_SANS_XL_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_SANS_XL_BOLD_LETTER_SPACING = 0;
const YLE_SANS_XL_BOLD_LINE_HEIGHT = '140%';
const YLE_SANS_XL_BOLD_PARAGRAPH_INDENT = 0;
const YLE_SANS_XL_BOLD_PARAGRAPH_SPACING = '20px';
const YLE_SANS_XL_BOLD_TEXT_CASE = 'none';
const YLE_SANS_L_BOLD_FONT_SIZE = '18px';
const YLE_SANS_L_BOLD_TEXT_DECORATION = 'none';
const YLE_SANS_L_BOLD_FONT_FAMILY = 'Yle';
const YLE_SANS_L_BOLD_FONT_WEIGHT = 700;
const YLE_SANS_L_BOLD_FONT_STYLE = 'normal';
const YLE_SANS_L_BOLD_FONT_STRETCH = 'normal';
const YLE_SANS_L_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_SANS_L_BOLD_LETTER_SPACING = 0;
const YLE_SANS_L_BOLD_LINE_HEIGHT = '140%';
const YLE_SANS_L_BOLD_PARAGRAPH_INDENT = 0;
const YLE_SANS_L_BOLD_PARAGRAPH_SPACING = '18px';
const YLE_SANS_L_BOLD_TEXT_CASE = 'none';
const YLE_SANS_XL_BLACK_FONT_SIZE = '20px';
const YLE_SANS_XL_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_XL_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_XL_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_XL_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_XL_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_XL_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_XL_BLACK_LETTER_SPACING = 0;
const YLE_SANS_XL_BLACK_LINE_HEIGHT = '140%';
const YLE_SANS_XL_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_XL_BLACK_PARAGRAPH_SPACING = '20px';
const YLE_SANS_XL_BLACK_TEXT_CASE = 'none';
const YLE_SANS_L_BLACK_FONT_SIZE = '18px';
const YLE_SANS_L_BLACK_TEXT_DECORATION = 'none';
const YLE_SANS_L_BLACK_FONT_FAMILY = 'Yle';
const YLE_SANS_L_BLACK_FONT_WEIGHT = 900;
const YLE_SANS_L_BLACK_FONT_STYLE = 'normal';
const YLE_SANS_L_BLACK_FONT_STRETCH = 'normal';
const YLE_SANS_L_BLACK_FONT_STYLE_OLD = 'Black';
const YLE_SANS_L_BLACK_LETTER_SPACING = 0;
const YLE_SANS_L_BLACK_LINE_HEIGHT = '140%';
const YLE_SANS_L_BLACK_PARAGRAPH_INDENT = 0;
const YLE_SANS_L_BLACK_PARAGRAPH_SPACING = '18px';
const YLE_SANS_L_BLACK_TEXT_CASE = 'none';
const YLE_SANS_M_BOLD_FONT_SIZE = '16px';
const YLE_SANS_M_BOLD_TEXT_DECORATION = 'none';
const YLE_SANS_M_BOLD_FONT_FAMILY = 'Yle';
const YLE_SANS_M_BOLD_FONT_WEIGHT = 700;
const YLE_SANS_M_BOLD_FONT_STYLE = 'normal';
const YLE_SANS_M_BOLD_FONT_STRETCH = 'normal';
const YLE_SANS_M_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_SANS_M_BOLD_LETTER_SPACING = 0;
const YLE_SANS_M_BOLD_LINE_HEIGHT = '140%';
const YLE_SANS_M_BOLD_PARAGRAPH_INDENT = 0;
const YLE_SANS_M_BOLD_PARAGRAPH_SPACING = '16px';
const YLE_SANS_M_BOLD_TEXT_CASE = 'none';
const YLE_SANS_S_BOLD_FONT_SIZE = '14px';
const YLE_SANS_S_BOLD_TEXT_DECORATION = 'none';
const YLE_SANS_S_BOLD_FONT_FAMILY = 'Yle';
const YLE_SANS_S_BOLD_FONT_WEIGHT = 700;
const YLE_SANS_S_BOLD_FONT_STYLE = 'normal';
const YLE_SANS_S_BOLD_FONT_STRETCH = 'normal';
const YLE_SANS_S_BOLD_FONT_STYLE_OLD = 'Bold';
const YLE_SANS_S_BOLD_LETTER_SPACING = 0;
const YLE_SANS_S_BOLD_LINE_HEIGHT = '140%';
const YLE_SANS_S_BOLD_PARAGRAPH_INDENT = 0;
const YLE_SANS_S_BOLD_PARAGRAPH_SPACING = '14px';
const YLE_SANS_S_BOLD_TEXT_CASE = 'none';

var typography = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_2XL_BOLD_FONT_FAMILY: DEFAULT_2XL_BOLD_FONT_FAMILY,
  DEFAULT_2XL_BOLD_FONT_SIZE: DEFAULT_2XL_BOLD_FONT_SIZE,
  DEFAULT_2XL_BOLD_FONT_STRETCH: DEFAULT_2XL_BOLD_FONT_STRETCH,
  DEFAULT_2XL_BOLD_FONT_STYLE: DEFAULT_2XL_BOLD_FONT_STYLE,
  DEFAULT_2XL_BOLD_FONT_STYLE_OLD: DEFAULT_2XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_2XL_BOLD_FONT_WEIGHT: DEFAULT_2XL_BOLD_FONT_WEIGHT,
  DEFAULT_2XL_BOLD_LETTER_SPACING: DEFAULT_2XL_BOLD_LETTER_SPACING,
  DEFAULT_2XL_BOLD_LINE_HEIGHT: DEFAULT_2XL_BOLD_LINE_HEIGHT,
  DEFAULT_2XL_BOLD_PARAGRAPH_INDENT: DEFAULT_2XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_2XL_BOLD_PARAGRAPH_SPACING: DEFAULT_2XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_2XL_BOLD_TEXT_CASE: DEFAULT_2XL_BOLD_TEXT_CASE,
  DEFAULT_2XL_BOLD_TEXT_DECORATION: DEFAULT_2XL_BOLD_TEXT_DECORATION,
  DEFAULT_2XL_FONT_FAMILY: DEFAULT_2XL_FONT_FAMILY,
  DEFAULT_2XL_FONT_SIZE: DEFAULT_2XL_FONT_SIZE,
  DEFAULT_2XL_FONT_STRETCH: DEFAULT_2XL_FONT_STRETCH,
  DEFAULT_2XL_FONT_STYLE: DEFAULT_2XL_FONT_STYLE,
  DEFAULT_2XL_FONT_STYLE_OLD: DEFAULT_2XL_FONT_STYLE_OLD,
  DEFAULT_2XL_FONT_WEIGHT: DEFAULT_2XL_FONT_WEIGHT,
  DEFAULT_2XL_HEAVY_FONT_FAMILY: DEFAULT_2XL_HEAVY_FONT_FAMILY,
  DEFAULT_2XL_HEAVY_FONT_SIZE: DEFAULT_2XL_HEAVY_FONT_SIZE,
  DEFAULT_2XL_HEAVY_FONT_STRETCH: DEFAULT_2XL_HEAVY_FONT_STRETCH,
  DEFAULT_2XL_HEAVY_FONT_STYLE: DEFAULT_2XL_HEAVY_FONT_STYLE,
  DEFAULT_2XL_HEAVY_FONT_STYLE_OLD: DEFAULT_2XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_2XL_HEAVY_FONT_WEIGHT: DEFAULT_2XL_HEAVY_FONT_WEIGHT,
  DEFAULT_2XL_HEAVY_LETTER_SPACING: DEFAULT_2XL_HEAVY_LETTER_SPACING,
  DEFAULT_2XL_HEAVY_LINE_HEIGHT: DEFAULT_2XL_HEAVY_LINE_HEIGHT,
  DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_2XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_2XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_2XL_HEAVY_TEXT_CASE: DEFAULT_2XL_HEAVY_TEXT_CASE,
  DEFAULT_2XL_HEAVY_TEXT_DECORATION: DEFAULT_2XL_HEAVY_TEXT_DECORATION,
  DEFAULT_2XL_LETTER_SPACING: DEFAULT_2XL_LETTER_SPACING,
  DEFAULT_2XL_LINE_HEIGHT: DEFAULT_2XL_LINE_HEIGHT,
  DEFAULT_2XL_PARAGRAPH_INDENT: DEFAULT_2XL_PARAGRAPH_INDENT,
  DEFAULT_2XL_PARAGRAPH_SPACING: DEFAULT_2XL_PARAGRAPH_SPACING,
  DEFAULT_2XL_TEXT_CASE: DEFAULT_2XL_TEXT_CASE,
  DEFAULT_2XL_TEXT_DECORATION: DEFAULT_2XL_TEXT_DECORATION,
  DEFAULT_3XL_BOLD_FONT_FAMILY: DEFAULT_3XL_BOLD_FONT_FAMILY,
  DEFAULT_3XL_BOLD_FONT_SIZE: DEFAULT_3XL_BOLD_FONT_SIZE,
  DEFAULT_3XL_BOLD_FONT_STRETCH: DEFAULT_3XL_BOLD_FONT_STRETCH,
  DEFAULT_3XL_BOLD_FONT_STYLE: DEFAULT_3XL_BOLD_FONT_STYLE,
  DEFAULT_3XL_BOLD_FONT_STYLE_OLD: DEFAULT_3XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_3XL_BOLD_FONT_WEIGHT: DEFAULT_3XL_BOLD_FONT_WEIGHT,
  DEFAULT_3XL_BOLD_LETTER_SPACING: DEFAULT_3XL_BOLD_LETTER_SPACING,
  DEFAULT_3XL_BOLD_LINE_HEIGHT: DEFAULT_3XL_BOLD_LINE_HEIGHT,
  DEFAULT_3XL_BOLD_PARAGRAPH_INDENT: DEFAULT_3XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_3XL_BOLD_PARAGRAPH_SPACING: DEFAULT_3XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_3XL_BOLD_TEXT_CASE: DEFAULT_3XL_BOLD_TEXT_CASE,
  DEFAULT_3XL_BOLD_TEXT_DECORATION: DEFAULT_3XL_BOLD_TEXT_DECORATION,
  DEFAULT_3XL_HEAVY_FONT_FAMILY: DEFAULT_3XL_HEAVY_FONT_FAMILY,
  DEFAULT_3XL_HEAVY_FONT_SIZE: DEFAULT_3XL_HEAVY_FONT_SIZE,
  DEFAULT_3XL_HEAVY_FONT_STRETCH: DEFAULT_3XL_HEAVY_FONT_STRETCH,
  DEFAULT_3XL_HEAVY_FONT_STYLE: DEFAULT_3XL_HEAVY_FONT_STYLE,
  DEFAULT_3XL_HEAVY_FONT_STYLE_OLD: DEFAULT_3XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_3XL_HEAVY_FONT_WEIGHT: DEFAULT_3XL_HEAVY_FONT_WEIGHT,
  DEFAULT_3XL_HEAVY_LETTER_SPACING: DEFAULT_3XL_HEAVY_LETTER_SPACING,
  DEFAULT_3XL_HEAVY_LINE_HEIGHT: DEFAULT_3XL_HEAVY_LINE_HEIGHT,
  DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_3XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_3XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_3XL_HEAVY_TEXT_CASE: DEFAULT_3XL_HEAVY_TEXT_CASE,
  DEFAULT_3XL_HEAVY_TEXT_DECORATION: DEFAULT_3XL_HEAVY_TEXT_DECORATION,
  DEFAULT_4XL_BOLD_FONT_FAMILY: DEFAULT_4XL_BOLD_FONT_FAMILY,
  DEFAULT_4XL_BOLD_FONT_SIZE: DEFAULT_4XL_BOLD_FONT_SIZE,
  DEFAULT_4XL_BOLD_FONT_STRETCH: DEFAULT_4XL_BOLD_FONT_STRETCH,
  DEFAULT_4XL_BOLD_FONT_STYLE: DEFAULT_4XL_BOLD_FONT_STYLE,
  DEFAULT_4XL_BOLD_FONT_STYLE_OLD: DEFAULT_4XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_4XL_BOLD_FONT_WEIGHT: DEFAULT_4XL_BOLD_FONT_WEIGHT,
  DEFAULT_4XL_BOLD_LETTER_SPACING: DEFAULT_4XL_BOLD_LETTER_SPACING,
  DEFAULT_4XL_BOLD_LINE_HEIGHT: DEFAULT_4XL_BOLD_LINE_HEIGHT,
  DEFAULT_4XL_BOLD_PARAGRAPH_INDENT: DEFAULT_4XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_4XL_BOLD_PARAGRAPH_SPACING: DEFAULT_4XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_4XL_BOLD_TEXT_CASE: DEFAULT_4XL_BOLD_TEXT_CASE,
  DEFAULT_4XL_BOLD_TEXT_DECORATION: DEFAULT_4XL_BOLD_TEXT_DECORATION,
  DEFAULT_4XL_HEAVY_FONT_FAMILY: DEFAULT_4XL_HEAVY_FONT_FAMILY,
  DEFAULT_4XL_HEAVY_FONT_SIZE: DEFAULT_4XL_HEAVY_FONT_SIZE,
  DEFAULT_4XL_HEAVY_FONT_STRETCH: DEFAULT_4XL_HEAVY_FONT_STRETCH,
  DEFAULT_4XL_HEAVY_FONT_STYLE: DEFAULT_4XL_HEAVY_FONT_STYLE,
  DEFAULT_4XL_HEAVY_FONT_STYLE_OLD: DEFAULT_4XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_4XL_HEAVY_FONT_WEIGHT: DEFAULT_4XL_HEAVY_FONT_WEIGHT,
  DEFAULT_4XL_HEAVY_LETTER_SPACING: DEFAULT_4XL_HEAVY_LETTER_SPACING,
  DEFAULT_4XL_HEAVY_LINE_HEIGHT: DEFAULT_4XL_HEAVY_LINE_HEIGHT,
  DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_4XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_4XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_4XL_HEAVY_TEXT_CASE: DEFAULT_4XL_HEAVY_TEXT_CASE,
  DEFAULT_4XL_HEAVY_TEXT_DECORATION: DEFAULT_4XL_HEAVY_TEXT_DECORATION,
  DEFAULT_5XL_BOLD_FONT_FAMILY: DEFAULT_5XL_BOLD_FONT_FAMILY,
  DEFAULT_5XL_BOLD_FONT_SIZE: DEFAULT_5XL_BOLD_FONT_SIZE,
  DEFAULT_5XL_BOLD_FONT_STRETCH: DEFAULT_5XL_BOLD_FONT_STRETCH,
  DEFAULT_5XL_BOLD_FONT_STYLE: DEFAULT_5XL_BOLD_FONT_STYLE,
  DEFAULT_5XL_BOLD_FONT_STYLE_OLD: DEFAULT_5XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_5XL_BOLD_FONT_WEIGHT: DEFAULT_5XL_BOLD_FONT_WEIGHT,
  DEFAULT_5XL_BOLD_LETTER_SPACING: DEFAULT_5XL_BOLD_LETTER_SPACING,
  DEFAULT_5XL_BOLD_LINE_HEIGHT: DEFAULT_5XL_BOLD_LINE_HEIGHT,
  DEFAULT_5XL_BOLD_PARAGRAPH_INDENT: DEFAULT_5XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_5XL_BOLD_PARAGRAPH_SPACING: DEFAULT_5XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_5XL_BOLD_TEXT_CASE: DEFAULT_5XL_BOLD_TEXT_CASE,
  DEFAULT_5XL_BOLD_TEXT_DECORATION: DEFAULT_5XL_BOLD_TEXT_DECORATION,
  DEFAULT_5XL_HEAVY_FONT_FAMILY: DEFAULT_5XL_HEAVY_FONT_FAMILY,
  DEFAULT_5XL_HEAVY_FONT_SIZE: DEFAULT_5XL_HEAVY_FONT_SIZE,
  DEFAULT_5XL_HEAVY_FONT_STRETCH: DEFAULT_5XL_HEAVY_FONT_STRETCH,
  DEFAULT_5XL_HEAVY_FONT_STYLE: DEFAULT_5XL_HEAVY_FONT_STYLE,
  DEFAULT_5XL_HEAVY_FONT_STYLE_OLD: DEFAULT_5XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_5XL_HEAVY_FONT_WEIGHT: DEFAULT_5XL_HEAVY_FONT_WEIGHT,
  DEFAULT_5XL_HEAVY_LETTER_SPACING: DEFAULT_5XL_HEAVY_LETTER_SPACING,
  DEFAULT_5XL_HEAVY_LINE_HEIGHT: DEFAULT_5XL_HEAVY_LINE_HEIGHT,
  DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_5XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_5XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_5XL_HEAVY_TEXT_CASE: DEFAULT_5XL_HEAVY_TEXT_CASE,
  DEFAULT_5XL_HEAVY_TEXT_DECORATION: DEFAULT_5XL_HEAVY_TEXT_DECORATION,
  DEFAULT_6XL_BOLD_FONT_FAMILY: DEFAULT_6XL_BOLD_FONT_FAMILY,
  DEFAULT_6XL_BOLD_FONT_SIZE: DEFAULT_6XL_BOLD_FONT_SIZE,
  DEFAULT_6XL_BOLD_FONT_STRETCH: DEFAULT_6XL_BOLD_FONT_STRETCH,
  DEFAULT_6XL_BOLD_FONT_STYLE: DEFAULT_6XL_BOLD_FONT_STYLE,
  DEFAULT_6XL_BOLD_FONT_STYLE_OLD: DEFAULT_6XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_6XL_BOLD_FONT_WEIGHT: DEFAULT_6XL_BOLD_FONT_WEIGHT,
  DEFAULT_6XL_BOLD_LETTER_SPACING: DEFAULT_6XL_BOLD_LETTER_SPACING,
  DEFAULT_6XL_BOLD_LINE_HEIGHT: DEFAULT_6XL_BOLD_LINE_HEIGHT,
  DEFAULT_6XL_BOLD_PARAGRAPH_INDENT: DEFAULT_6XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_6XL_BOLD_PARAGRAPH_SPACING: DEFAULT_6XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_6XL_BOLD_TEXT_CASE: DEFAULT_6XL_BOLD_TEXT_CASE,
  DEFAULT_6XL_BOLD_TEXT_DECORATION: DEFAULT_6XL_BOLD_TEXT_DECORATION,
  DEFAULT_6XL_HEAVY_FONT_FAMILY: DEFAULT_6XL_HEAVY_FONT_FAMILY,
  DEFAULT_6XL_HEAVY_FONT_SIZE: DEFAULT_6XL_HEAVY_FONT_SIZE,
  DEFAULT_6XL_HEAVY_FONT_STRETCH: DEFAULT_6XL_HEAVY_FONT_STRETCH,
  DEFAULT_6XL_HEAVY_FONT_STYLE: DEFAULT_6XL_HEAVY_FONT_STYLE,
  DEFAULT_6XL_HEAVY_FONT_STYLE_OLD: DEFAULT_6XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_6XL_HEAVY_FONT_WEIGHT: DEFAULT_6XL_HEAVY_FONT_WEIGHT,
  DEFAULT_6XL_HEAVY_LETTER_SPACING: DEFAULT_6XL_HEAVY_LETTER_SPACING,
  DEFAULT_6XL_HEAVY_LINE_HEIGHT: DEFAULT_6XL_HEAVY_LINE_HEIGHT,
  DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_6XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_6XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_6XL_HEAVY_TEXT_CASE: DEFAULT_6XL_HEAVY_TEXT_CASE,
  DEFAULT_6XL_HEAVY_TEXT_DECORATION: DEFAULT_6XL_HEAVY_TEXT_DECORATION,
  DEFAULT_7XL_BOLD_FONT_FAMILY: DEFAULT_7XL_BOLD_FONT_FAMILY,
  DEFAULT_7XL_BOLD_FONT_SIZE: DEFAULT_7XL_BOLD_FONT_SIZE,
  DEFAULT_7XL_BOLD_FONT_STRETCH: DEFAULT_7XL_BOLD_FONT_STRETCH,
  DEFAULT_7XL_BOLD_FONT_STYLE: DEFAULT_7XL_BOLD_FONT_STYLE,
  DEFAULT_7XL_BOLD_FONT_STYLE_OLD: DEFAULT_7XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_7XL_BOLD_FONT_WEIGHT: DEFAULT_7XL_BOLD_FONT_WEIGHT,
  DEFAULT_7XL_BOLD_LETTER_SPACING: DEFAULT_7XL_BOLD_LETTER_SPACING,
  DEFAULT_7XL_BOLD_LINE_HEIGHT: DEFAULT_7XL_BOLD_LINE_HEIGHT,
  DEFAULT_7XL_BOLD_PARAGRAPH_INDENT: DEFAULT_7XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_7XL_BOLD_PARAGRAPH_SPACING: DEFAULT_7XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_7XL_BOLD_TEXT_CASE: DEFAULT_7XL_BOLD_TEXT_CASE,
  DEFAULT_7XL_BOLD_TEXT_DECORATION: DEFAULT_7XL_BOLD_TEXT_DECORATION,
  DEFAULT_7XL_HEAVY_FONT_FAMILY: DEFAULT_7XL_HEAVY_FONT_FAMILY,
  DEFAULT_7XL_HEAVY_FONT_SIZE: DEFAULT_7XL_HEAVY_FONT_SIZE,
  DEFAULT_7XL_HEAVY_FONT_STRETCH: DEFAULT_7XL_HEAVY_FONT_STRETCH,
  DEFAULT_7XL_HEAVY_FONT_STYLE: DEFAULT_7XL_HEAVY_FONT_STYLE,
  DEFAULT_7XL_HEAVY_FONT_STYLE_OLD: DEFAULT_7XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_7XL_HEAVY_FONT_WEIGHT: DEFAULT_7XL_HEAVY_FONT_WEIGHT,
  DEFAULT_7XL_HEAVY_LETTER_SPACING: DEFAULT_7XL_HEAVY_LETTER_SPACING,
  DEFAULT_7XL_HEAVY_LINE_HEIGHT: DEFAULT_7XL_HEAVY_LINE_HEIGHT,
  DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_7XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_7XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_7XL_HEAVY_TEXT_CASE: DEFAULT_7XL_HEAVY_TEXT_CASE,
  DEFAULT_7XL_HEAVY_TEXT_DECORATION: DEFAULT_7XL_HEAVY_TEXT_DECORATION,
  DEFAULT_L_BOLD_FONT_FAMILY: DEFAULT_L_BOLD_FONT_FAMILY,
  DEFAULT_L_BOLD_FONT_SIZE: DEFAULT_L_BOLD_FONT_SIZE,
  DEFAULT_L_BOLD_FONT_STRETCH: DEFAULT_L_BOLD_FONT_STRETCH,
  DEFAULT_L_BOLD_FONT_STYLE: DEFAULT_L_BOLD_FONT_STYLE,
  DEFAULT_L_BOLD_FONT_STYLE_OLD: DEFAULT_L_BOLD_FONT_STYLE_OLD,
  DEFAULT_L_BOLD_FONT_WEIGHT: DEFAULT_L_BOLD_FONT_WEIGHT,
  DEFAULT_L_BOLD_LETTER_SPACING: DEFAULT_L_BOLD_LETTER_SPACING,
  DEFAULT_L_BOLD_LINE_HEIGHT: DEFAULT_L_BOLD_LINE_HEIGHT,
  DEFAULT_L_BOLD_PARAGRAPH_INDENT: DEFAULT_L_BOLD_PARAGRAPH_INDENT,
  DEFAULT_L_BOLD_PARAGRAPH_SPACING: DEFAULT_L_BOLD_PARAGRAPH_SPACING,
  DEFAULT_L_BOLD_TEXT_CASE: DEFAULT_L_BOLD_TEXT_CASE,
  DEFAULT_L_BOLD_TEXT_DECORATION: DEFAULT_L_BOLD_TEXT_DECORATION,
  DEFAULT_L_FONT_FAMILY: DEFAULT_L_FONT_FAMILY,
  DEFAULT_L_FONT_SIZE: DEFAULT_L_FONT_SIZE,
  DEFAULT_L_FONT_STRETCH: DEFAULT_L_FONT_STRETCH,
  DEFAULT_L_FONT_STYLE: DEFAULT_L_FONT_STYLE,
  DEFAULT_L_FONT_STYLE_OLD: DEFAULT_L_FONT_STYLE_OLD,
  DEFAULT_L_FONT_WEIGHT: DEFAULT_L_FONT_WEIGHT,
  DEFAULT_L_HEAVY_FONT_FAMILY: DEFAULT_L_HEAVY_FONT_FAMILY,
  DEFAULT_L_HEAVY_FONT_SIZE: DEFAULT_L_HEAVY_FONT_SIZE,
  DEFAULT_L_HEAVY_FONT_STRETCH: DEFAULT_L_HEAVY_FONT_STRETCH,
  DEFAULT_L_HEAVY_FONT_STYLE: DEFAULT_L_HEAVY_FONT_STYLE,
  DEFAULT_L_HEAVY_FONT_STYLE_OLD: DEFAULT_L_HEAVY_FONT_STYLE_OLD,
  DEFAULT_L_HEAVY_FONT_WEIGHT: DEFAULT_L_HEAVY_FONT_WEIGHT,
  DEFAULT_L_HEAVY_LETTER_SPACING: DEFAULT_L_HEAVY_LETTER_SPACING,
  DEFAULT_L_HEAVY_LINE_HEIGHT: DEFAULT_L_HEAVY_LINE_HEIGHT,
  DEFAULT_L_HEAVY_PARAGRAPH_INDENT: DEFAULT_L_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_L_HEAVY_PARAGRAPH_SPACING: DEFAULT_L_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_L_HEAVY_TEXT_CASE: DEFAULT_L_HEAVY_TEXT_CASE,
  DEFAULT_L_HEAVY_TEXT_DECORATION: DEFAULT_L_HEAVY_TEXT_DECORATION,
  DEFAULT_L_ITALIC_FONT_FAMILY: DEFAULT_L_ITALIC_FONT_FAMILY,
  DEFAULT_L_ITALIC_FONT_SIZE: DEFAULT_L_ITALIC_FONT_SIZE,
  DEFAULT_L_ITALIC_FONT_STRETCH: DEFAULT_L_ITALIC_FONT_STRETCH,
  DEFAULT_L_ITALIC_FONT_STYLE: DEFAULT_L_ITALIC_FONT_STYLE,
  DEFAULT_L_ITALIC_FONT_STYLE_OLD: DEFAULT_L_ITALIC_FONT_STYLE_OLD,
  DEFAULT_L_ITALIC_FONT_WEIGHT: DEFAULT_L_ITALIC_FONT_WEIGHT,
  DEFAULT_L_ITALIC_LETTER_SPACING: DEFAULT_L_ITALIC_LETTER_SPACING,
  DEFAULT_L_ITALIC_LINE_HEIGHT: DEFAULT_L_ITALIC_LINE_HEIGHT,
  DEFAULT_L_ITALIC_PARAGRAPH_INDENT: DEFAULT_L_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_L_ITALIC_PARAGRAPH_SPACING: DEFAULT_L_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_L_ITALIC_TEXT_CASE: DEFAULT_L_ITALIC_TEXT_CASE,
  DEFAULT_L_ITALIC_TEXT_DECORATION: DEFAULT_L_ITALIC_TEXT_DECORATION,
  DEFAULT_L_LETTER_SPACING: DEFAULT_L_LETTER_SPACING,
  DEFAULT_L_LINE_HEIGHT: DEFAULT_L_LINE_HEIGHT,
  DEFAULT_L_PARAGRAPH_INDENT: DEFAULT_L_PARAGRAPH_INDENT,
  DEFAULT_L_PARAGRAPH_SPACING: DEFAULT_L_PARAGRAPH_SPACING,
  DEFAULT_L_TEXT_CASE: DEFAULT_L_TEXT_CASE,
  DEFAULT_L_TEXT_DECORATION: DEFAULT_L_TEXT_DECORATION,
  DEFAULT_M_AC_FONT_FAMILY: DEFAULT_M_AC_FONT_FAMILY,
  DEFAULT_M_AC_FONT_SIZE: DEFAULT_M_AC_FONT_SIZE,
  DEFAULT_M_AC_FONT_STRETCH: DEFAULT_M_AC_FONT_STRETCH,
  DEFAULT_M_AC_FONT_STYLE: DEFAULT_M_AC_FONT_STYLE,
  DEFAULT_M_AC_FONT_STYLE_OLD: DEFAULT_M_AC_FONT_STYLE_OLD,
  DEFAULT_M_AC_FONT_WEIGHT: DEFAULT_M_AC_FONT_WEIGHT,
  DEFAULT_M_AC_LETTER_SPACING: DEFAULT_M_AC_LETTER_SPACING,
  DEFAULT_M_AC_LINE_HEIGHT: DEFAULT_M_AC_LINE_HEIGHT,
  DEFAULT_M_AC_PARAGRAPH_INDENT: DEFAULT_M_AC_PARAGRAPH_INDENT,
  DEFAULT_M_AC_PARAGRAPH_SPACING: DEFAULT_M_AC_PARAGRAPH_SPACING,
  DEFAULT_M_AC_TEXT_CASE: DEFAULT_M_AC_TEXT_CASE,
  DEFAULT_M_AC_TEXT_DECORATION: DEFAULT_M_AC_TEXT_DECORATION,
  DEFAULT_M_BOLD_AC_FONT_FAMILY: DEFAULT_M_BOLD_AC_FONT_FAMILY,
  DEFAULT_M_BOLD_AC_FONT_SIZE: DEFAULT_M_BOLD_AC_FONT_SIZE,
  DEFAULT_M_BOLD_AC_FONT_STRETCH: DEFAULT_M_BOLD_AC_FONT_STRETCH,
  DEFAULT_M_BOLD_AC_FONT_STYLE: DEFAULT_M_BOLD_AC_FONT_STYLE,
  DEFAULT_M_BOLD_AC_FONT_STYLE_OLD: DEFAULT_M_BOLD_AC_FONT_STYLE_OLD,
  DEFAULT_M_BOLD_AC_FONT_WEIGHT: DEFAULT_M_BOLD_AC_FONT_WEIGHT,
  DEFAULT_M_BOLD_AC_LETTER_SPACING: DEFAULT_M_BOLD_AC_LETTER_SPACING,
  DEFAULT_M_BOLD_AC_LINE_HEIGHT: DEFAULT_M_BOLD_AC_LINE_HEIGHT,
  DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_M_BOLD_AC_PARAGRAPH_INDENT,
  DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_M_BOLD_AC_PARAGRAPH_SPACING,
  DEFAULT_M_BOLD_AC_TEXT_CASE: DEFAULT_M_BOLD_AC_TEXT_CASE,
  DEFAULT_M_BOLD_AC_TEXT_DECORATION: DEFAULT_M_BOLD_AC_TEXT_DECORATION,
  DEFAULT_M_BOLD_FONT_FAMILY: DEFAULT_M_BOLD_FONT_FAMILY,
  DEFAULT_M_BOLD_FONT_SIZE: DEFAULT_M_BOLD_FONT_SIZE,
  DEFAULT_M_BOLD_FONT_STRETCH: DEFAULT_M_BOLD_FONT_STRETCH,
  DEFAULT_M_BOLD_FONT_STYLE: DEFAULT_M_BOLD_FONT_STYLE,
  DEFAULT_M_BOLD_FONT_STYLE_OLD: DEFAULT_M_BOLD_FONT_STYLE_OLD,
  DEFAULT_M_BOLD_FONT_WEIGHT: DEFAULT_M_BOLD_FONT_WEIGHT,
  DEFAULT_M_BOLD_LETTER_SPACING: DEFAULT_M_BOLD_LETTER_SPACING,
  DEFAULT_M_BOLD_LINE_HEIGHT: DEFAULT_M_BOLD_LINE_HEIGHT,
  DEFAULT_M_BOLD_PARAGRAPH_INDENT: DEFAULT_M_BOLD_PARAGRAPH_INDENT,
  DEFAULT_M_BOLD_PARAGRAPH_SPACING: DEFAULT_M_BOLD_PARAGRAPH_SPACING,
  DEFAULT_M_BOLD_TEXT_CASE: DEFAULT_M_BOLD_TEXT_CASE,
  DEFAULT_M_BOLD_TEXT_DECORATION: DEFAULT_M_BOLD_TEXT_DECORATION,
  DEFAULT_M_FONT_FAMILY: DEFAULT_M_FONT_FAMILY,
  DEFAULT_M_FONT_SIZE: DEFAULT_M_FONT_SIZE,
  DEFAULT_M_FONT_STRETCH: DEFAULT_M_FONT_STRETCH,
  DEFAULT_M_FONT_STYLE: DEFAULT_M_FONT_STYLE,
  DEFAULT_M_FONT_STYLE_OLD: DEFAULT_M_FONT_STYLE_OLD,
  DEFAULT_M_FONT_WEIGHT: DEFAULT_M_FONT_WEIGHT,
  DEFAULT_M_ITALIC_FONT_FAMILY: DEFAULT_M_ITALIC_FONT_FAMILY,
  DEFAULT_M_ITALIC_FONT_SIZE: DEFAULT_M_ITALIC_FONT_SIZE,
  DEFAULT_M_ITALIC_FONT_STRETCH: DEFAULT_M_ITALIC_FONT_STRETCH,
  DEFAULT_M_ITALIC_FONT_STYLE: DEFAULT_M_ITALIC_FONT_STYLE,
  DEFAULT_M_ITALIC_FONT_STYLE_OLD: DEFAULT_M_ITALIC_FONT_STYLE_OLD,
  DEFAULT_M_ITALIC_FONT_WEIGHT: DEFAULT_M_ITALIC_FONT_WEIGHT,
  DEFAULT_M_ITALIC_LETTER_SPACING: DEFAULT_M_ITALIC_LETTER_SPACING,
  DEFAULT_M_ITALIC_LINE_HEIGHT: DEFAULT_M_ITALIC_LINE_HEIGHT,
  DEFAULT_M_ITALIC_PARAGRAPH_INDENT: DEFAULT_M_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_M_ITALIC_PARAGRAPH_SPACING: DEFAULT_M_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_M_ITALIC_TEXT_CASE: DEFAULT_M_ITALIC_TEXT_CASE,
  DEFAULT_M_ITALIC_TEXT_DECORATION: DEFAULT_M_ITALIC_TEXT_DECORATION,
  DEFAULT_M_LETTER_SPACING: DEFAULT_M_LETTER_SPACING,
  DEFAULT_M_LINE_HEIGHT: DEFAULT_M_LINE_HEIGHT,
  DEFAULT_M_MEDIUM_FONT_FAMILY: DEFAULT_M_MEDIUM_FONT_FAMILY,
  DEFAULT_M_MEDIUM_FONT_SIZE: DEFAULT_M_MEDIUM_FONT_SIZE,
  DEFAULT_M_MEDIUM_FONT_STRETCH: DEFAULT_M_MEDIUM_FONT_STRETCH,
  DEFAULT_M_MEDIUM_FONT_STYLE: DEFAULT_M_MEDIUM_FONT_STYLE,
  DEFAULT_M_MEDIUM_FONT_STYLE_OLD: DEFAULT_M_MEDIUM_FONT_STYLE_OLD,
  DEFAULT_M_MEDIUM_FONT_WEIGHT: DEFAULT_M_MEDIUM_FONT_WEIGHT,
  DEFAULT_M_MEDIUM_LETTER_SPACING: DEFAULT_M_MEDIUM_LETTER_SPACING,
  DEFAULT_M_MEDIUM_LINE_HEIGHT: DEFAULT_M_MEDIUM_LINE_HEIGHT,
  DEFAULT_M_MEDIUM_PARAGRAPH_INDENT: DEFAULT_M_MEDIUM_PARAGRAPH_INDENT,
  DEFAULT_M_MEDIUM_PARAGRAPH_SPACING: DEFAULT_M_MEDIUM_PARAGRAPH_SPACING,
  DEFAULT_M_MEDIUM_TEXT_CASE: DEFAULT_M_MEDIUM_TEXT_CASE,
  DEFAULT_M_MEDIUM_TEXT_DECORATION: DEFAULT_M_MEDIUM_TEXT_DECORATION,
  DEFAULT_M_PARAGRAPH_INDENT: DEFAULT_M_PARAGRAPH_INDENT,
  DEFAULT_M_PARAGRAPH_SPACING: DEFAULT_M_PARAGRAPH_SPACING,
  DEFAULT_M_TEXT_CASE: DEFAULT_M_TEXT_CASE,
  DEFAULT_M_TEXT_DECORATION: DEFAULT_M_TEXT_DECORATION,
  DEFAULT_S_AC_FONT_FAMILY: DEFAULT_S_AC_FONT_FAMILY,
  DEFAULT_S_AC_FONT_SIZE: DEFAULT_S_AC_FONT_SIZE,
  DEFAULT_S_AC_FONT_STRETCH: DEFAULT_S_AC_FONT_STRETCH,
  DEFAULT_S_AC_FONT_STYLE: DEFAULT_S_AC_FONT_STYLE,
  DEFAULT_S_AC_FONT_STYLE_OLD: DEFAULT_S_AC_FONT_STYLE_OLD,
  DEFAULT_S_AC_FONT_WEIGHT: DEFAULT_S_AC_FONT_WEIGHT,
  DEFAULT_S_AC_LETTER_SPACING: DEFAULT_S_AC_LETTER_SPACING,
  DEFAULT_S_AC_LINE_HEIGHT: DEFAULT_S_AC_LINE_HEIGHT,
  DEFAULT_S_AC_PARAGRAPH_INDENT: DEFAULT_S_AC_PARAGRAPH_INDENT,
  DEFAULT_S_AC_PARAGRAPH_SPACING: DEFAULT_S_AC_PARAGRAPH_SPACING,
  DEFAULT_S_AC_TEXT_CASE: DEFAULT_S_AC_TEXT_CASE,
  DEFAULT_S_AC_TEXT_DECORATION: DEFAULT_S_AC_TEXT_DECORATION,
  DEFAULT_S_BOLD_AC_FONT_FAMILY: DEFAULT_S_BOLD_AC_FONT_FAMILY,
  DEFAULT_S_BOLD_AC_FONT_SIZE: DEFAULT_S_BOLD_AC_FONT_SIZE,
  DEFAULT_S_BOLD_AC_FONT_STRETCH: DEFAULT_S_BOLD_AC_FONT_STRETCH,
  DEFAULT_S_BOLD_AC_FONT_STYLE: DEFAULT_S_BOLD_AC_FONT_STYLE,
  DEFAULT_S_BOLD_AC_FONT_STYLE_OLD: DEFAULT_S_BOLD_AC_FONT_STYLE_OLD,
  DEFAULT_S_BOLD_AC_FONT_WEIGHT: DEFAULT_S_BOLD_AC_FONT_WEIGHT,
  DEFAULT_S_BOLD_AC_LETTER_SPACING: DEFAULT_S_BOLD_AC_LETTER_SPACING,
  DEFAULT_S_BOLD_AC_LINE_HEIGHT: DEFAULT_S_BOLD_AC_LINE_HEIGHT,
  DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_S_BOLD_AC_PARAGRAPH_INDENT,
  DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_S_BOLD_AC_PARAGRAPH_SPACING,
  DEFAULT_S_BOLD_AC_TEXT_CASE: DEFAULT_S_BOLD_AC_TEXT_CASE,
  DEFAULT_S_BOLD_AC_TEXT_DECORATION: DEFAULT_S_BOLD_AC_TEXT_DECORATION,
  DEFAULT_S_BOLD_FONT_FAMILY: DEFAULT_S_BOLD_FONT_FAMILY,
  DEFAULT_S_BOLD_FONT_SIZE: DEFAULT_S_BOLD_FONT_SIZE,
  DEFAULT_S_BOLD_FONT_STRETCH: DEFAULT_S_BOLD_FONT_STRETCH,
  DEFAULT_S_BOLD_FONT_STYLE: DEFAULT_S_BOLD_FONT_STYLE,
  DEFAULT_S_BOLD_FONT_STYLE_OLD: DEFAULT_S_BOLD_FONT_STYLE_OLD,
  DEFAULT_S_BOLD_FONT_WEIGHT: DEFAULT_S_BOLD_FONT_WEIGHT,
  DEFAULT_S_BOLD_LETTER_SPACING: DEFAULT_S_BOLD_LETTER_SPACING,
  DEFAULT_S_BOLD_LINE_HEIGHT: DEFAULT_S_BOLD_LINE_HEIGHT,
  DEFAULT_S_BOLD_PARAGRAPH_INDENT: DEFAULT_S_BOLD_PARAGRAPH_INDENT,
  DEFAULT_S_BOLD_PARAGRAPH_SPACING: DEFAULT_S_BOLD_PARAGRAPH_SPACING,
  DEFAULT_S_BOLD_TEXT_CASE: DEFAULT_S_BOLD_TEXT_CASE,
  DEFAULT_S_BOLD_TEXT_DECORATION: DEFAULT_S_BOLD_TEXT_DECORATION,
  DEFAULT_S_FONT_FAMILY: DEFAULT_S_FONT_FAMILY,
  DEFAULT_S_FONT_SIZE: DEFAULT_S_FONT_SIZE,
  DEFAULT_S_FONT_STRETCH: DEFAULT_S_FONT_STRETCH,
  DEFAULT_S_FONT_STYLE: DEFAULT_S_FONT_STYLE,
  DEFAULT_S_FONT_STYLE_OLD: DEFAULT_S_FONT_STYLE_OLD,
  DEFAULT_S_FONT_WEIGHT: DEFAULT_S_FONT_WEIGHT,
  DEFAULT_S_ITALIC_FONT_FAMILY: DEFAULT_S_ITALIC_FONT_FAMILY,
  DEFAULT_S_ITALIC_FONT_SIZE: DEFAULT_S_ITALIC_FONT_SIZE,
  DEFAULT_S_ITALIC_FONT_STRETCH: DEFAULT_S_ITALIC_FONT_STRETCH,
  DEFAULT_S_ITALIC_FONT_STYLE: DEFAULT_S_ITALIC_FONT_STYLE,
  DEFAULT_S_ITALIC_FONT_STYLE_OLD: DEFAULT_S_ITALIC_FONT_STYLE_OLD,
  DEFAULT_S_ITALIC_FONT_WEIGHT: DEFAULT_S_ITALIC_FONT_WEIGHT,
  DEFAULT_S_ITALIC_LETTER_SPACING: DEFAULT_S_ITALIC_LETTER_SPACING,
  DEFAULT_S_ITALIC_LINE_HEIGHT: DEFAULT_S_ITALIC_LINE_HEIGHT,
  DEFAULT_S_ITALIC_PARAGRAPH_INDENT: DEFAULT_S_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_S_ITALIC_PARAGRAPH_SPACING: DEFAULT_S_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_S_ITALIC_TEXT_CASE: DEFAULT_S_ITALIC_TEXT_CASE,
  DEFAULT_S_ITALIC_TEXT_DECORATION: DEFAULT_S_ITALIC_TEXT_DECORATION,
  DEFAULT_S_LETTER_SPACING: DEFAULT_S_LETTER_SPACING,
  DEFAULT_S_LINE_HEIGHT: DEFAULT_S_LINE_HEIGHT,
  DEFAULT_S_PARAGRAPH_INDENT: DEFAULT_S_PARAGRAPH_INDENT,
  DEFAULT_S_PARAGRAPH_SPACING: DEFAULT_S_PARAGRAPH_SPACING,
  DEFAULT_S_TEXT_CASE: DEFAULT_S_TEXT_CASE,
  DEFAULT_S_TEXT_DECORATION: DEFAULT_S_TEXT_DECORATION,
  DEFAULT_XL_BOLD_FONT_FAMILY: DEFAULT_XL_BOLD_FONT_FAMILY,
  DEFAULT_XL_BOLD_FONT_SIZE: DEFAULT_XL_BOLD_FONT_SIZE,
  DEFAULT_XL_BOLD_FONT_STRETCH: DEFAULT_XL_BOLD_FONT_STRETCH,
  DEFAULT_XL_BOLD_FONT_STYLE: DEFAULT_XL_BOLD_FONT_STYLE,
  DEFAULT_XL_BOLD_FONT_STYLE_OLD: DEFAULT_XL_BOLD_FONT_STYLE_OLD,
  DEFAULT_XL_BOLD_FONT_WEIGHT: DEFAULT_XL_BOLD_FONT_WEIGHT,
  DEFAULT_XL_BOLD_LETTER_SPACING: DEFAULT_XL_BOLD_LETTER_SPACING,
  DEFAULT_XL_BOLD_LINE_HEIGHT: DEFAULT_XL_BOLD_LINE_HEIGHT,
  DEFAULT_XL_BOLD_PARAGRAPH_INDENT: DEFAULT_XL_BOLD_PARAGRAPH_INDENT,
  DEFAULT_XL_BOLD_PARAGRAPH_SPACING: DEFAULT_XL_BOLD_PARAGRAPH_SPACING,
  DEFAULT_XL_BOLD_TEXT_CASE: DEFAULT_XL_BOLD_TEXT_CASE,
  DEFAULT_XL_BOLD_TEXT_DECORATION: DEFAULT_XL_BOLD_TEXT_DECORATION,
  DEFAULT_XL_FONT_FAMILY: DEFAULT_XL_FONT_FAMILY,
  DEFAULT_XL_FONT_SIZE: DEFAULT_XL_FONT_SIZE,
  DEFAULT_XL_FONT_STRETCH: DEFAULT_XL_FONT_STRETCH,
  DEFAULT_XL_FONT_STYLE: DEFAULT_XL_FONT_STYLE,
  DEFAULT_XL_FONT_STYLE_OLD: DEFAULT_XL_FONT_STYLE_OLD,
  DEFAULT_XL_FONT_WEIGHT: DEFAULT_XL_FONT_WEIGHT,
  DEFAULT_XL_HEAVY_FONT_FAMILY: DEFAULT_XL_HEAVY_FONT_FAMILY,
  DEFAULT_XL_HEAVY_FONT_SIZE: DEFAULT_XL_HEAVY_FONT_SIZE,
  DEFAULT_XL_HEAVY_FONT_STRETCH: DEFAULT_XL_HEAVY_FONT_STRETCH,
  DEFAULT_XL_HEAVY_FONT_STYLE: DEFAULT_XL_HEAVY_FONT_STYLE,
  DEFAULT_XL_HEAVY_FONT_STYLE_OLD: DEFAULT_XL_HEAVY_FONT_STYLE_OLD,
  DEFAULT_XL_HEAVY_FONT_WEIGHT: DEFAULT_XL_HEAVY_FONT_WEIGHT,
  DEFAULT_XL_HEAVY_LETTER_SPACING: DEFAULT_XL_HEAVY_LETTER_SPACING,
  DEFAULT_XL_HEAVY_LINE_HEIGHT: DEFAULT_XL_HEAVY_LINE_HEIGHT,
  DEFAULT_XL_HEAVY_PARAGRAPH_INDENT: DEFAULT_XL_HEAVY_PARAGRAPH_INDENT,
  DEFAULT_XL_HEAVY_PARAGRAPH_SPACING: DEFAULT_XL_HEAVY_PARAGRAPH_SPACING,
  DEFAULT_XL_HEAVY_TEXT_CASE: DEFAULT_XL_HEAVY_TEXT_CASE,
  DEFAULT_XL_HEAVY_TEXT_DECORATION: DEFAULT_XL_HEAVY_TEXT_DECORATION,
  DEFAULT_XL_ITALIC_FONT_FAMILY: DEFAULT_XL_ITALIC_FONT_FAMILY,
  DEFAULT_XL_ITALIC_FONT_SIZE: DEFAULT_XL_ITALIC_FONT_SIZE,
  DEFAULT_XL_ITALIC_FONT_STRETCH: DEFAULT_XL_ITALIC_FONT_STRETCH,
  DEFAULT_XL_ITALIC_FONT_STYLE: DEFAULT_XL_ITALIC_FONT_STYLE,
  DEFAULT_XL_ITALIC_FONT_STYLE_OLD: DEFAULT_XL_ITALIC_FONT_STYLE_OLD,
  DEFAULT_XL_ITALIC_FONT_WEIGHT: DEFAULT_XL_ITALIC_FONT_WEIGHT,
  DEFAULT_XL_ITALIC_LETTER_SPACING: DEFAULT_XL_ITALIC_LETTER_SPACING,
  DEFAULT_XL_ITALIC_LINE_HEIGHT: DEFAULT_XL_ITALIC_LINE_HEIGHT,
  DEFAULT_XL_ITALIC_PARAGRAPH_INDENT: DEFAULT_XL_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_XL_ITALIC_PARAGRAPH_SPACING: DEFAULT_XL_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_XL_ITALIC_TEXT_CASE: DEFAULT_XL_ITALIC_TEXT_CASE,
  DEFAULT_XL_ITALIC_TEXT_DECORATION: DEFAULT_XL_ITALIC_TEXT_DECORATION,
  DEFAULT_XL_LETTER_SPACING: DEFAULT_XL_LETTER_SPACING,
  DEFAULT_XL_LINE_HEIGHT: DEFAULT_XL_LINE_HEIGHT,
  DEFAULT_XL_PARAGRAPH_INDENT: DEFAULT_XL_PARAGRAPH_INDENT,
  DEFAULT_XL_PARAGRAPH_SPACING: DEFAULT_XL_PARAGRAPH_SPACING,
  DEFAULT_XL_TEXT_CASE: DEFAULT_XL_TEXT_CASE,
  DEFAULT_XL_TEXT_DECORATION: DEFAULT_XL_TEXT_DECORATION,
  DEFAULT_XS_AC_FONT_FAMILY: DEFAULT_XS_AC_FONT_FAMILY,
  DEFAULT_XS_AC_FONT_SIZE: DEFAULT_XS_AC_FONT_SIZE,
  DEFAULT_XS_AC_FONT_STRETCH: DEFAULT_XS_AC_FONT_STRETCH,
  DEFAULT_XS_AC_FONT_STYLE: DEFAULT_XS_AC_FONT_STYLE,
  DEFAULT_XS_AC_FONT_STYLE_OLD: DEFAULT_XS_AC_FONT_STYLE_OLD,
  DEFAULT_XS_AC_FONT_WEIGHT: DEFAULT_XS_AC_FONT_WEIGHT,
  DEFAULT_XS_AC_LETTER_SPACING: DEFAULT_XS_AC_LETTER_SPACING,
  DEFAULT_XS_AC_LINE_HEIGHT: DEFAULT_XS_AC_LINE_HEIGHT,
  DEFAULT_XS_AC_PARAGRAPH_INDENT: DEFAULT_XS_AC_PARAGRAPH_INDENT,
  DEFAULT_XS_AC_PARAGRAPH_SPACING: DEFAULT_XS_AC_PARAGRAPH_SPACING,
  DEFAULT_XS_AC_TEXT_CASE: DEFAULT_XS_AC_TEXT_CASE,
  DEFAULT_XS_AC_TEXT_DECORATION: DEFAULT_XS_AC_TEXT_DECORATION,
  DEFAULT_XS_BOLD_AC_FONT_FAMILY: DEFAULT_XS_BOLD_AC_FONT_FAMILY,
  DEFAULT_XS_BOLD_AC_FONT_SIZE: DEFAULT_XS_BOLD_AC_FONT_SIZE,
  DEFAULT_XS_BOLD_AC_FONT_STRETCH: DEFAULT_XS_BOLD_AC_FONT_STRETCH,
  DEFAULT_XS_BOLD_AC_FONT_STYLE: DEFAULT_XS_BOLD_AC_FONT_STYLE,
  DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD: DEFAULT_XS_BOLD_AC_FONT_STYLE_OLD,
  DEFAULT_XS_BOLD_AC_FONT_WEIGHT: DEFAULT_XS_BOLD_AC_FONT_WEIGHT,
  DEFAULT_XS_BOLD_AC_LETTER_SPACING: DEFAULT_XS_BOLD_AC_LETTER_SPACING,
  DEFAULT_XS_BOLD_AC_LINE_HEIGHT: DEFAULT_XS_BOLD_AC_LINE_HEIGHT,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_AC_PARAGRAPH_INDENT,
  DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_AC_PARAGRAPH_SPACING,
  DEFAULT_XS_BOLD_AC_TEXT_CASE: DEFAULT_XS_BOLD_AC_TEXT_CASE,
  DEFAULT_XS_BOLD_AC_TEXT_DECORATION: DEFAULT_XS_BOLD_AC_TEXT_DECORATION,
  DEFAULT_XS_BOLD_FONT_FAMILY: DEFAULT_XS_BOLD_FONT_FAMILY,
  DEFAULT_XS_BOLD_FONT_SIZE: DEFAULT_XS_BOLD_FONT_SIZE,
  DEFAULT_XS_BOLD_FONT_STRETCH: DEFAULT_XS_BOLD_FONT_STRETCH,
  DEFAULT_XS_BOLD_FONT_STYLE: DEFAULT_XS_BOLD_FONT_STYLE,
  DEFAULT_XS_BOLD_FONT_STYLE_OLD: DEFAULT_XS_BOLD_FONT_STYLE_OLD,
  DEFAULT_XS_BOLD_FONT_WEIGHT: DEFAULT_XS_BOLD_FONT_WEIGHT,
  DEFAULT_XS_BOLD_LETTER_SPACING: DEFAULT_XS_BOLD_LETTER_SPACING,
  DEFAULT_XS_BOLD_LINE_HEIGHT: DEFAULT_XS_BOLD_LINE_HEIGHT,
  DEFAULT_XS_BOLD_PARAGRAPH_INDENT: DEFAULT_XS_BOLD_PARAGRAPH_INDENT,
  DEFAULT_XS_BOLD_PARAGRAPH_SPACING: DEFAULT_XS_BOLD_PARAGRAPH_SPACING,
  DEFAULT_XS_BOLD_TEXT_CASE: DEFAULT_XS_BOLD_TEXT_CASE,
  DEFAULT_XS_BOLD_TEXT_DECORATION: DEFAULT_XS_BOLD_TEXT_DECORATION,
  DEFAULT_XS_FONT_FAMILY: DEFAULT_XS_FONT_FAMILY,
  DEFAULT_XS_FONT_SIZE: DEFAULT_XS_FONT_SIZE,
  DEFAULT_XS_FONT_STRETCH: DEFAULT_XS_FONT_STRETCH,
  DEFAULT_XS_FONT_STYLE: DEFAULT_XS_FONT_STYLE,
  DEFAULT_XS_FONT_STYLE_OLD: DEFAULT_XS_FONT_STYLE_OLD,
  DEFAULT_XS_FONT_WEIGHT: DEFAULT_XS_FONT_WEIGHT,
  DEFAULT_XS_ITALIC_FONT_FAMILY: DEFAULT_XS_ITALIC_FONT_FAMILY,
  DEFAULT_XS_ITALIC_FONT_SIZE: DEFAULT_XS_ITALIC_FONT_SIZE,
  DEFAULT_XS_ITALIC_FONT_STRETCH: DEFAULT_XS_ITALIC_FONT_STRETCH,
  DEFAULT_XS_ITALIC_FONT_STYLE: DEFAULT_XS_ITALIC_FONT_STYLE,
  DEFAULT_XS_ITALIC_FONT_STYLE_OLD: DEFAULT_XS_ITALIC_FONT_STYLE_OLD,
  DEFAULT_XS_ITALIC_FONT_WEIGHT: DEFAULT_XS_ITALIC_FONT_WEIGHT,
  DEFAULT_XS_ITALIC_LETTER_SPACING: DEFAULT_XS_ITALIC_LETTER_SPACING,
  DEFAULT_XS_ITALIC_LINE_HEIGHT: DEFAULT_XS_ITALIC_LINE_HEIGHT,
  DEFAULT_XS_ITALIC_PARAGRAPH_INDENT: DEFAULT_XS_ITALIC_PARAGRAPH_INDENT,
  DEFAULT_XS_ITALIC_PARAGRAPH_SPACING: DEFAULT_XS_ITALIC_PARAGRAPH_SPACING,
  DEFAULT_XS_ITALIC_TEXT_CASE: DEFAULT_XS_ITALIC_TEXT_CASE,
  DEFAULT_XS_ITALIC_TEXT_DECORATION: DEFAULT_XS_ITALIC_TEXT_DECORATION,
  DEFAULT_XS_LETTER_SPACING: DEFAULT_XS_LETTER_SPACING,
  DEFAULT_XS_LINE_HEIGHT: DEFAULT_XS_LINE_HEIGHT,
  DEFAULT_XS_PARAGRAPH_INDENT: DEFAULT_XS_PARAGRAPH_INDENT,
  DEFAULT_XS_PARAGRAPH_SPACING: DEFAULT_XS_PARAGRAPH_SPACING,
  DEFAULT_XS_TEXT_CASE: DEFAULT_XS_TEXT_CASE,
  DEFAULT_XS_TEXT_DECORATION: DEFAULT_XS_TEXT_DECORATION,
  OPEN_SANS_2XL_BOLD_FONT_FAMILY: OPEN_SANS_2XL_BOLD_FONT_FAMILY,
  OPEN_SANS_2XL_BOLD_FONT_SIZE: OPEN_SANS_2XL_BOLD_FONT_SIZE,
  OPEN_SANS_2XL_BOLD_FONT_STRETCH: OPEN_SANS_2XL_BOLD_FONT_STRETCH,
  OPEN_SANS_2XL_BOLD_FONT_STYLE: OPEN_SANS_2XL_BOLD_FONT_STYLE,
  OPEN_SANS_2XL_BOLD_FONT_STYLE_OLD: OPEN_SANS_2XL_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_2XL_BOLD_FONT_WEIGHT: OPEN_SANS_2XL_BOLD_FONT_WEIGHT,
  OPEN_SANS_2XL_BOLD_LETTER_SPACING: OPEN_SANS_2XL_BOLD_LETTER_SPACING,
  OPEN_SANS_2XL_BOLD_LINE_HEIGHT: OPEN_SANS_2XL_BOLD_LINE_HEIGHT,
  OPEN_SANS_2XL_BOLD_PARAGRAPH_INDENT: OPEN_SANS_2XL_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_2XL_BOLD_PARAGRAPH_SPACING: OPEN_SANS_2XL_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_2XL_BOLD_TEXT_CASE: OPEN_SANS_2XL_BOLD_TEXT_CASE,
  OPEN_SANS_2XL_BOLD_TEXT_DECORATION: OPEN_SANS_2XL_BOLD_TEXT_DECORATION,
  OPEN_SANS_2XL_EXTRABOLD_FONT_FAMILY: OPEN_SANS_2XL_EXTRABOLD_FONT_FAMILY,
  OPEN_SANS_2XL_EXTRABOLD_FONT_SIZE: OPEN_SANS_2XL_EXTRABOLD_FONT_SIZE,
  OPEN_SANS_2XL_EXTRABOLD_FONT_STRETCH: OPEN_SANS_2XL_EXTRABOLD_FONT_STRETCH,
  OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE: OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE,
  OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE_OLD: OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE_OLD,
  OPEN_SANS_2XL_EXTRABOLD_FONT_WEIGHT: OPEN_SANS_2XL_EXTRABOLD_FONT_WEIGHT,
  OPEN_SANS_2XL_EXTRABOLD_LETTER_SPACING: OPEN_SANS_2XL_EXTRABOLD_LETTER_SPACING,
  OPEN_SANS_2XL_EXTRABOLD_LINE_HEIGHT: OPEN_SANS_2XL_EXTRABOLD_LINE_HEIGHT,
  OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_INDENT: OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_INDENT,
  OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_SPACING: OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_SPACING,
  OPEN_SANS_2XL_EXTRABOLD_TEXT_CASE: OPEN_SANS_2XL_EXTRABOLD_TEXT_CASE,
  OPEN_SANS_2XL_EXTRABOLD_TEXT_DECORATION: OPEN_SANS_2XL_EXTRABOLD_TEXT_DECORATION,
  OPEN_SANS_2XL_FONT_FAMILY: OPEN_SANS_2XL_FONT_FAMILY,
  OPEN_SANS_2XL_FONT_SIZE: OPEN_SANS_2XL_FONT_SIZE,
  OPEN_SANS_2XL_FONT_STRETCH: OPEN_SANS_2XL_FONT_STRETCH,
  OPEN_SANS_2XL_FONT_STYLE: OPEN_SANS_2XL_FONT_STYLE,
  OPEN_SANS_2XL_FONT_STYLE_OLD: OPEN_SANS_2XL_FONT_STYLE_OLD,
  OPEN_SANS_2XL_FONT_WEIGHT: OPEN_SANS_2XL_FONT_WEIGHT,
  OPEN_SANS_2XL_LETTER_SPACING: OPEN_SANS_2XL_LETTER_SPACING,
  OPEN_SANS_2XL_LINE_HEIGHT: OPEN_SANS_2XL_LINE_HEIGHT,
  OPEN_SANS_2XL_PARAGRAPH_INDENT: OPEN_SANS_2XL_PARAGRAPH_INDENT,
  OPEN_SANS_2XL_PARAGRAPH_SPACING: OPEN_SANS_2XL_PARAGRAPH_SPACING,
  OPEN_SANS_2XL_TEXT_CASE: OPEN_SANS_2XL_TEXT_CASE,
  OPEN_SANS_2XL_TEXT_DECORATION: OPEN_SANS_2XL_TEXT_DECORATION,
  OPEN_SANS_3XL_BOLD_FONT_FAMILY: OPEN_SANS_3XL_BOLD_FONT_FAMILY,
  OPEN_SANS_3XL_BOLD_FONT_SIZE: OPEN_SANS_3XL_BOLD_FONT_SIZE,
  OPEN_SANS_3XL_BOLD_FONT_STRETCH: OPEN_SANS_3XL_BOLD_FONT_STRETCH,
  OPEN_SANS_3XL_BOLD_FONT_STYLE: OPEN_SANS_3XL_BOLD_FONT_STYLE,
  OPEN_SANS_3XL_BOLD_FONT_STYLE_OLD: OPEN_SANS_3XL_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_3XL_BOLD_FONT_WEIGHT: OPEN_SANS_3XL_BOLD_FONT_WEIGHT,
  OPEN_SANS_3XL_BOLD_LETTER_SPACING: OPEN_SANS_3XL_BOLD_LETTER_SPACING,
  OPEN_SANS_3XL_BOLD_LINE_HEIGHT: OPEN_SANS_3XL_BOLD_LINE_HEIGHT,
  OPEN_SANS_3XL_BOLD_PARAGRAPH_INDENT: OPEN_SANS_3XL_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_3XL_BOLD_PARAGRAPH_SPACING: OPEN_SANS_3XL_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_3XL_BOLD_TEXT_CASE: OPEN_SANS_3XL_BOLD_TEXT_CASE,
  OPEN_SANS_3XL_BOLD_TEXT_DECORATION: OPEN_SANS_3XL_BOLD_TEXT_DECORATION,
  OPEN_SANS_3XL_EXTRABOLD_FONT_FAMILY: OPEN_SANS_3XL_EXTRABOLD_FONT_FAMILY,
  OPEN_SANS_3XL_EXTRABOLD_FONT_SIZE: OPEN_SANS_3XL_EXTRABOLD_FONT_SIZE,
  OPEN_SANS_3XL_EXTRABOLD_FONT_STRETCH: OPEN_SANS_3XL_EXTRABOLD_FONT_STRETCH,
  OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE: OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE,
  OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE_OLD: OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE_OLD,
  OPEN_SANS_3XL_EXTRABOLD_FONT_WEIGHT: OPEN_SANS_3XL_EXTRABOLD_FONT_WEIGHT,
  OPEN_SANS_3XL_EXTRABOLD_LETTER_SPACING: OPEN_SANS_3XL_EXTRABOLD_LETTER_SPACING,
  OPEN_SANS_3XL_EXTRABOLD_LINE_HEIGHT: OPEN_SANS_3XL_EXTRABOLD_LINE_HEIGHT,
  OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_INDENT: OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_INDENT,
  OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_SPACING: OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_SPACING,
  OPEN_SANS_3XL_EXTRABOLD_TEXT_CASE: OPEN_SANS_3XL_EXTRABOLD_TEXT_CASE,
  OPEN_SANS_3XL_EXTRABOLD_TEXT_DECORATION: OPEN_SANS_3XL_EXTRABOLD_TEXT_DECORATION,
  OPEN_SANS_4XL_BOLD_FONT_FAMILY: OPEN_SANS_4XL_BOLD_FONT_FAMILY,
  OPEN_SANS_4XL_BOLD_FONT_SIZE: OPEN_SANS_4XL_BOLD_FONT_SIZE,
  OPEN_SANS_4XL_BOLD_FONT_STRETCH: OPEN_SANS_4XL_BOLD_FONT_STRETCH,
  OPEN_SANS_4XL_BOLD_FONT_STYLE: OPEN_SANS_4XL_BOLD_FONT_STYLE,
  OPEN_SANS_4XL_BOLD_FONT_STYLE_OLD: OPEN_SANS_4XL_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_4XL_BOLD_FONT_WEIGHT: OPEN_SANS_4XL_BOLD_FONT_WEIGHT,
  OPEN_SANS_4XL_BOLD_LETTER_SPACING: OPEN_SANS_4XL_BOLD_LETTER_SPACING,
  OPEN_SANS_4XL_BOLD_LINE_HEIGHT: OPEN_SANS_4XL_BOLD_LINE_HEIGHT,
  OPEN_SANS_4XL_BOLD_PARAGRAPH_INDENT: OPEN_SANS_4XL_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_4XL_BOLD_PARAGRAPH_SPACING: OPEN_SANS_4XL_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_4XL_BOLD_TEXT_CASE: OPEN_SANS_4XL_BOLD_TEXT_CASE,
  OPEN_SANS_4XL_BOLD_TEXT_DECORATION: OPEN_SANS_4XL_BOLD_TEXT_DECORATION,
  OPEN_SANS_4XL_EXTRABOLD_FONT_FAMILY: OPEN_SANS_4XL_EXTRABOLD_FONT_FAMILY,
  OPEN_SANS_4XL_EXTRABOLD_FONT_SIZE: OPEN_SANS_4XL_EXTRABOLD_FONT_SIZE,
  OPEN_SANS_4XL_EXTRABOLD_FONT_STRETCH: OPEN_SANS_4XL_EXTRABOLD_FONT_STRETCH,
  OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE: OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE,
  OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE_OLD: OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE_OLD,
  OPEN_SANS_4XL_EXTRABOLD_FONT_WEIGHT: OPEN_SANS_4XL_EXTRABOLD_FONT_WEIGHT,
  OPEN_SANS_4XL_EXTRABOLD_LETTER_SPACING: OPEN_SANS_4XL_EXTRABOLD_LETTER_SPACING,
  OPEN_SANS_4XL_EXTRABOLD_LINE_HEIGHT: OPEN_SANS_4XL_EXTRABOLD_LINE_HEIGHT,
  OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_INDENT: OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_INDENT,
  OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_SPACING: OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_SPACING,
  OPEN_SANS_4XL_EXTRABOLD_TEXT_CASE: OPEN_SANS_4XL_EXTRABOLD_TEXT_CASE,
  OPEN_SANS_4XL_EXTRABOLD_TEXT_DECORATION: OPEN_SANS_4XL_EXTRABOLD_TEXT_DECORATION,
  OPEN_SANS_5XL_BOLD_FONT_FAMILY: OPEN_SANS_5XL_BOLD_FONT_FAMILY,
  OPEN_SANS_5XL_BOLD_FONT_SIZE: OPEN_SANS_5XL_BOLD_FONT_SIZE,
  OPEN_SANS_5XL_BOLD_FONT_STRETCH: OPEN_SANS_5XL_BOLD_FONT_STRETCH,
  OPEN_SANS_5XL_BOLD_FONT_STYLE: OPEN_SANS_5XL_BOLD_FONT_STYLE,
  OPEN_SANS_5XL_BOLD_FONT_STYLE_OLD: OPEN_SANS_5XL_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_5XL_BOLD_FONT_WEIGHT: OPEN_SANS_5XL_BOLD_FONT_WEIGHT,
  OPEN_SANS_5XL_BOLD_LETTER_SPACING: OPEN_SANS_5XL_BOLD_LETTER_SPACING,
  OPEN_SANS_5XL_BOLD_LINE_HEIGHT: OPEN_SANS_5XL_BOLD_LINE_HEIGHT,
  OPEN_SANS_5XL_BOLD_PARAGRAPH_INDENT: OPEN_SANS_5XL_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_5XL_BOLD_PARAGRAPH_SPACING: OPEN_SANS_5XL_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_5XL_BOLD_TEXT_CASE: OPEN_SANS_5XL_BOLD_TEXT_CASE,
  OPEN_SANS_5XL_BOLD_TEXT_DECORATION: OPEN_SANS_5XL_BOLD_TEXT_DECORATION,
  OPEN_SANS_5XL_EXTRABOLD_FONT_FAMILY: OPEN_SANS_5XL_EXTRABOLD_FONT_FAMILY,
  OPEN_SANS_5XL_EXTRABOLD_FONT_SIZE: OPEN_SANS_5XL_EXTRABOLD_FONT_SIZE,
  OPEN_SANS_5XL_EXTRABOLD_FONT_STRETCH: OPEN_SANS_5XL_EXTRABOLD_FONT_STRETCH,
  OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE: OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE,
  OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE_OLD: OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE_OLD,
  OPEN_SANS_5XL_EXTRABOLD_FONT_WEIGHT: OPEN_SANS_5XL_EXTRABOLD_FONT_WEIGHT,
  OPEN_SANS_5XL_EXTRABOLD_LETTER_SPACING: OPEN_SANS_5XL_EXTRABOLD_LETTER_SPACING,
  OPEN_SANS_5XL_EXTRABOLD_LINE_HEIGHT: OPEN_SANS_5XL_EXTRABOLD_LINE_HEIGHT,
  OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_INDENT: OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_INDENT,
  OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_SPACING: OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_SPACING,
  OPEN_SANS_5XL_EXTRABOLD_TEXT_CASE: OPEN_SANS_5XL_EXTRABOLD_TEXT_CASE,
  OPEN_SANS_5XL_EXTRABOLD_TEXT_DECORATION: OPEN_SANS_5XL_EXTRABOLD_TEXT_DECORATION,
  OPEN_SANS_6XL_BOLD_FONT_FAMILY: OPEN_SANS_6XL_BOLD_FONT_FAMILY,
  OPEN_SANS_6XL_BOLD_FONT_SIZE: OPEN_SANS_6XL_BOLD_FONT_SIZE,
  OPEN_SANS_6XL_BOLD_FONT_STRETCH: OPEN_SANS_6XL_BOLD_FONT_STRETCH,
  OPEN_SANS_6XL_BOLD_FONT_STYLE: OPEN_SANS_6XL_BOLD_FONT_STYLE,
  OPEN_SANS_6XL_BOLD_FONT_STYLE_OLD: OPEN_SANS_6XL_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_6XL_BOLD_FONT_WEIGHT: OPEN_SANS_6XL_BOLD_FONT_WEIGHT,
  OPEN_SANS_6XL_BOLD_LETTER_SPACING: OPEN_SANS_6XL_BOLD_LETTER_SPACING,
  OPEN_SANS_6XL_BOLD_LINE_HEIGHT: OPEN_SANS_6XL_BOLD_LINE_HEIGHT,
  OPEN_SANS_6XL_BOLD_PARAGRAPH_INDENT: OPEN_SANS_6XL_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_6XL_BOLD_PARAGRAPH_SPACING: OPEN_SANS_6XL_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_6XL_BOLD_TEXT_CASE: OPEN_SANS_6XL_BOLD_TEXT_CASE,
  OPEN_SANS_6XL_BOLD_TEXT_DECORATION: OPEN_SANS_6XL_BOLD_TEXT_DECORATION,
  OPEN_SANS_6XL_EXTRABOLD_FONT_FAMILY: OPEN_SANS_6XL_EXTRABOLD_FONT_FAMILY,
  OPEN_SANS_6XL_EXTRABOLD_FONT_SIZE: OPEN_SANS_6XL_EXTRABOLD_FONT_SIZE,
  OPEN_SANS_6XL_EXTRABOLD_FONT_STRETCH: OPEN_SANS_6XL_EXTRABOLD_FONT_STRETCH,
  OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE: OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE,
  OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE_OLD: OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE_OLD,
  OPEN_SANS_6XL_EXTRABOLD_FONT_WEIGHT: OPEN_SANS_6XL_EXTRABOLD_FONT_WEIGHT,
  OPEN_SANS_6XL_EXTRABOLD_LETTER_SPACING: OPEN_SANS_6XL_EXTRABOLD_LETTER_SPACING,
  OPEN_SANS_6XL_EXTRABOLD_LINE_HEIGHT: OPEN_SANS_6XL_EXTRABOLD_LINE_HEIGHT,
  OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_INDENT: OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_INDENT,
  OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_SPACING: OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_SPACING,
  OPEN_SANS_6XL_EXTRABOLD_TEXT_CASE: OPEN_SANS_6XL_EXTRABOLD_TEXT_CASE,
  OPEN_SANS_6XL_EXTRABOLD_TEXT_DECORATION: OPEN_SANS_6XL_EXTRABOLD_TEXT_DECORATION,
  OPEN_SANS_7XL_BOLD_FONT_FAMILY: OPEN_SANS_7XL_BOLD_FONT_FAMILY,
  OPEN_SANS_7XL_BOLD_FONT_SIZE: OPEN_SANS_7XL_BOLD_FONT_SIZE,
  OPEN_SANS_7XL_BOLD_FONT_STRETCH: OPEN_SANS_7XL_BOLD_FONT_STRETCH,
  OPEN_SANS_7XL_BOLD_FONT_STYLE: OPEN_SANS_7XL_BOLD_FONT_STYLE,
  OPEN_SANS_7XL_BOLD_FONT_STYLE_OLD: OPEN_SANS_7XL_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_7XL_BOLD_FONT_WEIGHT: OPEN_SANS_7XL_BOLD_FONT_WEIGHT,
  OPEN_SANS_7XL_BOLD_LETTER_SPACING: OPEN_SANS_7XL_BOLD_LETTER_SPACING,
  OPEN_SANS_7XL_BOLD_LINE_HEIGHT: OPEN_SANS_7XL_BOLD_LINE_HEIGHT,
  OPEN_SANS_7XL_BOLD_PARAGRAPH_INDENT: OPEN_SANS_7XL_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_7XL_BOLD_PARAGRAPH_SPACING: OPEN_SANS_7XL_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_7XL_BOLD_TEXT_CASE: OPEN_SANS_7XL_BOLD_TEXT_CASE,
  OPEN_SANS_7XL_BOLD_TEXT_DECORATION: OPEN_SANS_7XL_BOLD_TEXT_DECORATION,
  OPEN_SANS_7XL_EXTRABOLD_FONT_FAMILY: OPEN_SANS_7XL_EXTRABOLD_FONT_FAMILY,
  OPEN_SANS_7XL_EXTRABOLD_FONT_SIZE: OPEN_SANS_7XL_EXTRABOLD_FONT_SIZE,
  OPEN_SANS_7XL_EXTRABOLD_FONT_STRETCH: OPEN_SANS_7XL_EXTRABOLD_FONT_STRETCH,
  OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE: OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE,
  OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE_OLD: OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE_OLD,
  OPEN_SANS_7XL_EXTRABOLD_FONT_WEIGHT: OPEN_SANS_7XL_EXTRABOLD_FONT_WEIGHT,
  OPEN_SANS_7XL_EXTRABOLD_LETTER_SPACING: OPEN_SANS_7XL_EXTRABOLD_LETTER_SPACING,
  OPEN_SANS_7XL_EXTRABOLD_LINE_HEIGHT: OPEN_SANS_7XL_EXTRABOLD_LINE_HEIGHT,
  OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_INDENT: OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_INDENT,
  OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_SPACING: OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_SPACING,
  OPEN_SANS_7XL_EXTRABOLD_TEXT_CASE: OPEN_SANS_7XL_EXTRABOLD_TEXT_CASE,
  OPEN_SANS_7XL_EXTRABOLD_TEXT_DECORATION: OPEN_SANS_7XL_EXTRABOLD_TEXT_DECORATION,
  OPEN_SANS_L_BOLD_FONT_FAMILY: OPEN_SANS_L_BOLD_FONT_FAMILY,
  OPEN_SANS_L_BOLD_FONT_SIZE: OPEN_SANS_L_BOLD_FONT_SIZE,
  OPEN_SANS_L_BOLD_FONT_STRETCH: OPEN_SANS_L_BOLD_FONT_STRETCH,
  OPEN_SANS_L_BOLD_FONT_STYLE: OPEN_SANS_L_BOLD_FONT_STYLE,
  OPEN_SANS_L_BOLD_FONT_STYLE_OLD: OPEN_SANS_L_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_L_BOLD_FONT_WEIGHT: OPEN_SANS_L_BOLD_FONT_WEIGHT,
  OPEN_SANS_L_BOLD_LETTER_SPACING: OPEN_SANS_L_BOLD_LETTER_SPACING,
  OPEN_SANS_L_BOLD_LINE_HEIGHT: OPEN_SANS_L_BOLD_LINE_HEIGHT,
  OPEN_SANS_L_BOLD_PARAGRAPH_INDENT: OPEN_SANS_L_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_L_BOLD_PARAGRAPH_SPACING: OPEN_SANS_L_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_L_BOLD_TEXT_CASE: OPEN_SANS_L_BOLD_TEXT_CASE,
  OPEN_SANS_L_BOLD_TEXT_DECORATION: OPEN_SANS_L_BOLD_TEXT_DECORATION,
  OPEN_SANS_L_FONT_FAMILY: OPEN_SANS_L_FONT_FAMILY,
  OPEN_SANS_L_FONT_SIZE: OPEN_SANS_L_FONT_SIZE,
  OPEN_SANS_L_FONT_STRETCH: OPEN_SANS_L_FONT_STRETCH,
  OPEN_SANS_L_FONT_STYLE: OPEN_SANS_L_FONT_STYLE,
  OPEN_SANS_L_FONT_STYLE_OLD: OPEN_SANS_L_FONT_STYLE_OLD,
  OPEN_SANS_L_FONT_WEIGHT: OPEN_SANS_L_FONT_WEIGHT,
  OPEN_SANS_L_LETTER_SPACING: OPEN_SANS_L_LETTER_SPACING,
  OPEN_SANS_L_LINE_HEIGHT: OPEN_SANS_L_LINE_HEIGHT,
  OPEN_SANS_L_PARAGRAPH_INDENT: OPEN_SANS_L_PARAGRAPH_INDENT,
  OPEN_SANS_L_PARAGRAPH_SPACING: OPEN_SANS_L_PARAGRAPH_SPACING,
  OPEN_SANS_L_TEXT_CASE: OPEN_SANS_L_TEXT_CASE,
  OPEN_SANS_L_TEXT_DECORATION: OPEN_SANS_L_TEXT_DECORATION,
  OPEN_SANS_M_AC_FONT_FAMILY: OPEN_SANS_M_AC_FONT_FAMILY,
  OPEN_SANS_M_AC_FONT_SIZE: OPEN_SANS_M_AC_FONT_SIZE,
  OPEN_SANS_M_AC_FONT_STRETCH: OPEN_SANS_M_AC_FONT_STRETCH,
  OPEN_SANS_M_AC_FONT_STYLE: OPEN_SANS_M_AC_FONT_STYLE,
  OPEN_SANS_M_AC_FONT_STYLE_OLD: OPEN_SANS_M_AC_FONT_STYLE_OLD,
  OPEN_SANS_M_AC_FONT_WEIGHT: OPEN_SANS_M_AC_FONT_WEIGHT,
  OPEN_SANS_M_AC_LETTER_SPACING: OPEN_SANS_M_AC_LETTER_SPACING,
  OPEN_SANS_M_AC_LINE_HEIGHT: OPEN_SANS_M_AC_LINE_HEIGHT,
  OPEN_SANS_M_AC_PARAGRAPH_INDENT: OPEN_SANS_M_AC_PARAGRAPH_INDENT,
  OPEN_SANS_M_AC_PARAGRAPH_SPACING: OPEN_SANS_M_AC_PARAGRAPH_SPACING,
  OPEN_SANS_M_AC_TEXT_CASE: OPEN_SANS_M_AC_TEXT_CASE,
  OPEN_SANS_M_AC_TEXT_DECORATION: OPEN_SANS_M_AC_TEXT_DECORATION,
  OPEN_SANS_M_BOLD_AC_FONT_FAMILY: OPEN_SANS_M_BOLD_AC_FONT_FAMILY,
  OPEN_SANS_M_BOLD_AC_FONT_SIZE: OPEN_SANS_M_BOLD_AC_FONT_SIZE,
  OPEN_SANS_M_BOLD_AC_FONT_STRETCH: OPEN_SANS_M_BOLD_AC_FONT_STRETCH,
  OPEN_SANS_M_BOLD_AC_FONT_STYLE: OPEN_SANS_M_BOLD_AC_FONT_STYLE,
  OPEN_SANS_M_BOLD_AC_FONT_STYLE_OLD: OPEN_SANS_M_BOLD_AC_FONT_STYLE_OLD,
  OPEN_SANS_M_BOLD_AC_FONT_WEIGHT: OPEN_SANS_M_BOLD_AC_FONT_WEIGHT,
  OPEN_SANS_M_BOLD_AC_LETTER_SPACING: OPEN_SANS_M_BOLD_AC_LETTER_SPACING,
  OPEN_SANS_M_BOLD_AC_LINE_HEIGHT: OPEN_SANS_M_BOLD_AC_LINE_HEIGHT,
  OPEN_SANS_M_BOLD_AC_PARAGRAPH_INDENT: OPEN_SANS_M_BOLD_AC_PARAGRAPH_INDENT,
  OPEN_SANS_M_BOLD_AC_PARAGRAPH_SPACING: OPEN_SANS_M_BOLD_AC_PARAGRAPH_SPACING,
  OPEN_SANS_M_BOLD_AC_TEXT_CASE: OPEN_SANS_M_BOLD_AC_TEXT_CASE,
  OPEN_SANS_M_BOLD_AC_TEXT_DECORATION: OPEN_SANS_M_BOLD_AC_TEXT_DECORATION,
  OPEN_SANS_M_BOLD_FONT_FAMILY: OPEN_SANS_M_BOLD_FONT_FAMILY,
  OPEN_SANS_M_BOLD_FONT_SIZE: OPEN_SANS_M_BOLD_FONT_SIZE,
  OPEN_SANS_M_BOLD_FONT_STRETCH: OPEN_SANS_M_BOLD_FONT_STRETCH,
  OPEN_SANS_M_BOLD_FONT_STYLE: OPEN_SANS_M_BOLD_FONT_STYLE,
  OPEN_SANS_M_BOLD_FONT_STYLE_OLD: OPEN_SANS_M_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_M_BOLD_FONT_WEIGHT: OPEN_SANS_M_BOLD_FONT_WEIGHT,
  OPEN_SANS_M_BOLD_LETTER_SPACING: OPEN_SANS_M_BOLD_LETTER_SPACING,
  OPEN_SANS_M_BOLD_LINE_HEIGHT: OPEN_SANS_M_BOLD_LINE_HEIGHT,
  OPEN_SANS_M_BOLD_PARAGRAPH_INDENT: OPEN_SANS_M_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_M_BOLD_PARAGRAPH_SPACING: OPEN_SANS_M_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_M_BOLD_TEXT_CASE: OPEN_SANS_M_BOLD_TEXT_CASE,
  OPEN_SANS_M_BOLD_TEXT_DECORATION: OPEN_SANS_M_BOLD_TEXT_DECORATION,
  OPEN_SANS_M_FONT_FAMILY: OPEN_SANS_M_FONT_FAMILY,
  OPEN_SANS_M_FONT_SIZE: OPEN_SANS_M_FONT_SIZE,
  OPEN_SANS_M_FONT_STRETCH: OPEN_SANS_M_FONT_STRETCH,
  OPEN_SANS_M_FONT_STYLE: OPEN_SANS_M_FONT_STYLE,
  OPEN_SANS_M_FONT_STYLE_OLD: OPEN_SANS_M_FONT_STYLE_OLD,
  OPEN_SANS_M_FONT_WEIGHT: OPEN_SANS_M_FONT_WEIGHT,
  OPEN_SANS_M_LETTER_SPACING: OPEN_SANS_M_LETTER_SPACING,
  OPEN_SANS_M_LINE_HEIGHT: OPEN_SANS_M_LINE_HEIGHT,
  OPEN_SANS_M_PARAGRAPH_INDENT: OPEN_SANS_M_PARAGRAPH_INDENT,
  OPEN_SANS_M_PARAGRAPH_SPACING: OPEN_SANS_M_PARAGRAPH_SPACING,
  OPEN_SANS_M_TEXT_CASE: OPEN_SANS_M_TEXT_CASE,
  OPEN_SANS_M_TEXT_DECORATION: OPEN_SANS_M_TEXT_DECORATION,
  OPEN_SANS_S_AC_FONT_FAMILY: OPEN_SANS_S_AC_FONT_FAMILY,
  OPEN_SANS_S_AC_FONT_SIZE: OPEN_SANS_S_AC_FONT_SIZE,
  OPEN_SANS_S_AC_FONT_STRETCH: OPEN_SANS_S_AC_FONT_STRETCH,
  OPEN_SANS_S_AC_FONT_STYLE: OPEN_SANS_S_AC_FONT_STYLE,
  OPEN_SANS_S_AC_FONT_STYLE_OLD: OPEN_SANS_S_AC_FONT_STYLE_OLD,
  OPEN_SANS_S_AC_FONT_WEIGHT: OPEN_SANS_S_AC_FONT_WEIGHT,
  OPEN_SANS_S_AC_LETTER_SPACING: OPEN_SANS_S_AC_LETTER_SPACING,
  OPEN_SANS_S_AC_LINE_HEIGHT: OPEN_SANS_S_AC_LINE_HEIGHT,
  OPEN_SANS_S_AC_PARAGRAPH_INDENT: OPEN_SANS_S_AC_PARAGRAPH_INDENT,
  OPEN_SANS_S_AC_PARAGRAPH_SPACING: OPEN_SANS_S_AC_PARAGRAPH_SPACING,
  OPEN_SANS_S_AC_TEXT_CASE: OPEN_SANS_S_AC_TEXT_CASE,
  OPEN_SANS_S_AC_TEXT_DECORATION: OPEN_SANS_S_AC_TEXT_DECORATION,
  OPEN_SANS_S_BOLD_AC_FONT_FAMILY: OPEN_SANS_S_BOLD_AC_FONT_FAMILY,
  OPEN_SANS_S_BOLD_AC_FONT_SIZE: OPEN_SANS_S_BOLD_AC_FONT_SIZE,
  OPEN_SANS_S_BOLD_AC_FONT_STRETCH: OPEN_SANS_S_BOLD_AC_FONT_STRETCH,
  OPEN_SANS_S_BOLD_AC_FONT_STYLE: OPEN_SANS_S_BOLD_AC_FONT_STYLE,
  OPEN_SANS_S_BOLD_AC_FONT_STYLE_OLD: OPEN_SANS_S_BOLD_AC_FONT_STYLE_OLD,
  OPEN_SANS_S_BOLD_AC_FONT_WEIGHT: OPEN_SANS_S_BOLD_AC_FONT_WEIGHT,
  OPEN_SANS_S_BOLD_AC_LETTER_SPACING: OPEN_SANS_S_BOLD_AC_LETTER_SPACING,
  OPEN_SANS_S_BOLD_AC_LINE_HEIGHT: OPEN_SANS_S_BOLD_AC_LINE_HEIGHT,
  OPEN_SANS_S_BOLD_AC_PARAGRAPH_INDENT: OPEN_SANS_S_BOLD_AC_PARAGRAPH_INDENT,
  OPEN_SANS_S_BOLD_AC_PARAGRAPH_SPACING: OPEN_SANS_S_BOLD_AC_PARAGRAPH_SPACING,
  OPEN_SANS_S_BOLD_AC_TEXT_CASE: OPEN_SANS_S_BOLD_AC_TEXT_CASE,
  OPEN_SANS_S_BOLD_AC_TEXT_DECORATION: OPEN_SANS_S_BOLD_AC_TEXT_DECORATION,
  OPEN_SANS_S_BOLD_FONT_FAMILY: OPEN_SANS_S_BOLD_FONT_FAMILY,
  OPEN_SANS_S_BOLD_FONT_SIZE: OPEN_SANS_S_BOLD_FONT_SIZE,
  OPEN_SANS_S_BOLD_FONT_STRETCH: OPEN_SANS_S_BOLD_FONT_STRETCH,
  OPEN_SANS_S_BOLD_FONT_STYLE: OPEN_SANS_S_BOLD_FONT_STYLE,
  OPEN_SANS_S_BOLD_FONT_STYLE_OLD: OPEN_SANS_S_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_S_BOLD_FONT_WEIGHT: OPEN_SANS_S_BOLD_FONT_WEIGHT,
  OPEN_SANS_S_BOLD_LETTER_SPACING: OPEN_SANS_S_BOLD_LETTER_SPACING,
  OPEN_SANS_S_BOLD_LINE_HEIGHT: OPEN_SANS_S_BOLD_LINE_HEIGHT,
  OPEN_SANS_S_BOLD_PARAGRAPH_INDENT: OPEN_SANS_S_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_S_BOLD_PARAGRAPH_SPACING: OPEN_SANS_S_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_S_BOLD_TEXT_CASE: OPEN_SANS_S_BOLD_TEXT_CASE,
  OPEN_SANS_S_BOLD_TEXT_DECORATION: OPEN_SANS_S_BOLD_TEXT_DECORATION,
  OPEN_SANS_S_FONT_FAMILY: OPEN_SANS_S_FONT_FAMILY,
  OPEN_SANS_S_FONT_SIZE: OPEN_SANS_S_FONT_SIZE,
  OPEN_SANS_S_FONT_STRETCH: OPEN_SANS_S_FONT_STRETCH,
  OPEN_SANS_S_FONT_STYLE: OPEN_SANS_S_FONT_STYLE,
  OPEN_SANS_S_FONT_STYLE_OLD: OPEN_SANS_S_FONT_STYLE_OLD,
  OPEN_SANS_S_FONT_WEIGHT: OPEN_SANS_S_FONT_WEIGHT,
  OPEN_SANS_S_LETTER_SPACING: OPEN_SANS_S_LETTER_SPACING,
  OPEN_SANS_S_LINE_HEIGHT: OPEN_SANS_S_LINE_HEIGHT,
  OPEN_SANS_S_PARAGRAPH_INDENT: OPEN_SANS_S_PARAGRAPH_INDENT,
  OPEN_SANS_S_PARAGRAPH_SPACING: OPEN_SANS_S_PARAGRAPH_SPACING,
  OPEN_SANS_S_TEXT_CASE: OPEN_SANS_S_TEXT_CASE,
  OPEN_SANS_S_TEXT_DECORATION: OPEN_SANS_S_TEXT_DECORATION,
  OPEN_SANS_XL_BOLD_FONT_FAMILY: OPEN_SANS_XL_BOLD_FONT_FAMILY,
  OPEN_SANS_XL_BOLD_FONT_SIZE: OPEN_SANS_XL_BOLD_FONT_SIZE,
  OPEN_SANS_XL_BOLD_FONT_STRETCH: OPEN_SANS_XL_BOLD_FONT_STRETCH,
  OPEN_SANS_XL_BOLD_FONT_STYLE: OPEN_SANS_XL_BOLD_FONT_STYLE,
  OPEN_SANS_XL_BOLD_FONT_STYLE_OLD: OPEN_SANS_XL_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_XL_BOLD_FONT_WEIGHT: OPEN_SANS_XL_BOLD_FONT_WEIGHT,
  OPEN_SANS_XL_BOLD_LETTER_SPACING: OPEN_SANS_XL_BOLD_LETTER_SPACING,
  OPEN_SANS_XL_BOLD_LINE_HEIGHT: OPEN_SANS_XL_BOLD_LINE_HEIGHT,
  OPEN_SANS_XL_BOLD_PARAGRAPH_INDENT: OPEN_SANS_XL_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_XL_BOLD_PARAGRAPH_SPACING: OPEN_SANS_XL_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_XL_BOLD_TEXT_CASE: OPEN_SANS_XL_BOLD_TEXT_CASE,
  OPEN_SANS_XL_BOLD_TEXT_DECORATION: OPEN_SANS_XL_BOLD_TEXT_DECORATION,
  OPEN_SANS_XL_FONT_FAMILY: OPEN_SANS_XL_FONT_FAMILY,
  OPEN_SANS_XL_FONT_SIZE: OPEN_SANS_XL_FONT_SIZE,
  OPEN_SANS_XL_FONT_STRETCH: OPEN_SANS_XL_FONT_STRETCH,
  OPEN_SANS_XL_FONT_STYLE: OPEN_SANS_XL_FONT_STYLE,
  OPEN_SANS_XL_FONT_STYLE_OLD: OPEN_SANS_XL_FONT_STYLE_OLD,
  OPEN_SANS_XL_FONT_WEIGHT: OPEN_SANS_XL_FONT_WEIGHT,
  OPEN_SANS_XL_LETTER_SPACING: OPEN_SANS_XL_LETTER_SPACING,
  OPEN_SANS_XL_LINE_HEIGHT: OPEN_SANS_XL_LINE_HEIGHT,
  OPEN_SANS_XL_PARAGRAPH_INDENT: OPEN_SANS_XL_PARAGRAPH_INDENT,
  OPEN_SANS_XL_PARAGRAPH_SPACING: OPEN_SANS_XL_PARAGRAPH_SPACING,
  OPEN_SANS_XL_TEXT_CASE: OPEN_SANS_XL_TEXT_CASE,
  OPEN_SANS_XL_TEXT_DECORATION: OPEN_SANS_XL_TEXT_DECORATION,
  OPEN_SANS_XS_AC_FONT_FAMILY: OPEN_SANS_XS_AC_FONT_FAMILY,
  OPEN_SANS_XS_AC_FONT_SIZE: OPEN_SANS_XS_AC_FONT_SIZE,
  OPEN_SANS_XS_AC_FONT_STRETCH: OPEN_SANS_XS_AC_FONT_STRETCH,
  OPEN_SANS_XS_AC_FONT_STYLE: OPEN_SANS_XS_AC_FONT_STYLE,
  OPEN_SANS_XS_AC_FONT_STYLE_OLD: OPEN_SANS_XS_AC_FONT_STYLE_OLD,
  OPEN_SANS_XS_AC_FONT_WEIGHT: OPEN_SANS_XS_AC_FONT_WEIGHT,
  OPEN_SANS_XS_AC_LETTER_SPACING: OPEN_SANS_XS_AC_LETTER_SPACING,
  OPEN_SANS_XS_AC_LINE_HEIGHT: OPEN_SANS_XS_AC_LINE_HEIGHT,
  OPEN_SANS_XS_AC_PARAGRAPH_INDENT: OPEN_SANS_XS_AC_PARAGRAPH_INDENT,
  OPEN_SANS_XS_AC_PARAGRAPH_SPACING: OPEN_SANS_XS_AC_PARAGRAPH_SPACING,
  OPEN_SANS_XS_AC_TEXT_CASE: OPEN_SANS_XS_AC_TEXT_CASE,
  OPEN_SANS_XS_AC_TEXT_DECORATION: OPEN_SANS_XS_AC_TEXT_DECORATION,
  OPEN_SANS_XS_BOLD_AC_FONT_FAMILY: OPEN_SANS_XS_BOLD_AC_FONT_FAMILY,
  OPEN_SANS_XS_BOLD_AC_FONT_SIZE: OPEN_SANS_XS_BOLD_AC_FONT_SIZE,
  OPEN_SANS_XS_BOLD_AC_FONT_STRETCH: OPEN_SANS_XS_BOLD_AC_FONT_STRETCH,
  OPEN_SANS_XS_BOLD_AC_FONT_STYLE: OPEN_SANS_XS_BOLD_AC_FONT_STYLE,
  OPEN_SANS_XS_BOLD_AC_FONT_STYLE_OLD: OPEN_SANS_XS_BOLD_AC_FONT_STYLE_OLD,
  OPEN_SANS_XS_BOLD_AC_FONT_WEIGHT: OPEN_SANS_XS_BOLD_AC_FONT_WEIGHT,
  OPEN_SANS_XS_BOLD_AC_LETTER_SPACING: OPEN_SANS_XS_BOLD_AC_LETTER_SPACING,
  OPEN_SANS_XS_BOLD_AC_LINE_HEIGHT: OPEN_SANS_XS_BOLD_AC_LINE_HEIGHT,
  OPEN_SANS_XS_BOLD_AC_PARAGRAPH_INDENT: OPEN_SANS_XS_BOLD_AC_PARAGRAPH_INDENT,
  OPEN_SANS_XS_BOLD_AC_PARAGRAPH_SPACING: OPEN_SANS_XS_BOLD_AC_PARAGRAPH_SPACING,
  OPEN_SANS_XS_BOLD_AC_TEXT_CASE: OPEN_SANS_XS_BOLD_AC_TEXT_CASE,
  OPEN_SANS_XS_BOLD_AC_TEXT_DECORATION: OPEN_SANS_XS_BOLD_AC_TEXT_DECORATION,
  OPEN_SANS_XS_BOLD_FONT_FAMILY: OPEN_SANS_XS_BOLD_FONT_FAMILY,
  OPEN_SANS_XS_BOLD_FONT_SIZE: OPEN_SANS_XS_BOLD_FONT_SIZE,
  OPEN_SANS_XS_BOLD_FONT_STRETCH: OPEN_SANS_XS_BOLD_FONT_STRETCH,
  OPEN_SANS_XS_BOLD_FONT_STYLE: OPEN_SANS_XS_BOLD_FONT_STYLE,
  OPEN_SANS_XS_BOLD_FONT_STYLE_OLD: OPEN_SANS_XS_BOLD_FONT_STYLE_OLD,
  OPEN_SANS_XS_BOLD_FONT_WEIGHT: OPEN_SANS_XS_BOLD_FONT_WEIGHT,
  OPEN_SANS_XS_BOLD_LETTER_SPACING: OPEN_SANS_XS_BOLD_LETTER_SPACING,
  OPEN_SANS_XS_BOLD_LINE_HEIGHT: OPEN_SANS_XS_BOLD_LINE_HEIGHT,
  OPEN_SANS_XS_BOLD_PARAGRAPH_INDENT: OPEN_SANS_XS_BOLD_PARAGRAPH_INDENT,
  OPEN_SANS_XS_BOLD_PARAGRAPH_SPACING: OPEN_SANS_XS_BOLD_PARAGRAPH_SPACING,
  OPEN_SANS_XS_BOLD_TEXT_CASE: OPEN_SANS_XS_BOLD_TEXT_CASE,
  OPEN_SANS_XS_BOLD_TEXT_DECORATION: OPEN_SANS_XS_BOLD_TEXT_DECORATION,
  OPEN_SANS_XS_FONT_FAMILY: OPEN_SANS_XS_FONT_FAMILY,
  OPEN_SANS_XS_FONT_SIZE: OPEN_SANS_XS_FONT_SIZE,
  OPEN_SANS_XS_FONT_STRETCH: OPEN_SANS_XS_FONT_STRETCH,
  OPEN_SANS_XS_FONT_STYLE: OPEN_SANS_XS_FONT_STYLE,
  OPEN_SANS_XS_FONT_STYLE_OLD: OPEN_SANS_XS_FONT_STYLE_OLD,
  OPEN_SANS_XS_FONT_WEIGHT: OPEN_SANS_XS_FONT_WEIGHT,
  OPEN_SANS_XS_LETTER_SPACING: OPEN_SANS_XS_LETTER_SPACING,
  OPEN_SANS_XS_LINE_HEIGHT: OPEN_SANS_XS_LINE_HEIGHT,
  OPEN_SANS_XS_PARAGRAPH_INDENT: OPEN_SANS_XS_PARAGRAPH_INDENT,
  OPEN_SANS_XS_PARAGRAPH_SPACING: OPEN_SANS_XS_PARAGRAPH_SPACING,
  OPEN_SANS_XS_TEXT_CASE: OPEN_SANS_XS_TEXT_CASE,
  OPEN_SANS_XS_TEXT_DECORATION: OPEN_SANS_XS_TEXT_DECORATION,
  YLE_NEXT_2XL_BOLD_FONT_FAMILY: YLE_NEXT_2XL_BOLD_FONT_FAMILY,
  YLE_NEXT_2XL_BOLD_FONT_SIZE: YLE_NEXT_2XL_BOLD_FONT_SIZE,
  YLE_NEXT_2XL_BOLD_FONT_STRETCH: YLE_NEXT_2XL_BOLD_FONT_STRETCH,
  YLE_NEXT_2XL_BOLD_FONT_STYLE: YLE_NEXT_2XL_BOLD_FONT_STYLE,
  YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_2XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_2XL_BOLD_FONT_WEIGHT: YLE_NEXT_2XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_2XL_BOLD_LETTER_SPACING: YLE_NEXT_2XL_BOLD_LETTER_SPACING,
  YLE_NEXT_2XL_BOLD_LINE_HEIGHT: YLE_NEXT_2XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_2XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_2XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_BOLD_TEXT_CASE: YLE_NEXT_2XL_BOLD_TEXT_CASE,
  YLE_NEXT_2XL_BOLD_TEXT_DECORATION: YLE_NEXT_2XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_2XL_FONT_FAMILY: YLE_NEXT_2XL_FONT_FAMILY,
  YLE_NEXT_2XL_FONT_SIZE: YLE_NEXT_2XL_FONT_SIZE,
  YLE_NEXT_2XL_FONT_STRETCH: YLE_NEXT_2XL_FONT_STRETCH,
  YLE_NEXT_2XL_FONT_STYLE: YLE_NEXT_2XL_FONT_STYLE,
  YLE_NEXT_2XL_FONT_STYLE_OLD: YLE_NEXT_2XL_FONT_STYLE_OLD,
  YLE_NEXT_2XL_FONT_WEIGHT: YLE_NEXT_2XL_FONT_WEIGHT,
  YLE_NEXT_2XL_HEAVY_FONT_FAMILY: YLE_NEXT_2XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_2XL_HEAVY_FONT_SIZE: YLE_NEXT_2XL_HEAVY_FONT_SIZE,
  YLE_NEXT_2XL_HEAVY_FONT_STRETCH: YLE_NEXT_2XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE: YLE_NEXT_2XL_HEAVY_FONT_STYLE,
  YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_2XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_2XL_HEAVY_FONT_WEIGHT: YLE_NEXT_2XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_2XL_HEAVY_LETTER_SPACING: YLE_NEXT_2XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_2XL_HEAVY_LINE_HEIGHT: YLE_NEXT_2XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_2XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_2XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_HEAVY_TEXT_CASE: YLE_NEXT_2XL_HEAVY_TEXT_CASE,
  YLE_NEXT_2XL_HEAVY_TEXT_DECORATION: YLE_NEXT_2XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_2XL_LETTER_SPACING: YLE_NEXT_2XL_LETTER_SPACING,
  YLE_NEXT_2XL_LINE_HEIGHT: YLE_NEXT_2XL_LINE_HEIGHT,
  YLE_NEXT_2XL_PARAGRAPH_INDENT: YLE_NEXT_2XL_PARAGRAPH_INDENT,
  YLE_NEXT_2XL_PARAGRAPH_SPACING: YLE_NEXT_2XL_PARAGRAPH_SPACING,
  YLE_NEXT_2XL_TEXT_CASE: YLE_NEXT_2XL_TEXT_CASE,
  YLE_NEXT_2XL_TEXT_DECORATION: YLE_NEXT_2XL_TEXT_DECORATION,
  YLE_NEXT_3XL_BOLD_FONT_FAMILY: YLE_NEXT_3XL_BOLD_FONT_FAMILY,
  YLE_NEXT_3XL_BOLD_FONT_SIZE: YLE_NEXT_3XL_BOLD_FONT_SIZE,
  YLE_NEXT_3XL_BOLD_FONT_STRETCH: YLE_NEXT_3XL_BOLD_FONT_STRETCH,
  YLE_NEXT_3XL_BOLD_FONT_STYLE: YLE_NEXT_3XL_BOLD_FONT_STYLE,
  YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_3XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_3XL_BOLD_FONT_WEIGHT: YLE_NEXT_3XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_3XL_BOLD_LETTER_SPACING: YLE_NEXT_3XL_BOLD_LETTER_SPACING,
  YLE_NEXT_3XL_BOLD_LINE_HEIGHT: YLE_NEXT_3XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_3XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_3XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_3XL_BOLD_TEXT_CASE: YLE_NEXT_3XL_BOLD_TEXT_CASE,
  YLE_NEXT_3XL_BOLD_TEXT_DECORATION: YLE_NEXT_3XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_3XL_HEAVY_FONT_FAMILY: YLE_NEXT_3XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_3XL_HEAVY_FONT_SIZE: YLE_NEXT_3XL_HEAVY_FONT_SIZE,
  YLE_NEXT_3XL_HEAVY_FONT_STRETCH: YLE_NEXT_3XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE: YLE_NEXT_3XL_HEAVY_FONT_STYLE,
  YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_3XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_3XL_HEAVY_FONT_WEIGHT: YLE_NEXT_3XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_3XL_HEAVY_LETTER_SPACING: YLE_NEXT_3XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_3XL_HEAVY_LINE_HEIGHT: YLE_NEXT_3XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_3XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_3XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_3XL_HEAVY_TEXT_CASE: YLE_NEXT_3XL_HEAVY_TEXT_CASE,
  YLE_NEXT_3XL_HEAVY_TEXT_DECORATION: YLE_NEXT_3XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_4XL_BOLD_FONT_FAMILY: YLE_NEXT_4XL_BOLD_FONT_FAMILY,
  YLE_NEXT_4XL_BOLD_FONT_SIZE: YLE_NEXT_4XL_BOLD_FONT_SIZE,
  YLE_NEXT_4XL_BOLD_FONT_STRETCH: YLE_NEXT_4XL_BOLD_FONT_STRETCH,
  YLE_NEXT_4XL_BOLD_FONT_STYLE: YLE_NEXT_4XL_BOLD_FONT_STYLE,
  YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_4XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_4XL_BOLD_FONT_WEIGHT: YLE_NEXT_4XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_4XL_BOLD_LETTER_SPACING: YLE_NEXT_4XL_BOLD_LETTER_SPACING,
  YLE_NEXT_4XL_BOLD_LINE_HEIGHT: YLE_NEXT_4XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_4XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_4XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_4XL_BOLD_TEXT_CASE: YLE_NEXT_4XL_BOLD_TEXT_CASE,
  YLE_NEXT_4XL_BOLD_TEXT_DECORATION: YLE_NEXT_4XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_4XL_HEAVY_FONT_FAMILY: YLE_NEXT_4XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_4XL_HEAVY_FONT_SIZE: YLE_NEXT_4XL_HEAVY_FONT_SIZE,
  YLE_NEXT_4XL_HEAVY_FONT_STRETCH: YLE_NEXT_4XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE: YLE_NEXT_4XL_HEAVY_FONT_STYLE,
  YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_4XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_4XL_HEAVY_FONT_WEIGHT: YLE_NEXT_4XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_4XL_HEAVY_LETTER_SPACING: YLE_NEXT_4XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_4XL_HEAVY_LINE_HEIGHT: YLE_NEXT_4XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_4XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_4XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_4XL_HEAVY_TEXT_CASE: YLE_NEXT_4XL_HEAVY_TEXT_CASE,
  YLE_NEXT_4XL_HEAVY_TEXT_DECORATION: YLE_NEXT_4XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_5XL_BOLD_FONT_FAMILY: YLE_NEXT_5XL_BOLD_FONT_FAMILY,
  YLE_NEXT_5XL_BOLD_FONT_SIZE: YLE_NEXT_5XL_BOLD_FONT_SIZE,
  YLE_NEXT_5XL_BOLD_FONT_STRETCH: YLE_NEXT_5XL_BOLD_FONT_STRETCH,
  YLE_NEXT_5XL_BOLD_FONT_STYLE: YLE_NEXT_5XL_BOLD_FONT_STYLE,
  YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_5XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_5XL_BOLD_FONT_WEIGHT: YLE_NEXT_5XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_5XL_BOLD_LETTER_SPACING: YLE_NEXT_5XL_BOLD_LETTER_SPACING,
  YLE_NEXT_5XL_BOLD_LINE_HEIGHT: YLE_NEXT_5XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_5XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_5XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_5XL_BOLD_TEXT_CASE: YLE_NEXT_5XL_BOLD_TEXT_CASE,
  YLE_NEXT_5XL_BOLD_TEXT_DECORATION: YLE_NEXT_5XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_5XL_HEAVY_FONT_FAMILY: YLE_NEXT_5XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_5XL_HEAVY_FONT_SIZE: YLE_NEXT_5XL_HEAVY_FONT_SIZE,
  YLE_NEXT_5XL_HEAVY_FONT_STRETCH: YLE_NEXT_5XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE: YLE_NEXT_5XL_HEAVY_FONT_STYLE,
  YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_5XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_5XL_HEAVY_FONT_WEIGHT: YLE_NEXT_5XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_5XL_HEAVY_LETTER_SPACING: YLE_NEXT_5XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_5XL_HEAVY_LINE_HEIGHT: YLE_NEXT_5XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_5XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_5XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_5XL_HEAVY_TEXT_CASE: YLE_NEXT_5XL_HEAVY_TEXT_CASE,
  YLE_NEXT_5XL_HEAVY_TEXT_DECORATION: YLE_NEXT_5XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_6XL_BOLD_FONT_FAMILY: YLE_NEXT_6XL_BOLD_FONT_FAMILY,
  YLE_NEXT_6XL_BOLD_FONT_SIZE: YLE_NEXT_6XL_BOLD_FONT_SIZE,
  YLE_NEXT_6XL_BOLD_FONT_STRETCH: YLE_NEXT_6XL_BOLD_FONT_STRETCH,
  YLE_NEXT_6XL_BOLD_FONT_STYLE: YLE_NEXT_6XL_BOLD_FONT_STYLE,
  YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_6XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_6XL_BOLD_FONT_WEIGHT: YLE_NEXT_6XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_6XL_BOLD_LETTER_SPACING: YLE_NEXT_6XL_BOLD_LETTER_SPACING,
  YLE_NEXT_6XL_BOLD_LINE_HEIGHT: YLE_NEXT_6XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_6XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_6XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_6XL_BOLD_TEXT_CASE: YLE_NEXT_6XL_BOLD_TEXT_CASE,
  YLE_NEXT_6XL_BOLD_TEXT_DECORATION: YLE_NEXT_6XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_6XL_HEAVY_FONT_FAMILY: YLE_NEXT_6XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_6XL_HEAVY_FONT_SIZE: YLE_NEXT_6XL_HEAVY_FONT_SIZE,
  YLE_NEXT_6XL_HEAVY_FONT_STRETCH: YLE_NEXT_6XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE: YLE_NEXT_6XL_HEAVY_FONT_STYLE,
  YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_6XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_6XL_HEAVY_FONT_WEIGHT: YLE_NEXT_6XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_6XL_HEAVY_LETTER_SPACING: YLE_NEXT_6XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_6XL_HEAVY_LINE_HEIGHT: YLE_NEXT_6XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_6XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_6XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_6XL_HEAVY_TEXT_CASE: YLE_NEXT_6XL_HEAVY_TEXT_CASE,
  YLE_NEXT_6XL_HEAVY_TEXT_DECORATION: YLE_NEXT_6XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_7XL_BOLD_FONT_FAMILY: YLE_NEXT_7XL_BOLD_FONT_FAMILY,
  YLE_NEXT_7XL_BOLD_FONT_SIZE: YLE_NEXT_7XL_BOLD_FONT_SIZE,
  YLE_NEXT_7XL_BOLD_FONT_STRETCH: YLE_NEXT_7XL_BOLD_FONT_STRETCH,
  YLE_NEXT_7XL_BOLD_FONT_STYLE: YLE_NEXT_7XL_BOLD_FONT_STYLE,
  YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_7XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_7XL_BOLD_FONT_WEIGHT: YLE_NEXT_7XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_7XL_BOLD_LETTER_SPACING: YLE_NEXT_7XL_BOLD_LETTER_SPACING,
  YLE_NEXT_7XL_BOLD_LINE_HEIGHT: YLE_NEXT_7XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_7XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_7XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_7XL_BOLD_TEXT_CASE: YLE_NEXT_7XL_BOLD_TEXT_CASE,
  YLE_NEXT_7XL_BOLD_TEXT_DECORATION: YLE_NEXT_7XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_7XL_HEAVY_FONT_FAMILY: YLE_NEXT_7XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_7XL_HEAVY_FONT_SIZE: YLE_NEXT_7XL_HEAVY_FONT_SIZE,
  YLE_NEXT_7XL_HEAVY_FONT_STRETCH: YLE_NEXT_7XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE: YLE_NEXT_7XL_HEAVY_FONT_STYLE,
  YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_7XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_7XL_HEAVY_FONT_WEIGHT: YLE_NEXT_7XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_7XL_HEAVY_LETTER_SPACING: YLE_NEXT_7XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_7XL_HEAVY_LINE_HEIGHT: YLE_NEXT_7XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_7XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_7XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_7XL_HEAVY_TEXT_CASE: YLE_NEXT_7XL_HEAVY_TEXT_CASE,
  YLE_NEXT_7XL_HEAVY_TEXT_DECORATION: YLE_NEXT_7XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_L_BOLD_FONT_FAMILY: YLE_NEXT_L_BOLD_FONT_FAMILY,
  YLE_NEXT_L_BOLD_FONT_SIZE: YLE_NEXT_L_BOLD_FONT_SIZE,
  YLE_NEXT_L_BOLD_FONT_STRETCH: YLE_NEXT_L_BOLD_FONT_STRETCH,
  YLE_NEXT_L_BOLD_FONT_STYLE: YLE_NEXT_L_BOLD_FONT_STYLE,
  YLE_NEXT_L_BOLD_FONT_STYLE_OLD: YLE_NEXT_L_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_L_BOLD_FONT_WEIGHT: YLE_NEXT_L_BOLD_FONT_WEIGHT,
  YLE_NEXT_L_BOLD_LETTER_SPACING: YLE_NEXT_L_BOLD_LETTER_SPACING,
  YLE_NEXT_L_BOLD_LINE_HEIGHT: YLE_NEXT_L_BOLD_LINE_HEIGHT,
  YLE_NEXT_L_BOLD_PARAGRAPH_INDENT: YLE_NEXT_L_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_L_BOLD_PARAGRAPH_SPACING: YLE_NEXT_L_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_L_BOLD_TEXT_CASE: YLE_NEXT_L_BOLD_TEXT_CASE,
  YLE_NEXT_L_BOLD_TEXT_DECORATION: YLE_NEXT_L_BOLD_TEXT_DECORATION,
  YLE_NEXT_L_FONT_FAMILY: YLE_NEXT_L_FONT_FAMILY,
  YLE_NEXT_L_FONT_SIZE: YLE_NEXT_L_FONT_SIZE,
  YLE_NEXT_L_FONT_STRETCH: YLE_NEXT_L_FONT_STRETCH,
  YLE_NEXT_L_FONT_STYLE: YLE_NEXT_L_FONT_STYLE,
  YLE_NEXT_L_FONT_STYLE_OLD: YLE_NEXT_L_FONT_STYLE_OLD,
  YLE_NEXT_L_FONT_WEIGHT: YLE_NEXT_L_FONT_WEIGHT,
  YLE_NEXT_L_HEAVY_FONT_FAMILY: YLE_NEXT_L_HEAVY_FONT_FAMILY,
  YLE_NEXT_L_HEAVY_FONT_SIZE: YLE_NEXT_L_HEAVY_FONT_SIZE,
  YLE_NEXT_L_HEAVY_FONT_STRETCH: YLE_NEXT_L_HEAVY_FONT_STRETCH,
  YLE_NEXT_L_HEAVY_FONT_STYLE: YLE_NEXT_L_HEAVY_FONT_STYLE,
  YLE_NEXT_L_HEAVY_FONT_STYLE_OLD: YLE_NEXT_L_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_L_HEAVY_FONT_WEIGHT: YLE_NEXT_L_HEAVY_FONT_WEIGHT,
  YLE_NEXT_L_HEAVY_LETTER_SPACING: YLE_NEXT_L_HEAVY_LETTER_SPACING,
  YLE_NEXT_L_HEAVY_LINE_HEIGHT: YLE_NEXT_L_HEAVY_LINE_HEIGHT,
  YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_L_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_L_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_L_HEAVY_TEXT_CASE: YLE_NEXT_L_HEAVY_TEXT_CASE,
  YLE_NEXT_L_HEAVY_TEXT_DECORATION: YLE_NEXT_L_HEAVY_TEXT_DECORATION,
  YLE_NEXT_L_ITALIC_FONT_FAMILY: YLE_NEXT_L_ITALIC_FONT_FAMILY,
  YLE_NEXT_L_ITALIC_FONT_SIZE: YLE_NEXT_L_ITALIC_FONT_SIZE,
  YLE_NEXT_L_ITALIC_FONT_STRETCH: YLE_NEXT_L_ITALIC_FONT_STRETCH,
  YLE_NEXT_L_ITALIC_FONT_STYLE: YLE_NEXT_L_ITALIC_FONT_STYLE,
  YLE_NEXT_L_ITALIC_FONT_STYLE_OLD: YLE_NEXT_L_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_L_ITALIC_FONT_WEIGHT: YLE_NEXT_L_ITALIC_FONT_WEIGHT,
  YLE_NEXT_L_ITALIC_LETTER_SPACING: YLE_NEXT_L_ITALIC_LETTER_SPACING,
  YLE_NEXT_L_ITALIC_LINE_HEIGHT: YLE_NEXT_L_ITALIC_LINE_HEIGHT,
  YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_L_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_L_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_L_ITALIC_TEXT_CASE: YLE_NEXT_L_ITALIC_TEXT_CASE,
  YLE_NEXT_L_ITALIC_TEXT_DECORATION: YLE_NEXT_L_ITALIC_TEXT_DECORATION,
  YLE_NEXT_L_LETTER_SPACING: YLE_NEXT_L_LETTER_SPACING,
  YLE_NEXT_L_LINE_HEIGHT: YLE_NEXT_L_LINE_HEIGHT,
  YLE_NEXT_L_PARAGRAPH_INDENT: YLE_NEXT_L_PARAGRAPH_INDENT,
  YLE_NEXT_L_PARAGRAPH_SPACING: YLE_NEXT_L_PARAGRAPH_SPACING,
  YLE_NEXT_L_TEXT_CASE: YLE_NEXT_L_TEXT_CASE,
  YLE_NEXT_L_TEXT_DECORATION: YLE_NEXT_L_TEXT_DECORATION,
  YLE_NEXT_M_AC_FONT_FAMILY: YLE_NEXT_M_AC_FONT_FAMILY,
  YLE_NEXT_M_AC_FONT_SIZE: YLE_NEXT_M_AC_FONT_SIZE,
  YLE_NEXT_M_AC_FONT_STRETCH: YLE_NEXT_M_AC_FONT_STRETCH,
  YLE_NEXT_M_AC_FONT_STYLE: YLE_NEXT_M_AC_FONT_STYLE,
  YLE_NEXT_M_AC_FONT_STYLE_OLD: YLE_NEXT_M_AC_FONT_STYLE_OLD,
  YLE_NEXT_M_AC_FONT_WEIGHT: YLE_NEXT_M_AC_FONT_WEIGHT,
  YLE_NEXT_M_AC_LETTER_SPACING: YLE_NEXT_M_AC_LETTER_SPACING,
  YLE_NEXT_M_AC_LINE_HEIGHT: YLE_NEXT_M_AC_LINE_HEIGHT,
  YLE_NEXT_M_AC_PARAGRAPH_INDENT: YLE_NEXT_M_AC_PARAGRAPH_INDENT,
  YLE_NEXT_M_AC_PARAGRAPH_SPACING: YLE_NEXT_M_AC_PARAGRAPH_SPACING,
  YLE_NEXT_M_AC_TEXT_CASE: YLE_NEXT_M_AC_TEXT_CASE,
  YLE_NEXT_M_AC_TEXT_DECORATION: YLE_NEXT_M_AC_TEXT_DECORATION,
  YLE_NEXT_M_BOLD_AC_FONT_FAMILY: YLE_NEXT_M_BOLD_AC_FONT_FAMILY,
  YLE_NEXT_M_BOLD_AC_FONT_SIZE: YLE_NEXT_M_BOLD_AC_FONT_SIZE,
  YLE_NEXT_M_BOLD_AC_FONT_STRETCH: YLE_NEXT_M_BOLD_AC_FONT_STRETCH,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE: YLE_NEXT_M_BOLD_AC_FONT_STYLE,
  YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_AC_FONT_STYLE_OLD,
  YLE_NEXT_M_BOLD_AC_FONT_WEIGHT: YLE_NEXT_M_BOLD_AC_FONT_WEIGHT,
  YLE_NEXT_M_BOLD_AC_LETTER_SPACING: YLE_NEXT_M_BOLD_AC_LETTER_SPACING,
  YLE_NEXT_M_BOLD_AC_LINE_HEIGHT: YLE_NEXT_M_BOLD_AC_LINE_HEIGHT,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_AC_PARAGRAPH_INDENT,
  YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_AC_PARAGRAPH_SPACING,
  YLE_NEXT_M_BOLD_AC_TEXT_CASE: YLE_NEXT_M_BOLD_AC_TEXT_CASE,
  YLE_NEXT_M_BOLD_AC_TEXT_DECORATION: YLE_NEXT_M_BOLD_AC_TEXT_DECORATION,
  YLE_NEXT_M_BOLD_FONT_FAMILY: YLE_NEXT_M_BOLD_FONT_FAMILY,
  YLE_NEXT_M_BOLD_FONT_SIZE: YLE_NEXT_M_BOLD_FONT_SIZE,
  YLE_NEXT_M_BOLD_FONT_STRETCH: YLE_NEXT_M_BOLD_FONT_STRETCH,
  YLE_NEXT_M_BOLD_FONT_STYLE: YLE_NEXT_M_BOLD_FONT_STYLE,
  YLE_NEXT_M_BOLD_FONT_STYLE_OLD: YLE_NEXT_M_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_M_BOLD_FONT_WEIGHT: YLE_NEXT_M_BOLD_FONT_WEIGHT,
  YLE_NEXT_M_BOLD_LETTER_SPACING: YLE_NEXT_M_BOLD_LETTER_SPACING,
  YLE_NEXT_M_BOLD_LINE_HEIGHT: YLE_NEXT_M_BOLD_LINE_HEIGHT,
  YLE_NEXT_M_BOLD_PARAGRAPH_INDENT: YLE_NEXT_M_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_M_BOLD_PARAGRAPH_SPACING: YLE_NEXT_M_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_M_BOLD_TEXT_CASE: YLE_NEXT_M_BOLD_TEXT_CASE,
  YLE_NEXT_M_BOLD_TEXT_DECORATION: YLE_NEXT_M_BOLD_TEXT_DECORATION,
  YLE_NEXT_M_FONT_FAMILY: YLE_NEXT_M_FONT_FAMILY,
  YLE_NEXT_M_FONT_SIZE: YLE_NEXT_M_FONT_SIZE,
  YLE_NEXT_M_FONT_STRETCH: YLE_NEXT_M_FONT_STRETCH,
  YLE_NEXT_M_FONT_STYLE: YLE_NEXT_M_FONT_STYLE,
  YLE_NEXT_M_FONT_STYLE_OLD: YLE_NEXT_M_FONT_STYLE_OLD,
  YLE_NEXT_M_FONT_WEIGHT: YLE_NEXT_M_FONT_WEIGHT,
  YLE_NEXT_M_ITALIC_FONT_FAMILY: YLE_NEXT_M_ITALIC_FONT_FAMILY,
  YLE_NEXT_M_ITALIC_FONT_SIZE: YLE_NEXT_M_ITALIC_FONT_SIZE,
  YLE_NEXT_M_ITALIC_FONT_STRETCH: YLE_NEXT_M_ITALIC_FONT_STRETCH,
  YLE_NEXT_M_ITALIC_FONT_STYLE: YLE_NEXT_M_ITALIC_FONT_STYLE,
  YLE_NEXT_M_ITALIC_FONT_STYLE_OLD: YLE_NEXT_M_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_M_ITALIC_FONT_WEIGHT: YLE_NEXT_M_ITALIC_FONT_WEIGHT,
  YLE_NEXT_M_ITALIC_LETTER_SPACING: YLE_NEXT_M_ITALIC_LETTER_SPACING,
  YLE_NEXT_M_ITALIC_LINE_HEIGHT: YLE_NEXT_M_ITALIC_LINE_HEIGHT,
  YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_M_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_M_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_M_ITALIC_TEXT_CASE: YLE_NEXT_M_ITALIC_TEXT_CASE,
  YLE_NEXT_M_ITALIC_TEXT_DECORATION: YLE_NEXT_M_ITALIC_TEXT_DECORATION,
  YLE_NEXT_M_LETTER_SPACING: YLE_NEXT_M_LETTER_SPACING,
  YLE_NEXT_M_LINE_HEIGHT: YLE_NEXT_M_LINE_HEIGHT,
  YLE_NEXT_M_MEDIUM_FONT_FAMILY: YLE_NEXT_M_MEDIUM_FONT_FAMILY,
  YLE_NEXT_M_MEDIUM_FONT_SIZE: YLE_NEXT_M_MEDIUM_FONT_SIZE,
  YLE_NEXT_M_MEDIUM_FONT_STRETCH: YLE_NEXT_M_MEDIUM_FONT_STRETCH,
  YLE_NEXT_M_MEDIUM_FONT_STYLE: YLE_NEXT_M_MEDIUM_FONT_STYLE,
  YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD: YLE_NEXT_M_MEDIUM_FONT_STYLE_OLD,
  YLE_NEXT_M_MEDIUM_FONT_WEIGHT: YLE_NEXT_M_MEDIUM_FONT_WEIGHT,
  YLE_NEXT_M_MEDIUM_LETTER_SPACING: YLE_NEXT_M_MEDIUM_LETTER_SPACING,
  YLE_NEXT_M_MEDIUM_LINE_HEIGHT: YLE_NEXT_M_MEDIUM_LINE_HEIGHT,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT: YLE_NEXT_M_MEDIUM_PARAGRAPH_INDENT,
  YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING: YLE_NEXT_M_MEDIUM_PARAGRAPH_SPACING,
  YLE_NEXT_M_MEDIUM_TEXT_CASE: YLE_NEXT_M_MEDIUM_TEXT_CASE,
  YLE_NEXT_M_MEDIUM_TEXT_DECORATION: YLE_NEXT_M_MEDIUM_TEXT_DECORATION,
  YLE_NEXT_M_PARAGRAPH_INDENT: YLE_NEXT_M_PARAGRAPH_INDENT,
  YLE_NEXT_M_PARAGRAPH_SPACING: YLE_NEXT_M_PARAGRAPH_SPACING,
  YLE_NEXT_M_TEXT_CASE: YLE_NEXT_M_TEXT_CASE,
  YLE_NEXT_M_TEXT_DECORATION: YLE_NEXT_M_TEXT_DECORATION,
  YLE_NEXT_S_AC_FONT_FAMILY: YLE_NEXT_S_AC_FONT_FAMILY,
  YLE_NEXT_S_AC_FONT_SIZE: YLE_NEXT_S_AC_FONT_SIZE,
  YLE_NEXT_S_AC_FONT_STRETCH: YLE_NEXT_S_AC_FONT_STRETCH,
  YLE_NEXT_S_AC_FONT_STYLE: YLE_NEXT_S_AC_FONT_STYLE,
  YLE_NEXT_S_AC_FONT_STYLE_OLD: YLE_NEXT_S_AC_FONT_STYLE_OLD,
  YLE_NEXT_S_AC_FONT_WEIGHT: YLE_NEXT_S_AC_FONT_WEIGHT,
  YLE_NEXT_S_AC_LETTER_SPACING: YLE_NEXT_S_AC_LETTER_SPACING,
  YLE_NEXT_S_AC_LINE_HEIGHT: YLE_NEXT_S_AC_LINE_HEIGHT,
  YLE_NEXT_S_AC_PARAGRAPH_INDENT: YLE_NEXT_S_AC_PARAGRAPH_INDENT,
  YLE_NEXT_S_AC_PARAGRAPH_SPACING: YLE_NEXT_S_AC_PARAGRAPH_SPACING,
  YLE_NEXT_S_AC_TEXT_CASE: YLE_NEXT_S_AC_TEXT_CASE,
  YLE_NEXT_S_AC_TEXT_DECORATION: YLE_NEXT_S_AC_TEXT_DECORATION,
  YLE_NEXT_S_BOLD_AC_FONT_FAMILY: YLE_NEXT_S_BOLD_AC_FONT_FAMILY,
  YLE_NEXT_S_BOLD_AC_FONT_SIZE: YLE_NEXT_S_BOLD_AC_FONT_SIZE,
  YLE_NEXT_S_BOLD_AC_FONT_STRETCH: YLE_NEXT_S_BOLD_AC_FONT_STRETCH,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE: YLE_NEXT_S_BOLD_AC_FONT_STYLE,
  YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_AC_FONT_STYLE_OLD,
  YLE_NEXT_S_BOLD_AC_FONT_WEIGHT: YLE_NEXT_S_BOLD_AC_FONT_WEIGHT,
  YLE_NEXT_S_BOLD_AC_LETTER_SPACING: YLE_NEXT_S_BOLD_AC_LETTER_SPACING,
  YLE_NEXT_S_BOLD_AC_LINE_HEIGHT: YLE_NEXT_S_BOLD_AC_LINE_HEIGHT,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_AC_PARAGRAPH_INDENT,
  YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_AC_PARAGRAPH_SPACING,
  YLE_NEXT_S_BOLD_AC_TEXT_CASE: YLE_NEXT_S_BOLD_AC_TEXT_CASE,
  YLE_NEXT_S_BOLD_AC_TEXT_DECORATION: YLE_NEXT_S_BOLD_AC_TEXT_DECORATION,
  YLE_NEXT_S_BOLD_FONT_FAMILY: YLE_NEXT_S_BOLD_FONT_FAMILY,
  YLE_NEXT_S_BOLD_FONT_SIZE: YLE_NEXT_S_BOLD_FONT_SIZE,
  YLE_NEXT_S_BOLD_FONT_STRETCH: YLE_NEXT_S_BOLD_FONT_STRETCH,
  YLE_NEXT_S_BOLD_FONT_STYLE: YLE_NEXT_S_BOLD_FONT_STYLE,
  YLE_NEXT_S_BOLD_FONT_STYLE_OLD: YLE_NEXT_S_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_S_BOLD_FONT_WEIGHT: YLE_NEXT_S_BOLD_FONT_WEIGHT,
  YLE_NEXT_S_BOLD_LETTER_SPACING: YLE_NEXT_S_BOLD_LETTER_SPACING,
  YLE_NEXT_S_BOLD_LINE_HEIGHT: YLE_NEXT_S_BOLD_LINE_HEIGHT,
  YLE_NEXT_S_BOLD_PARAGRAPH_INDENT: YLE_NEXT_S_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_S_BOLD_PARAGRAPH_SPACING: YLE_NEXT_S_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_S_BOLD_TEXT_CASE: YLE_NEXT_S_BOLD_TEXT_CASE,
  YLE_NEXT_S_BOLD_TEXT_DECORATION: YLE_NEXT_S_BOLD_TEXT_DECORATION,
  YLE_NEXT_S_FONT_FAMILY: YLE_NEXT_S_FONT_FAMILY,
  YLE_NEXT_S_FONT_SIZE: YLE_NEXT_S_FONT_SIZE,
  YLE_NEXT_S_FONT_STRETCH: YLE_NEXT_S_FONT_STRETCH,
  YLE_NEXT_S_FONT_STYLE: YLE_NEXT_S_FONT_STYLE,
  YLE_NEXT_S_FONT_STYLE_OLD: YLE_NEXT_S_FONT_STYLE_OLD,
  YLE_NEXT_S_FONT_WEIGHT: YLE_NEXT_S_FONT_WEIGHT,
  YLE_NEXT_S_ITALIC_FONT_FAMILY: YLE_NEXT_S_ITALIC_FONT_FAMILY,
  YLE_NEXT_S_ITALIC_FONT_SIZE: YLE_NEXT_S_ITALIC_FONT_SIZE,
  YLE_NEXT_S_ITALIC_FONT_STRETCH: YLE_NEXT_S_ITALIC_FONT_STRETCH,
  YLE_NEXT_S_ITALIC_FONT_STYLE: YLE_NEXT_S_ITALIC_FONT_STYLE,
  YLE_NEXT_S_ITALIC_FONT_STYLE_OLD: YLE_NEXT_S_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_S_ITALIC_FONT_WEIGHT: YLE_NEXT_S_ITALIC_FONT_WEIGHT,
  YLE_NEXT_S_ITALIC_LETTER_SPACING: YLE_NEXT_S_ITALIC_LETTER_SPACING,
  YLE_NEXT_S_ITALIC_LINE_HEIGHT: YLE_NEXT_S_ITALIC_LINE_HEIGHT,
  YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_S_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_S_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_S_ITALIC_TEXT_CASE: YLE_NEXT_S_ITALIC_TEXT_CASE,
  YLE_NEXT_S_ITALIC_TEXT_DECORATION: YLE_NEXT_S_ITALIC_TEXT_DECORATION,
  YLE_NEXT_S_LETTER_SPACING: YLE_NEXT_S_LETTER_SPACING,
  YLE_NEXT_S_LINE_HEIGHT: YLE_NEXT_S_LINE_HEIGHT,
  YLE_NEXT_S_PARAGRAPH_INDENT: YLE_NEXT_S_PARAGRAPH_INDENT,
  YLE_NEXT_S_PARAGRAPH_SPACING: YLE_NEXT_S_PARAGRAPH_SPACING,
  YLE_NEXT_S_TEXT_CASE: YLE_NEXT_S_TEXT_CASE,
  YLE_NEXT_S_TEXT_DECORATION: YLE_NEXT_S_TEXT_DECORATION,
  YLE_NEXT_XL_BOLD_FONT_FAMILY: YLE_NEXT_XL_BOLD_FONT_FAMILY,
  YLE_NEXT_XL_BOLD_FONT_SIZE: YLE_NEXT_XL_BOLD_FONT_SIZE,
  YLE_NEXT_XL_BOLD_FONT_STRETCH: YLE_NEXT_XL_BOLD_FONT_STRETCH,
  YLE_NEXT_XL_BOLD_FONT_STYLE: YLE_NEXT_XL_BOLD_FONT_STYLE,
  YLE_NEXT_XL_BOLD_FONT_STYLE_OLD: YLE_NEXT_XL_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_XL_BOLD_FONT_WEIGHT: YLE_NEXT_XL_BOLD_FONT_WEIGHT,
  YLE_NEXT_XL_BOLD_LETTER_SPACING: YLE_NEXT_XL_BOLD_LETTER_SPACING,
  YLE_NEXT_XL_BOLD_LINE_HEIGHT: YLE_NEXT_XL_BOLD_LINE_HEIGHT,
  YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XL_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XL_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_XL_BOLD_TEXT_CASE: YLE_NEXT_XL_BOLD_TEXT_CASE,
  YLE_NEXT_XL_BOLD_TEXT_DECORATION: YLE_NEXT_XL_BOLD_TEXT_DECORATION,
  YLE_NEXT_XL_FONT_FAMILY: YLE_NEXT_XL_FONT_FAMILY,
  YLE_NEXT_XL_FONT_SIZE: YLE_NEXT_XL_FONT_SIZE,
  YLE_NEXT_XL_FONT_STRETCH: YLE_NEXT_XL_FONT_STRETCH,
  YLE_NEXT_XL_FONT_STYLE: YLE_NEXT_XL_FONT_STYLE,
  YLE_NEXT_XL_FONT_STYLE_OLD: YLE_NEXT_XL_FONT_STYLE_OLD,
  YLE_NEXT_XL_FONT_WEIGHT: YLE_NEXT_XL_FONT_WEIGHT,
  YLE_NEXT_XL_HEAVY_FONT_FAMILY: YLE_NEXT_XL_HEAVY_FONT_FAMILY,
  YLE_NEXT_XL_HEAVY_FONT_SIZE: YLE_NEXT_XL_HEAVY_FONT_SIZE,
  YLE_NEXT_XL_HEAVY_FONT_STRETCH: YLE_NEXT_XL_HEAVY_FONT_STRETCH,
  YLE_NEXT_XL_HEAVY_FONT_STYLE: YLE_NEXT_XL_HEAVY_FONT_STYLE,
  YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD: YLE_NEXT_XL_HEAVY_FONT_STYLE_OLD,
  YLE_NEXT_XL_HEAVY_FONT_WEIGHT: YLE_NEXT_XL_HEAVY_FONT_WEIGHT,
  YLE_NEXT_XL_HEAVY_LETTER_SPACING: YLE_NEXT_XL_HEAVY_LETTER_SPACING,
  YLE_NEXT_XL_HEAVY_LINE_HEIGHT: YLE_NEXT_XL_HEAVY_LINE_HEIGHT,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT: YLE_NEXT_XL_HEAVY_PARAGRAPH_INDENT,
  YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING: YLE_NEXT_XL_HEAVY_PARAGRAPH_SPACING,
  YLE_NEXT_XL_HEAVY_TEXT_CASE: YLE_NEXT_XL_HEAVY_TEXT_CASE,
  YLE_NEXT_XL_HEAVY_TEXT_DECORATION: YLE_NEXT_XL_HEAVY_TEXT_DECORATION,
  YLE_NEXT_XL_ITALIC_FONT_FAMILY: YLE_NEXT_XL_ITALIC_FONT_FAMILY,
  YLE_NEXT_XL_ITALIC_FONT_SIZE: YLE_NEXT_XL_ITALIC_FONT_SIZE,
  YLE_NEXT_XL_ITALIC_FONT_STRETCH: YLE_NEXT_XL_ITALIC_FONT_STRETCH,
  YLE_NEXT_XL_ITALIC_FONT_STYLE: YLE_NEXT_XL_ITALIC_FONT_STYLE,
  YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XL_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_XL_ITALIC_FONT_WEIGHT: YLE_NEXT_XL_ITALIC_FONT_WEIGHT,
  YLE_NEXT_XL_ITALIC_LETTER_SPACING: YLE_NEXT_XL_ITALIC_LETTER_SPACING,
  YLE_NEXT_XL_ITALIC_LINE_HEIGHT: YLE_NEXT_XL_ITALIC_LINE_HEIGHT,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XL_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XL_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_XL_ITALIC_TEXT_CASE: YLE_NEXT_XL_ITALIC_TEXT_CASE,
  YLE_NEXT_XL_ITALIC_TEXT_DECORATION: YLE_NEXT_XL_ITALIC_TEXT_DECORATION,
  YLE_NEXT_XL_LETTER_SPACING: YLE_NEXT_XL_LETTER_SPACING,
  YLE_NEXT_XL_LINE_HEIGHT: YLE_NEXT_XL_LINE_HEIGHT,
  YLE_NEXT_XL_PARAGRAPH_INDENT: YLE_NEXT_XL_PARAGRAPH_INDENT,
  YLE_NEXT_XL_PARAGRAPH_SPACING: YLE_NEXT_XL_PARAGRAPH_SPACING,
  YLE_NEXT_XL_TEXT_CASE: YLE_NEXT_XL_TEXT_CASE,
  YLE_NEXT_XL_TEXT_DECORATION: YLE_NEXT_XL_TEXT_DECORATION,
  YLE_NEXT_XS_AC_FONT_FAMILY: YLE_NEXT_XS_AC_FONT_FAMILY,
  YLE_NEXT_XS_AC_FONT_SIZE: YLE_NEXT_XS_AC_FONT_SIZE,
  YLE_NEXT_XS_AC_FONT_STRETCH: YLE_NEXT_XS_AC_FONT_STRETCH,
  YLE_NEXT_XS_AC_FONT_STYLE: YLE_NEXT_XS_AC_FONT_STYLE,
  YLE_NEXT_XS_AC_FONT_STYLE_OLD: YLE_NEXT_XS_AC_FONT_STYLE_OLD,
  YLE_NEXT_XS_AC_FONT_WEIGHT: YLE_NEXT_XS_AC_FONT_WEIGHT,
  YLE_NEXT_XS_AC_LETTER_SPACING: YLE_NEXT_XS_AC_LETTER_SPACING,
  YLE_NEXT_XS_AC_LINE_HEIGHT: YLE_NEXT_XS_AC_LINE_HEIGHT,
  YLE_NEXT_XS_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_AC_PARAGRAPH_INDENT,
  YLE_NEXT_XS_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_AC_PARAGRAPH_SPACING,
  YLE_NEXT_XS_AC_TEXT_CASE: YLE_NEXT_XS_AC_TEXT_CASE,
  YLE_NEXT_XS_AC_TEXT_DECORATION: YLE_NEXT_XS_AC_TEXT_DECORATION,
  YLE_NEXT_XS_BOLD_AC_FONT_FAMILY: YLE_NEXT_XS_BOLD_AC_FONT_FAMILY,
  YLE_NEXT_XS_BOLD_AC_FONT_SIZE: YLE_NEXT_XS_BOLD_AC_FONT_SIZE,
  YLE_NEXT_XS_BOLD_AC_FONT_STRETCH: YLE_NEXT_XS_BOLD_AC_FONT_STRETCH,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE: YLE_NEXT_XS_BOLD_AC_FONT_STYLE,
  YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_AC_FONT_STYLE_OLD,
  YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT: YLE_NEXT_XS_BOLD_AC_FONT_WEIGHT,
  YLE_NEXT_XS_BOLD_AC_LETTER_SPACING: YLE_NEXT_XS_BOLD_AC_LETTER_SPACING,
  YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT: YLE_NEXT_XS_BOLD_AC_LINE_HEIGHT,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_INDENT,
  YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_AC_PARAGRAPH_SPACING,
  YLE_NEXT_XS_BOLD_AC_TEXT_CASE: YLE_NEXT_XS_BOLD_AC_TEXT_CASE,
  YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION: YLE_NEXT_XS_BOLD_AC_TEXT_DECORATION,
  YLE_NEXT_XS_BOLD_FONT_FAMILY: YLE_NEXT_XS_BOLD_FONT_FAMILY,
  YLE_NEXT_XS_BOLD_FONT_SIZE: YLE_NEXT_XS_BOLD_FONT_SIZE,
  YLE_NEXT_XS_BOLD_FONT_STRETCH: YLE_NEXT_XS_BOLD_FONT_STRETCH,
  YLE_NEXT_XS_BOLD_FONT_STYLE: YLE_NEXT_XS_BOLD_FONT_STYLE,
  YLE_NEXT_XS_BOLD_FONT_STYLE_OLD: YLE_NEXT_XS_BOLD_FONT_STYLE_OLD,
  YLE_NEXT_XS_BOLD_FONT_WEIGHT: YLE_NEXT_XS_BOLD_FONT_WEIGHT,
  YLE_NEXT_XS_BOLD_LETTER_SPACING: YLE_NEXT_XS_BOLD_LETTER_SPACING,
  YLE_NEXT_XS_BOLD_LINE_HEIGHT: YLE_NEXT_XS_BOLD_LINE_HEIGHT,
  YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT: YLE_NEXT_XS_BOLD_PARAGRAPH_INDENT,
  YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING: YLE_NEXT_XS_BOLD_PARAGRAPH_SPACING,
  YLE_NEXT_XS_BOLD_TEXT_CASE: YLE_NEXT_XS_BOLD_TEXT_CASE,
  YLE_NEXT_XS_BOLD_TEXT_DECORATION: YLE_NEXT_XS_BOLD_TEXT_DECORATION,
  YLE_NEXT_XS_FONT_FAMILY: YLE_NEXT_XS_FONT_FAMILY,
  YLE_NEXT_XS_FONT_SIZE: YLE_NEXT_XS_FONT_SIZE,
  YLE_NEXT_XS_FONT_STRETCH: YLE_NEXT_XS_FONT_STRETCH,
  YLE_NEXT_XS_FONT_STYLE: YLE_NEXT_XS_FONT_STYLE,
  YLE_NEXT_XS_FONT_STYLE_OLD: YLE_NEXT_XS_FONT_STYLE_OLD,
  YLE_NEXT_XS_FONT_WEIGHT: YLE_NEXT_XS_FONT_WEIGHT,
  YLE_NEXT_XS_ITALIC_FONT_FAMILY: YLE_NEXT_XS_ITALIC_FONT_FAMILY,
  YLE_NEXT_XS_ITALIC_FONT_SIZE: YLE_NEXT_XS_ITALIC_FONT_SIZE,
  YLE_NEXT_XS_ITALIC_FONT_STRETCH: YLE_NEXT_XS_ITALIC_FONT_STRETCH,
  YLE_NEXT_XS_ITALIC_FONT_STYLE: YLE_NEXT_XS_ITALIC_FONT_STYLE,
  YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD: YLE_NEXT_XS_ITALIC_FONT_STYLE_OLD,
  YLE_NEXT_XS_ITALIC_FONT_WEIGHT: YLE_NEXT_XS_ITALIC_FONT_WEIGHT,
  YLE_NEXT_XS_ITALIC_LETTER_SPACING: YLE_NEXT_XS_ITALIC_LETTER_SPACING,
  YLE_NEXT_XS_ITALIC_LINE_HEIGHT: YLE_NEXT_XS_ITALIC_LINE_HEIGHT,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT: YLE_NEXT_XS_ITALIC_PARAGRAPH_INDENT,
  YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING: YLE_NEXT_XS_ITALIC_PARAGRAPH_SPACING,
  YLE_NEXT_XS_ITALIC_TEXT_CASE: YLE_NEXT_XS_ITALIC_TEXT_CASE,
  YLE_NEXT_XS_ITALIC_TEXT_DECORATION: YLE_NEXT_XS_ITALIC_TEXT_DECORATION,
  YLE_NEXT_XS_LETTER_SPACING: YLE_NEXT_XS_LETTER_SPACING,
  YLE_NEXT_XS_LINE_HEIGHT: YLE_NEXT_XS_LINE_HEIGHT,
  YLE_NEXT_XS_PARAGRAPH_INDENT: YLE_NEXT_XS_PARAGRAPH_INDENT,
  YLE_NEXT_XS_PARAGRAPH_SPACING: YLE_NEXT_XS_PARAGRAPH_SPACING,
  YLE_NEXT_XS_TEXT_CASE: YLE_NEXT_XS_TEXT_CASE,
  YLE_NEXT_XS_TEXT_DECORATION: YLE_NEXT_XS_TEXT_DECORATION,
  YLE_SANS_2XL_BLACK_FONT_FAMILY: YLE_SANS_2XL_BLACK_FONT_FAMILY,
  YLE_SANS_2XL_BLACK_FONT_SIZE: YLE_SANS_2XL_BLACK_FONT_SIZE,
  YLE_SANS_2XL_BLACK_FONT_STRETCH: YLE_SANS_2XL_BLACK_FONT_STRETCH,
  YLE_SANS_2XL_BLACK_FONT_STYLE: YLE_SANS_2XL_BLACK_FONT_STYLE,
  YLE_SANS_2XL_BLACK_FONT_STYLE_OLD: YLE_SANS_2XL_BLACK_FONT_STYLE_OLD,
  YLE_SANS_2XL_BLACK_FONT_WEIGHT: YLE_SANS_2XL_BLACK_FONT_WEIGHT,
  YLE_SANS_2XL_BLACK_LETTER_SPACING: YLE_SANS_2XL_BLACK_LETTER_SPACING,
  YLE_SANS_2XL_BLACK_LINE_HEIGHT: YLE_SANS_2XL_BLACK_LINE_HEIGHT,
  YLE_SANS_2XL_BLACK_PARAGRAPH_INDENT: YLE_SANS_2XL_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_2XL_BLACK_PARAGRAPH_SPACING: YLE_SANS_2XL_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_2XL_BLACK_TEXT_CASE: YLE_SANS_2XL_BLACK_TEXT_CASE,
  YLE_SANS_2XL_BLACK_TEXT_DECORATION: YLE_SANS_2XL_BLACK_TEXT_DECORATION,
  YLE_SANS_2XL_BOLD_FONT_FAMILY: YLE_SANS_2XL_BOLD_FONT_FAMILY,
  YLE_SANS_2XL_BOLD_FONT_SIZE: YLE_SANS_2XL_BOLD_FONT_SIZE,
  YLE_SANS_2XL_BOLD_FONT_STRETCH: YLE_SANS_2XL_BOLD_FONT_STRETCH,
  YLE_SANS_2XL_BOLD_FONT_STYLE: YLE_SANS_2XL_BOLD_FONT_STYLE,
  YLE_SANS_2XL_BOLD_FONT_STYLE_OLD: YLE_SANS_2XL_BOLD_FONT_STYLE_OLD,
  YLE_SANS_2XL_BOLD_FONT_WEIGHT: YLE_SANS_2XL_BOLD_FONT_WEIGHT,
  YLE_SANS_2XL_BOLD_LETTER_SPACING: YLE_SANS_2XL_BOLD_LETTER_SPACING,
  YLE_SANS_2XL_BOLD_LINE_HEIGHT: YLE_SANS_2XL_BOLD_LINE_HEIGHT,
  YLE_SANS_2XL_BOLD_PARAGRAPH_INDENT: YLE_SANS_2XL_BOLD_PARAGRAPH_INDENT,
  YLE_SANS_2XL_BOLD_PARAGRAPH_SPACING: YLE_SANS_2XL_BOLD_PARAGRAPH_SPACING,
  YLE_SANS_2XL_BOLD_TEXT_CASE: YLE_SANS_2XL_BOLD_TEXT_CASE,
  YLE_SANS_2XL_BOLD_TEXT_DECORATION: YLE_SANS_2XL_BOLD_TEXT_DECORATION,
  YLE_SANS_3XL_BLACK_FONT_FAMILY: YLE_SANS_3XL_BLACK_FONT_FAMILY,
  YLE_SANS_3XL_BLACK_FONT_SIZE: YLE_SANS_3XL_BLACK_FONT_SIZE,
  YLE_SANS_3XL_BLACK_FONT_STRETCH: YLE_SANS_3XL_BLACK_FONT_STRETCH,
  YLE_SANS_3XL_BLACK_FONT_STYLE: YLE_SANS_3XL_BLACK_FONT_STYLE,
  YLE_SANS_3XL_BLACK_FONT_STYLE_OLD: YLE_SANS_3XL_BLACK_FONT_STYLE_OLD,
  YLE_SANS_3XL_BLACK_FONT_WEIGHT: YLE_SANS_3XL_BLACK_FONT_WEIGHT,
  YLE_SANS_3XL_BLACK_LETTER_SPACING: YLE_SANS_3XL_BLACK_LETTER_SPACING,
  YLE_SANS_3XL_BLACK_LINE_HEIGHT: YLE_SANS_3XL_BLACK_LINE_HEIGHT,
  YLE_SANS_3XL_BLACK_PARAGRAPH_INDENT: YLE_SANS_3XL_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_3XL_BLACK_PARAGRAPH_SPACING: YLE_SANS_3XL_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_3XL_BLACK_TEXT_CASE: YLE_SANS_3XL_BLACK_TEXT_CASE,
  YLE_SANS_3XL_BLACK_TEXT_DECORATION: YLE_SANS_3XL_BLACK_TEXT_DECORATION,
  YLE_SANS_3XL_BOLD_FONT_FAMILY: YLE_SANS_3XL_BOLD_FONT_FAMILY,
  YLE_SANS_3XL_BOLD_FONT_SIZE: YLE_SANS_3XL_BOLD_FONT_SIZE,
  YLE_SANS_3XL_BOLD_FONT_STRETCH: YLE_SANS_3XL_BOLD_FONT_STRETCH,
  YLE_SANS_3XL_BOLD_FONT_STYLE: YLE_SANS_3XL_BOLD_FONT_STYLE,
  YLE_SANS_3XL_BOLD_FONT_STYLE_OLD: YLE_SANS_3XL_BOLD_FONT_STYLE_OLD,
  YLE_SANS_3XL_BOLD_FONT_WEIGHT: YLE_SANS_3XL_BOLD_FONT_WEIGHT,
  YLE_SANS_3XL_BOLD_LETTER_SPACING: YLE_SANS_3XL_BOLD_LETTER_SPACING,
  YLE_SANS_3XL_BOLD_LINE_HEIGHT: YLE_SANS_3XL_BOLD_LINE_HEIGHT,
  YLE_SANS_3XL_BOLD_PARAGRAPH_INDENT: YLE_SANS_3XL_BOLD_PARAGRAPH_INDENT,
  YLE_SANS_3XL_BOLD_PARAGRAPH_SPACING: YLE_SANS_3XL_BOLD_PARAGRAPH_SPACING,
  YLE_SANS_3XL_BOLD_TEXT_CASE: YLE_SANS_3XL_BOLD_TEXT_CASE,
  YLE_SANS_3XL_BOLD_TEXT_DECORATION: YLE_SANS_3XL_BOLD_TEXT_DECORATION,
  YLE_SANS_4XL_BLACK_FONT_FAMILY: YLE_SANS_4XL_BLACK_FONT_FAMILY,
  YLE_SANS_4XL_BLACK_FONT_SIZE: YLE_SANS_4XL_BLACK_FONT_SIZE,
  YLE_SANS_4XL_BLACK_FONT_STRETCH: YLE_SANS_4XL_BLACK_FONT_STRETCH,
  YLE_SANS_4XL_BLACK_FONT_STYLE: YLE_SANS_4XL_BLACK_FONT_STYLE,
  YLE_SANS_4XL_BLACK_FONT_STYLE_OLD: YLE_SANS_4XL_BLACK_FONT_STYLE_OLD,
  YLE_SANS_4XL_BLACK_FONT_WEIGHT: YLE_SANS_4XL_BLACK_FONT_WEIGHT,
  YLE_SANS_4XL_BLACK_LETTER_SPACING: YLE_SANS_4XL_BLACK_LETTER_SPACING,
  YLE_SANS_4XL_BLACK_LINE_HEIGHT: YLE_SANS_4XL_BLACK_LINE_HEIGHT,
  YLE_SANS_4XL_BLACK_PARAGRAPH_INDENT: YLE_SANS_4XL_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_4XL_BLACK_PARAGRAPH_SPACING: YLE_SANS_4XL_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_4XL_BLACK_TEXT_CASE: YLE_SANS_4XL_BLACK_TEXT_CASE,
  YLE_SANS_4XL_BLACK_TEXT_DECORATION: YLE_SANS_4XL_BLACK_TEXT_DECORATION,
  YLE_SANS_4XL_BOLD_FONT_FAMILY: YLE_SANS_4XL_BOLD_FONT_FAMILY,
  YLE_SANS_4XL_BOLD_FONT_SIZE: YLE_SANS_4XL_BOLD_FONT_SIZE,
  YLE_SANS_4XL_BOLD_FONT_STRETCH: YLE_SANS_4XL_BOLD_FONT_STRETCH,
  YLE_SANS_4XL_BOLD_FONT_STYLE: YLE_SANS_4XL_BOLD_FONT_STYLE,
  YLE_SANS_4XL_BOLD_FONT_STYLE_OLD: YLE_SANS_4XL_BOLD_FONT_STYLE_OLD,
  YLE_SANS_4XL_BOLD_FONT_WEIGHT: YLE_SANS_4XL_BOLD_FONT_WEIGHT,
  YLE_SANS_4XL_BOLD_LETTER_SPACING: YLE_SANS_4XL_BOLD_LETTER_SPACING,
  YLE_SANS_4XL_BOLD_LINE_HEIGHT: YLE_SANS_4XL_BOLD_LINE_HEIGHT,
  YLE_SANS_4XL_BOLD_PARAGRAPH_INDENT: YLE_SANS_4XL_BOLD_PARAGRAPH_INDENT,
  YLE_SANS_4XL_BOLD_PARAGRAPH_SPACING: YLE_SANS_4XL_BOLD_PARAGRAPH_SPACING,
  YLE_SANS_4XL_BOLD_TEXT_CASE: YLE_SANS_4XL_BOLD_TEXT_CASE,
  YLE_SANS_4XL_BOLD_TEXT_DECORATION: YLE_SANS_4XL_BOLD_TEXT_DECORATION,
  YLE_SANS_5XL_BLACK_FONT_FAMILY: YLE_SANS_5XL_BLACK_FONT_FAMILY,
  YLE_SANS_5XL_BLACK_FONT_SIZE: YLE_SANS_5XL_BLACK_FONT_SIZE,
  YLE_SANS_5XL_BLACK_FONT_STRETCH: YLE_SANS_5XL_BLACK_FONT_STRETCH,
  YLE_SANS_5XL_BLACK_FONT_STYLE: YLE_SANS_5XL_BLACK_FONT_STYLE,
  YLE_SANS_5XL_BLACK_FONT_STYLE_OLD: YLE_SANS_5XL_BLACK_FONT_STYLE_OLD,
  YLE_SANS_5XL_BLACK_FONT_WEIGHT: YLE_SANS_5XL_BLACK_FONT_WEIGHT,
  YLE_SANS_5XL_BLACK_LETTER_SPACING: YLE_SANS_5XL_BLACK_LETTER_SPACING,
  YLE_SANS_5XL_BLACK_LINE_HEIGHT: YLE_SANS_5XL_BLACK_LINE_HEIGHT,
  YLE_SANS_5XL_BLACK_PARAGRAPH_INDENT: YLE_SANS_5XL_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_5XL_BLACK_PARAGRAPH_SPACING: YLE_SANS_5XL_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_5XL_BLACK_TEXT_CASE: YLE_SANS_5XL_BLACK_TEXT_CASE,
  YLE_SANS_5XL_BLACK_TEXT_DECORATION: YLE_SANS_5XL_BLACK_TEXT_DECORATION,
  YLE_SANS_6XL_BLACK_FONT_FAMILY: YLE_SANS_6XL_BLACK_FONT_FAMILY,
  YLE_SANS_6XL_BLACK_FONT_SIZE: YLE_SANS_6XL_BLACK_FONT_SIZE,
  YLE_SANS_6XL_BLACK_FONT_STRETCH: YLE_SANS_6XL_BLACK_FONT_STRETCH,
  YLE_SANS_6XL_BLACK_FONT_STYLE: YLE_SANS_6XL_BLACK_FONT_STYLE,
  YLE_SANS_6XL_BLACK_FONT_STYLE_OLD: YLE_SANS_6XL_BLACK_FONT_STYLE_OLD,
  YLE_SANS_6XL_BLACK_FONT_WEIGHT: YLE_SANS_6XL_BLACK_FONT_WEIGHT,
  YLE_SANS_6XL_BLACK_LETTER_SPACING: YLE_SANS_6XL_BLACK_LETTER_SPACING,
  YLE_SANS_6XL_BLACK_LINE_HEIGHT: YLE_SANS_6XL_BLACK_LINE_HEIGHT,
  YLE_SANS_6XL_BLACK_PARAGRAPH_INDENT: YLE_SANS_6XL_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_6XL_BLACK_PARAGRAPH_SPACING: YLE_SANS_6XL_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_6XL_BLACK_TEXT_CASE: YLE_SANS_6XL_BLACK_TEXT_CASE,
  YLE_SANS_6XL_BLACK_TEXT_DECORATION: YLE_SANS_6XL_BLACK_TEXT_DECORATION,
  YLE_SANS_7XL_BLACK_FONT_FAMILY: YLE_SANS_7XL_BLACK_FONT_FAMILY,
  YLE_SANS_7XL_BLACK_FONT_SIZE: YLE_SANS_7XL_BLACK_FONT_SIZE,
  YLE_SANS_7XL_BLACK_FONT_STRETCH: YLE_SANS_7XL_BLACK_FONT_STRETCH,
  YLE_SANS_7XL_BLACK_FONT_STYLE: YLE_SANS_7XL_BLACK_FONT_STYLE,
  YLE_SANS_7XL_BLACK_FONT_STYLE_OLD: YLE_SANS_7XL_BLACK_FONT_STYLE_OLD,
  YLE_SANS_7XL_BLACK_FONT_WEIGHT: YLE_SANS_7XL_BLACK_FONT_WEIGHT,
  YLE_SANS_7XL_BLACK_LETTER_SPACING: YLE_SANS_7XL_BLACK_LETTER_SPACING,
  YLE_SANS_7XL_BLACK_LINE_HEIGHT: YLE_SANS_7XL_BLACK_LINE_HEIGHT,
  YLE_SANS_7XL_BLACK_PARAGRAPH_INDENT: YLE_SANS_7XL_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_7XL_BLACK_PARAGRAPH_SPACING: YLE_SANS_7XL_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_7XL_BLACK_TEXT_CASE: YLE_SANS_7XL_BLACK_TEXT_CASE,
  YLE_SANS_7XL_BLACK_TEXT_DECORATION: YLE_SANS_7XL_BLACK_TEXT_DECORATION,
  YLE_SANS_L_BLACK_FONT_FAMILY: YLE_SANS_L_BLACK_FONT_FAMILY,
  YLE_SANS_L_BLACK_FONT_SIZE: YLE_SANS_L_BLACK_FONT_SIZE,
  YLE_SANS_L_BLACK_FONT_STRETCH: YLE_SANS_L_BLACK_FONT_STRETCH,
  YLE_SANS_L_BLACK_FONT_STYLE: YLE_SANS_L_BLACK_FONT_STYLE,
  YLE_SANS_L_BLACK_FONT_STYLE_OLD: YLE_SANS_L_BLACK_FONT_STYLE_OLD,
  YLE_SANS_L_BLACK_FONT_WEIGHT: YLE_SANS_L_BLACK_FONT_WEIGHT,
  YLE_SANS_L_BLACK_LETTER_SPACING: YLE_SANS_L_BLACK_LETTER_SPACING,
  YLE_SANS_L_BLACK_LINE_HEIGHT: YLE_SANS_L_BLACK_LINE_HEIGHT,
  YLE_SANS_L_BLACK_PARAGRAPH_INDENT: YLE_SANS_L_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_L_BLACK_PARAGRAPH_SPACING: YLE_SANS_L_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_L_BLACK_TEXT_CASE: YLE_SANS_L_BLACK_TEXT_CASE,
  YLE_SANS_L_BLACK_TEXT_DECORATION: YLE_SANS_L_BLACK_TEXT_DECORATION,
  YLE_SANS_L_BOLD_FONT_FAMILY: YLE_SANS_L_BOLD_FONT_FAMILY,
  YLE_SANS_L_BOLD_FONT_SIZE: YLE_SANS_L_BOLD_FONT_SIZE,
  YLE_SANS_L_BOLD_FONT_STRETCH: YLE_SANS_L_BOLD_FONT_STRETCH,
  YLE_SANS_L_BOLD_FONT_STYLE: YLE_SANS_L_BOLD_FONT_STYLE,
  YLE_SANS_L_BOLD_FONT_STYLE_OLD: YLE_SANS_L_BOLD_FONT_STYLE_OLD,
  YLE_SANS_L_BOLD_FONT_WEIGHT: YLE_SANS_L_BOLD_FONT_WEIGHT,
  YLE_SANS_L_BOLD_LETTER_SPACING: YLE_SANS_L_BOLD_LETTER_SPACING,
  YLE_SANS_L_BOLD_LINE_HEIGHT: YLE_SANS_L_BOLD_LINE_HEIGHT,
  YLE_SANS_L_BOLD_PARAGRAPH_INDENT: YLE_SANS_L_BOLD_PARAGRAPH_INDENT,
  YLE_SANS_L_BOLD_PARAGRAPH_SPACING: YLE_SANS_L_BOLD_PARAGRAPH_SPACING,
  YLE_SANS_L_BOLD_TEXT_CASE: YLE_SANS_L_BOLD_TEXT_CASE,
  YLE_SANS_L_BOLD_TEXT_DECORATION: YLE_SANS_L_BOLD_TEXT_DECORATION,
  YLE_SANS_M_BOLD_FONT_FAMILY: YLE_SANS_M_BOLD_FONT_FAMILY,
  YLE_SANS_M_BOLD_FONT_SIZE: YLE_SANS_M_BOLD_FONT_SIZE,
  YLE_SANS_M_BOLD_FONT_STRETCH: YLE_SANS_M_BOLD_FONT_STRETCH,
  YLE_SANS_M_BOLD_FONT_STYLE: YLE_SANS_M_BOLD_FONT_STYLE,
  YLE_SANS_M_BOLD_FONT_STYLE_OLD: YLE_SANS_M_BOLD_FONT_STYLE_OLD,
  YLE_SANS_M_BOLD_FONT_WEIGHT: YLE_SANS_M_BOLD_FONT_WEIGHT,
  YLE_SANS_M_BOLD_LETTER_SPACING: YLE_SANS_M_BOLD_LETTER_SPACING,
  YLE_SANS_M_BOLD_LINE_HEIGHT: YLE_SANS_M_BOLD_LINE_HEIGHT,
  YLE_SANS_M_BOLD_PARAGRAPH_INDENT: YLE_SANS_M_BOLD_PARAGRAPH_INDENT,
  YLE_SANS_M_BOLD_PARAGRAPH_SPACING: YLE_SANS_M_BOLD_PARAGRAPH_SPACING,
  YLE_SANS_M_BOLD_TEXT_CASE: YLE_SANS_M_BOLD_TEXT_CASE,
  YLE_SANS_M_BOLD_TEXT_DECORATION: YLE_SANS_M_BOLD_TEXT_DECORATION,
  YLE_SANS_S_BOLD_FONT_FAMILY: YLE_SANS_S_BOLD_FONT_FAMILY,
  YLE_SANS_S_BOLD_FONT_SIZE: YLE_SANS_S_BOLD_FONT_SIZE,
  YLE_SANS_S_BOLD_FONT_STRETCH: YLE_SANS_S_BOLD_FONT_STRETCH,
  YLE_SANS_S_BOLD_FONT_STYLE: YLE_SANS_S_BOLD_FONT_STYLE,
  YLE_SANS_S_BOLD_FONT_STYLE_OLD: YLE_SANS_S_BOLD_FONT_STYLE_OLD,
  YLE_SANS_S_BOLD_FONT_WEIGHT: YLE_SANS_S_BOLD_FONT_WEIGHT,
  YLE_SANS_S_BOLD_LETTER_SPACING: YLE_SANS_S_BOLD_LETTER_SPACING,
  YLE_SANS_S_BOLD_LINE_HEIGHT: YLE_SANS_S_BOLD_LINE_HEIGHT,
  YLE_SANS_S_BOLD_PARAGRAPH_INDENT: YLE_SANS_S_BOLD_PARAGRAPH_INDENT,
  YLE_SANS_S_BOLD_PARAGRAPH_SPACING: YLE_SANS_S_BOLD_PARAGRAPH_SPACING,
  YLE_SANS_S_BOLD_TEXT_CASE: YLE_SANS_S_BOLD_TEXT_CASE,
  YLE_SANS_S_BOLD_TEXT_DECORATION: YLE_SANS_S_BOLD_TEXT_DECORATION,
  YLE_SANS_XL_BLACK_FONT_FAMILY: YLE_SANS_XL_BLACK_FONT_FAMILY,
  YLE_SANS_XL_BLACK_FONT_SIZE: YLE_SANS_XL_BLACK_FONT_SIZE,
  YLE_SANS_XL_BLACK_FONT_STRETCH: YLE_SANS_XL_BLACK_FONT_STRETCH,
  YLE_SANS_XL_BLACK_FONT_STYLE: YLE_SANS_XL_BLACK_FONT_STYLE,
  YLE_SANS_XL_BLACK_FONT_STYLE_OLD: YLE_SANS_XL_BLACK_FONT_STYLE_OLD,
  YLE_SANS_XL_BLACK_FONT_WEIGHT: YLE_SANS_XL_BLACK_FONT_WEIGHT,
  YLE_SANS_XL_BLACK_LETTER_SPACING: YLE_SANS_XL_BLACK_LETTER_SPACING,
  YLE_SANS_XL_BLACK_LINE_HEIGHT: YLE_SANS_XL_BLACK_LINE_HEIGHT,
  YLE_SANS_XL_BLACK_PARAGRAPH_INDENT: YLE_SANS_XL_BLACK_PARAGRAPH_INDENT,
  YLE_SANS_XL_BLACK_PARAGRAPH_SPACING: YLE_SANS_XL_BLACK_PARAGRAPH_SPACING,
  YLE_SANS_XL_BLACK_TEXT_CASE: YLE_SANS_XL_BLACK_TEXT_CASE,
  YLE_SANS_XL_BLACK_TEXT_DECORATION: YLE_SANS_XL_BLACK_TEXT_DECORATION,
  YLE_SANS_XL_BOLD_FONT_FAMILY: YLE_SANS_XL_BOLD_FONT_FAMILY,
  YLE_SANS_XL_BOLD_FONT_SIZE: YLE_SANS_XL_BOLD_FONT_SIZE,
  YLE_SANS_XL_BOLD_FONT_STRETCH: YLE_SANS_XL_BOLD_FONT_STRETCH,
  YLE_SANS_XL_BOLD_FONT_STYLE: YLE_SANS_XL_BOLD_FONT_STYLE,
  YLE_SANS_XL_BOLD_FONT_STYLE_OLD: YLE_SANS_XL_BOLD_FONT_STYLE_OLD,
  YLE_SANS_XL_BOLD_FONT_WEIGHT: YLE_SANS_XL_BOLD_FONT_WEIGHT,
  YLE_SANS_XL_BOLD_LETTER_SPACING: YLE_SANS_XL_BOLD_LETTER_SPACING,
  YLE_SANS_XL_BOLD_LINE_HEIGHT: YLE_SANS_XL_BOLD_LINE_HEIGHT,
  YLE_SANS_XL_BOLD_PARAGRAPH_INDENT: YLE_SANS_XL_BOLD_PARAGRAPH_INDENT,
  YLE_SANS_XL_BOLD_PARAGRAPH_SPACING: YLE_SANS_XL_BOLD_PARAGRAPH_SPACING,
  YLE_SANS_XL_BOLD_TEXT_CASE: YLE_SANS_XL_BOLD_TEXT_CASE,
  YLE_SANS_XL_BOLD_TEXT_DECORATION: YLE_SANS_XL_BOLD_TEXT_DECORATION
});

/**
 * Yle Design System
 * v1.2.4
 */

const FONT_SIZE_7XL = '56px';
const FONT_SIZE_6XL = '48px';
const FONT_SIZE_5XL = '40px';
const FONT_SIZE_4XL = '32px';
const FONT_SIZE_3XL = '28px';
const FONT_SIZE_2XL = '24px';
const FONT_SIZE_XL = '20px';
const FONT_SIZE_LG = '18px';
const FONT_SIZE_MD = '16px';
const FONT_SIZE_SM = '14px';
const FONT_SIZE_XS = '12px';
const FONT_WEIGHT_HEAVY = 900; // New
const FONT_WEIGHT_BLACK = 900; // Deprecated, use heavy instead
const FONT_WEIGHT_EXTRA_BOLD = 800; // Deprecated, use heavy instead
const FONT_WEIGHT_BOLD = 700;
const FONT_WEIGHT_MEDIUM = 500; // New
const FONT_WEIGHT_NORMAL = 400;
const FONT_WEIGHT_LIGHT = 300; // New
const LINE_HEIGHT_120 = '120%';
const LINE_HEIGHT_130 = '130%';
const LINE_HEIGHT_140 = '140%';
const LINE_HEIGHT_150 = '150%';
const FONT_FAMILY_DEFAULT = 'Yle Next'; // New
const FONT_FAMILY_YLE_NEXT = 'Yle Next'; // New
const FONT_FAMILY_YLE = 'Yle'; // Deprecated, use Yle Next/Default instead
const FONT_FAMILY_OPEN_SANS = 'Open Sans'; // Deprecated, use Yle Next/Default instead
const TEXT_DECORATION_DEFAULT = 'none';
const FONT_STYLE_DEFAULT = 'normal';
const FONT_STYLE_ITALIC = 'italic';
const TEXT_CASE_DEFAULT = 'normal';
const TEXT_CASE_UPPERCASE = 'uppercase';
const LETTER_SPACING_MD = 0;
const LETTER_SPACING_LG = '0.01em';

var typographyTokens = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FONT_FAMILY_DEFAULT: FONT_FAMILY_DEFAULT,
  FONT_FAMILY_OPEN_SANS: FONT_FAMILY_OPEN_SANS,
  FONT_FAMILY_YLE: FONT_FAMILY_YLE,
  FONT_FAMILY_YLE_NEXT: FONT_FAMILY_YLE_NEXT,
  FONT_SIZE_2XL: FONT_SIZE_2XL,
  FONT_SIZE_3XL: FONT_SIZE_3XL,
  FONT_SIZE_4XL: FONT_SIZE_4XL,
  FONT_SIZE_5XL: FONT_SIZE_5XL,
  FONT_SIZE_6XL: FONT_SIZE_6XL,
  FONT_SIZE_7XL: FONT_SIZE_7XL,
  FONT_SIZE_LG: FONT_SIZE_LG,
  FONT_SIZE_MD: FONT_SIZE_MD,
  FONT_SIZE_SM: FONT_SIZE_SM,
  FONT_SIZE_XL: FONT_SIZE_XL,
  FONT_SIZE_XS: FONT_SIZE_XS,
  FONT_STYLE_DEFAULT: FONT_STYLE_DEFAULT,
  FONT_STYLE_ITALIC: FONT_STYLE_ITALIC,
  FONT_WEIGHT_BLACK: FONT_WEIGHT_BLACK,
  FONT_WEIGHT_BOLD: FONT_WEIGHT_BOLD,
  FONT_WEIGHT_EXTRA_BOLD: FONT_WEIGHT_EXTRA_BOLD,
  FONT_WEIGHT_HEAVY: FONT_WEIGHT_HEAVY,
  FONT_WEIGHT_LIGHT: FONT_WEIGHT_LIGHT,
  FONT_WEIGHT_MEDIUM: FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_NORMAL: FONT_WEIGHT_NORMAL,
  LETTER_SPACING_LG: LETTER_SPACING_LG,
  LETTER_SPACING_MD: LETTER_SPACING_MD,
  LINE_HEIGHT_120: LINE_HEIGHT_120,
  LINE_HEIGHT_130: LINE_HEIGHT_130,
  LINE_HEIGHT_140: LINE_HEIGHT_140,
  LINE_HEIGHT_150: LINE_HEIGHT_150,
  TEXT_CASE_DEFAULT: TEXT_CASE_DEFAULT,
  TEXT_CASE_UPPERCASE: TEXT_CASE_UPPERCASE,
  TEXT_DECORATION_DEFAULT: TEXT_DECORATION_DEFAULT
});

/**
 * Yle Design System
 * v1.2.4
 */

const TV_YLE_1 = '#008ac7';
const TV_YLE_2 = '#cb0fd0';
const TV_YLE_TEEMA = '#fe8300';
const TV_YLE_FEM = '#a3bd2f';
const TV_LASTENAREENA = '#feb500';
const RADIO_YLE_1 = '#dc006a';
const RADIO_YLE_X = '#fd2b77';
const RADIO_YLE_SUOMI = '#0000e6';
const RADIO_YLE_PUHE = '#ffff0b';
const RADIO_YLE_SAMI = '#0049bf';
const RADIO_YLE_KLASSINEN = '#0f7b87';
const RADIO_YLE_VEGA = '#169bd4';
const RADIO_YLE_X3M = '#ff4c20';
const RADIO_YLE_SUOMI_2 = '#00b9eb';

var colorsChannel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RADIO_YLE_1: RADIO_YLE_1,
  RADIO_YLE_KLASSINEN: RADIO_YLE_KLASSINEN,
  RADIO_YLE_PUHE: RADIO_YLE_PUHE,
  RADIO_YLE_SAMI: RADIO_YLE_SAMI,
  RADIO_YLE_SUOMI: RADIO_YLE_SUOMI,
  RADIO_YLE_SUOMI_2: RADIO_YLE_SUOMI_2,
  RADIO_YLE_VEGA: RADIO_YLE_VEGA,
  RADIO_YLE_X: RADIO_YLE_X,
  RADIO_YLE_X3M: RADIO_YLE_X3M,
  TV_LASTENAREENA: TV_LASTENAREENA,
  TV_YLE_1: TV_YLE_1,
  TV_YLE_2: TV_YLE_2,
  TV_YLE_FEM: TV_YLE_FEM,
  TV_YLE_TEEMA: TV_YLE_TEEMA
});

/**
 * Yle Design System
 * v1.2.4
 */

const PARTY_KESK = '#209e3a';
const PARTY_PS = '#00c2ef';
const PARTY_KOK = '#005cb7';
const PARTY_SDP = '#ff3333';
const PARTY_VIHR = '#6bd12a';
const PARTY_VAS = '#9a003d';
const PARTY_RKP = '#f9b800';
const PARTY_KD = '#7946e8';
const PARTY_SIN = '#002c7a';
const PARTY_FEM = '#ff4097';
const PARTY_LIIK = '#af0079';
const PARTY_KTP = '#640020';
const PARTY_LIB = '#f95900';
const PARTY_PIR = '#191919';
const PARTY_MUUT = '#9cacb5';
const POLITICAL_ALIGNMENT_FAR_LEFT = '#6d162e';
const POLITICAL_ALIGNMENT_LEFT = '#cb1428';
const POLITICAL_ALIGNMENT_MID_LEFT = '#f195a9';
const POLITICAL_ALIGNMENT_MID_RIGHT = '#6bb6e1';
const POLITICAL_ALIGNMENT_RIGHT = '#1877bc';
const POLITICAL_ALIGNMENT_FAR_RIGHT = '#223361';

var colorsPolitical = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PARTY_FEM: PARTY_FEM,
  PARTY_KD: PARTY_KD,
  PARTY_KESK: PARTY_KESK,
  PARTY_KOK: PARTY_KOK,
  PARTY_KTP: PARTY_KTP,
  PARTY_LIB: PARTY_LIB,
  PARTY_LIIK: PARTY_LIIK,
  PARTY_MUUT: PARTY_MUUT,
  PARTY_PIR: PARTY_PIR,
  PARTY_PS: PARTY_PS,
  PARTY_RKP: PARTY_RKP,
  PARTY_SDP: PARTY_SDP,
  PARTY_SIN: PARTY_SIN,
  PARTY_VAS: PARTY_VAS,
  PARTY_VIHR: PARTY_VIHR,
  POLITICAL_ALIGNMENT_FAR_LEFT: POLITICAL_ALIGNMENT_FAR_LEFT,
  POLITICAL_ALIGNMENT_FAR_RIGHT: POLITICAL_ALIGNMENT_FAR_RIGHT,
  POLITICAL_ALIGNMENT_LEFT: POLITICAL_ALIGNMENT_LEFT,
  POLITICAL_ALIGNMENT_MID_LEFT: POLITICAL_ALIGNMENT_MID_LEFT,
  POLITICAL_ALIGNMENT_MID_RIGHT: POLITICAL_ALIGNMENT_MID_RIGHT,
  POLITICAL_ALIGNMENT_RIGHT: POLITICAL_ALIGNMENT_RIGHT
});

/**
 * Yle Design System
 * v1.2.4
 */

const WEATHER_ICON_CLOUD_LIGHT$2 = 'var(--yds-infographic-weather-icon-cloud-light, #d8d9db)'; // gray-30
const WEATHER_ICON_CLOUD_MID$2 = 'var(--yds-infographic-weather-icon-cloud-mid, #949697)'; // gray-50
const WEATHER_ICON_CLOUD_DARK$2 = 'var(--yds-infographic-weather-icon-cloud-dark, #4a4f54)'; // gray-60
const WEATHER_ICON_MOON$2 = 'var(--yds-infographic-weather-icon-moon, #95c6ff)'; // info-blue-20
const WEATHER_ICON_DROPLET$2 = 'var(--yds-infographic-weather-icon-droplet, #2684ff)'; // info-blue-50
const WEATHER_ICON_SUN$2 = 'var(--yds-infographic-weather-icon-sun, #ffc400)'; // info-yellow-50
const TEXT_DEFAULT$2 = 'var(--yds-infographic-text-default, #131415)'; // default-text
const BACKGROUND$2 = 'var(--yds-infographic-background, #ffffff)'; // background
const TOOLTIP_BACKGROUND$2 = 'var(--yds-infographic-tooltip-background, #131415)'; // negative-background
const GRIDLINE$2 = 'var(--yds-infographic-gridline, #b4b6b7)'; // gray-40
const TEXT_NEGATIVE$2 = 'var(--yds-infographic-text-negative, #f8f9fa)'; // negative-text
const TEXT_SECONDARY$2 = 'var(--yds-infographic-text-secondary, #4a4f54)'; // gray-60
const TEXT_DARK$2 = 'var(--yds-infographic-text-dark, #131415)'; // dark-text
const TEXT_LIGHT$2 = 'var(--yds-infographic-text-light, #f8f9fa)'; // light-text
const NEWS_DEFAULT_1$2 = 'var(--yds-infographic-news-default-1, #7c59fa)'; // news-violet-40
const NEWS_DEFAULT_2$2 = 'var(--yds-infographic-news-default-2, #009cb5)'; // turquoise-60
const NEWS_DEFAULT_3$2 = 'var(--yds-infographic-news-default-3, #0b54b4)'; // info-blue-90
const NEWS_DEFAULT_4$2 = 'var(--yds-infographic-news-default-4, #f56a1b)'; // info-orange-60
const NEWS_DEFAULT_5$2 = 'var(--yds-infographic-news-default-5, #80259f)'; // info-purple-60
const NEWS_DEFAULT_6$2 = 'var(--yds-infographic-news-default-6, #2f2372)'; // news-violet-80
const NEWS_MONOCHROME_1$2 = 'var(--yds-infographic-news-monochrome-1, #1e1753)'; // news-violet-90
const NEWS_MONOCHROME_2$2 = 'var(--yds-infographic-news-monochrome-2, #413091)'; // news-violet-70
const NEWS_MONOCHROME_3$2 = 'var(--yds-infographic-news-monochrome-3, #694bd7)'; // news-violet-50
const NEWS_MONOCHROME_4$2 = 'var(--yds-infographic-news-monochrome-4, #9479fb)'; // news-violet-30
const NEWS_MONOCHROME_5$2 = 'var(--yds-infographic-news-monochrome-5, #b7a8fa)'; // news-violet-20
const NEWS_MONOCHROME_6$2 = 'var(--yds-infographic-news-monochrome-6, #d3cbfb)'; // news-violet-10
const SPORTS_DEFAULT_1$2 = 'var(--yds-infographic-sports-default-1, #5541ed)'; // sports-violet-50
const SPORTS_DEFAULT_2$2 = 'var(--yds-infographic-sports-default-2, #ea3e85)'; // sports-pink-40
const SPORTS_DEFAULT_3$2 = 'var(--yds-infographic-sports-default-3, #7a9a2c)'; // sports-lime-70
const SPORTS_DEFAULT_4$2 = 'var(--yds-infographic-sports-default-4, #6553ef)'; // sports-violet-40
const SPORTS_DEFAULT_5$2 = 'var(--yds-infographic-sports-default-5, #f273a8)'; // sports-pink-30
const SPORTS_DEFAULT_6$2 = 'var(--yds-infographic-sports-default-6, #46690b)'; // sports-lime-90
const SPORTS_MONOCHROME_1$2 = 'var(--yds-infographic-sports-monochrome-1, #1a1476)'; // sports-violet-80
const SPORTS_MONOCHROME_2$2 = 'var(--yds-infographic-sports-monochrome-2, #372bb1)'; // sports-violet-60
const SPORTS_MONOCHROME_3$2 = 'var(--yds-infographic-sports-monochrome-3, #5541ed)'; // sports-violet-50
const SPORTS_MONOCHROME_4$2 = 'var(--yds-infographic-sports-monochrome-4, #8578f2)'; // sports-violet-30
const SPORTS_MONOCHROME_5$2 = 'var(--yds-infographic-sports-monochrome-5, #b3abf7)'; // sports-violet-20
const SPORTS_MONOCHROME_6$2 = 'var(--yds-infographic-sports-monochrome-6, #ddd9fc)'; // sports-violet-10
const ACCENT_NEWS$2 = 'var(--yds-infographic-accent-news, #f26659)'; // news-orange-50

var infographicDefault = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACCENT_NEWS: ACCENT_NEWS$2,
  BACKGROUND: BACKGROUND$2,
  GRIDLINE: GRIDLINE$2,
  NEWS_DEFAULT_1: NEWS_DEFAULT_1$2,
  NEWS_DEFAULT_2: NEWS_DEFAULT_2$2,
  NEWS_DEFAULT_3: NEWS_DEFAULT_3$2,
  NEWS_DEFAULT_4: NEWS_DEFAULT_4$2,
  NEWS_DEFAULT_5: NEWS_DEFAULT_5$2,
  NEWS_DEFAULT_6: NEWS_DEFAULT_6$2,
  NEWS_MONOCHROME_1: NEWS_MONOCHROME_1$2,
  NEWS_MONOCHROME_2: NEWS_MONOCHROME_2$2,
  NEWS_MONOCHROME_3: NEWS_MONOCHROME_3$2,
  NEWS_MONOCHROME_4: NEWS_MONOCHROME_4$2,
  NEWS_MONOCHROME_5: NEWS_MONOCHROME_5$2,
  NEWS_MONOCHROME_6: NEWS_MONOCHROME_6$2,
  SPORTS_DEFAULT_1: SPORTS_DEFAULT_1$2,
  SPORTS_DEFAULT_2: SPORTS_DEFAULT_2$2,
  SPORTS_DEFAULT_3: SPORTS_DEFAULT_3$2,
  SPORTS_DEFAULT_4: SPORTS_DEFAULT_4$2,
  SPORTS_DEFAULT_5: SPORTS_DEFAULT_5$2,
  SPORTS_DEFAULT_6: SPORTS_DEFAULT_6$2,
  SPORTS_MONOCHROME_1: SPORTS_MONOCHROME_1$2,
  SPORTS_MONOCHROME_2: SPORTS_MONOCHROME_2$2,
  SPORTS_MONOCHROME_3: SPORTS_MONOCHROME_3$2,
  SPORTS_MONOCHROME_4: SPORTS_MONOCHROME_4$2,
  SPORTS_MONOCHROME_5: SPORTS_MONOCHROME_5$2,
  SPORTS_MONOCHROME_6: SPORTS_MONOCHROME_6$2,
  TEXT_DARK: TEXT_DARK$2,
  TEXT_DEFAULT: TEXT_DEFAULT$2,
  TEXT_LIGHT: TEXT_LIGHT$2,
  TEXT_NEGATIVE: TEXT_NEGATIVE$2,
  TEXT_SECONDARY: TEXT_SECONDARY$2,
  TOOLTIP_BACKGROUND: TOOLTIP_BACKGROUND$2,
  WEATHER_ICON_CLOUD_DARK: WEATHER_ICON_CLOUD_DARK$2,
  WEATHER_ICON_CLOUD_LIGHT: WEATHER_ICON_CLOUD_LIGHT$2,
  WEATHER_ICON_CLOUD_MID: WEATHER_ICON_CLOUD_MID$2,
  WEATHER_ICON_DROPLET: WEATHER_ICON_DROPLET$2,
  WEATHER_ICON_MOON: WEATHER_ICON_MOON$2,
  WEATHER_ICON_SUN: WEATHER_ICON_SUN$2
});

/**
 * Yle Design System
 * v1.2.4
 */

const WEATHER_ICON_CLOUD_LIGHT$1 = '#d8d9db'; // gray-30
const WEATHER_ICON_CLOUD_MID$1 = '#949697'; // gray-50
const WEATHER_ICON_CLOUD_DARK$1 = '#4a4f54'; // gray-60
const WEATHER_ICON_MOON$1 = '#95c6ff'; // info-blue-20
const WEATHER_ICON_DROPLET$1 = '#ffffff'; // white
const WEATHER_ICON_SUN$1 = '#ffc400'; // info-yellow-50
const TEXT_DEFAULT$1 = '#f8f9fa'; // default-text
const BACKGROUND$1 = '#131415'; // background
const TOOLTIP_BACKGROUND$1 = '#ffffff'; // negative-background
const GRIDLINE$1 = '#4a4f54'; // gray-60
const TEXT_NEGATIVE$1 = '#131415'; // negative-text
const TEXT_SECONDARY$1 = '#b4b6b7'; // gray-40
const TEXT_DARK$1 = '#131415'; // dark-text
const TEXT_LIGHT$1 = '#f8f9fa'; // light-text
const NEWS_DEFAULT_1$1 = '#7c59fa'; // news-violet-40
const NEWS_DEFAULT_2$1 = '#29ccde'; // turquoise-40
const NEWS_DEFAULT_3$1 = '#ffe387'; // info-yellow-20
const NEWS_DEFAULT_4$1 = '#ff8f33'; // info-orange-50
const NEWS_DEFAULT_5$1 = '#9436b5'; // info-purple-50
const NEWS_DEFAULT_6$1 = '#fff3e2'; // info-orange-5
const NEWS_MONOCHROME_1$1 = '#e6e5ff'; // news-violet-5
const NEWS_MONOCHROME_2$1 = '#d3cbfb'; // news-violet-10
const NEWS_MONOCHROME_3$1 = '#b7a8fa'; // news-violet-20
const NEWS_MONOCHROME_4$1 = '#9479fb'; // news-violet-30
const NEWS_MONOCHROME_5$1 = '#694bd7'; // news-violet-50
const NEWS_MONOCHROME_6$1 = '#413091'; // news-violet-70
const SPORTS_DEFAULT_1$1 = '#5541ed'; // sports-violet-50
const SPORTS_DEFAULT_2$1 = '#ea3e85'; // sports-pink-40
const SPORTS_DEFAULT_3$1 = '#d4ff42'; // sports-lime-30
const SPORTS_DEFAULT_4$1 = '#8578f2'; // sports-violet-30
const SPORTS_DEFAULT_5$1 = '#f7abcb'; // sports-pink-20
const SPORTS_DEFAULT_6$1 = '#ebfe8d'; // sports-lime-20
const SPORTS_MONOCHROME_1$1 = '#eeeeff'; // sports-violet-5
const SPORTS_MONOCHROME_2$1 = '#ddd9fc'; // sports-violet-10
const SPORTS_MONOCHROME_3$1 = '#b3abf7'; // sports-violet-20
const SPORTS_MONOCHROME_4$1 = '#8578f2'; // sports-violet-30
const SPORTS_MONOCHROME_5$1 = '#5541ed'; // sports-violet-50
const SPORTS_MONOCHROME_6$1 = '#372bb1'; // sports-violet-60
const ACCENT_NEWS$1 = '#f26659'; // news-orange-50

var infographicDark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACCENT_NEWS: ACCENT_NEWS$1,
  BACKGROUND: BACKGROUND$1,
  GRIDLINE: GRIDLINE$1,
  NEWS_DEFAULT_1: NEWS_DEFAULT_1$1,
  NEWS_DEFAULT_2: NEWS_DEFAULT_2$1,
  NEWS_DEFAULT_3: NEWS_DEFAULT_3$1,
  NEWS_DEFAULT_4: NEWS_DEFAULT_4$1,
  NEWS_DEFAULT_5: NEWS_DEFAULT_5$1,
  NEWS_DEFAULT_6: NEWS_DEFAULT_6$1,
  NEWS_MONOCHROME_1: NEWS_MONOCHROME_1$1,
  NEWS_MONOCHROME_2: NEWS_MONOCHROME_2$1,
  NEWS_MONOCHROME_3: NEWS_MONOCHROME_3$1,
  NEWS_MONOCHROME_4: NEWS_MONOCHROME_4$1,
  NEWS_MONOCHROME_5: NEWS_MONOCHROME_5$1,
  NEWS_MONOCHROME_6: NEWS_MONOCHROME_6$1,
  SPORTS_DEFAULT_1: SPORTS_DEFAULT_1$1,
  SPORTS_DEFAULT_2: SPORTS_DEFAULT_2$1,
  SPORTS_DEFAULT_3: SPORTS_DEFAULT_3$1,
  SPORTS_DEFAULT_4: SPORTS_DEFAULT_4$1,
  SPORTS_DEFAULT_5: SPORTS_DEFAULT_5$1,
  SPORTS_DEFAULT_6: SPORTS_DEFAULT_6$1,
  SPORTS_MONOCHROME_1: SPORTS_MONOCHROME_1$1,
  SPORTS_MONOCHROME_2: SPORTS_MONOCHROME_2$1,
  SPORTS_MONOCHROME_3: SPORTS_MONOCHROME_3$1,
  SPORTS_MONOCHROME_4: SPORTS_MONOCHROME_4$1,
  SPORTS_MONOCHROME_5: SPORTS_MONOCHROME_5$1,
  SPORTS_MONOCHROME_6: SPORTS_MONOCHROME_6$1,
  TEXT_DARK: TEXT_DARK$1,
  TEXT_DEFAULT: TEXT_DEFAULT$1,
  TEXT_LIGHT: TEXT_LIGHT$1,
  TEXT_NEGATIVE: TEXT_NEGATIVE$1,
  TEXT_SECONDARY: TEXT_SECONDARY$1,
  TOOLTIP_BACKGROUND: TOOLTIP_BACKGROUND$1,
  WEATHER_ICON_CLOUD_DARK: WEATHER_ICON_CLOUD_DARK$1,
  WEATHER_ICON_CLOUD_LIGHT: WEATHER_ICON_CLOUD_LIGHT$1,
  WEATHER_ICON_CLOUD_MID: WEATHER_ICON_CLOUD_MID$1,
  WEATHER_ICON_DROPLET: WEATHER_ICON_DROPLET$1,
  WEATHER_ICON_MOON: WEATHER_ICON_MOON$1,
  WEATHER_ICON_SUN: WEATHER_ICON_SUN$1
});

/**
 * Yle Design System
 * v1.2.4
 */

const WEATHER_ICON_CLOUD_LIGHT = '#d8d9db'; // gray-30
const WEATHER_ICON_CLOUD_MID = '#949697'; // gray-50
const WEATHER_ICON_CLOUD_DARK = '#4a4f54'; // gray-60
const WEATHER_ICON_MOON = '#95c6ff'; // info-blue-20
const WEATHER_ICON_DROPLET = '#2684ff'; // info-blue-50
const WEATHER_ICON_SUN = '#ffc400'; // info-yellow-50
const TEXT_DEFAULT = '#131415'; // default-text
const BACKGROUND = '#ffffff'; // background
const TOOLTIP_BACKGROUND = '#131415'; // negative-background
const GRIDLINE = '#b4b6b7'; // gray-40
const TEXT_NEGATIVE = '#f8f9fa'; // negative-text
const TEXT_SECONDARY = '#4a4f54'; // gray-60
const TEXT_DARK = '#131415'; // dark-text
const TEXT_LIGHT = '#f8f9fa'; // light-text
const NEWS_DEFAULT_1 = '#7c59fa'; // news-violet-40
const NEWS_DEFAULT_2 = '#009cb5'; // turquoise-60
const NEWS_DEFAULT_3 = '#0b54b4'; // info-blue-90
const NEWS_DEFAULT_4 = '#f56a1b'; // info-orange-60
const NEWS_DEFAULT_5 = '#80259f'; // info-purple-60
const NEWS_DEFAULT_6 = '#2f2372'; // news-violet-80
const NEWS_MONOCHROME_1 = '#1e1753'; // news-violet-90
const NEWS_MONOCHROME_2 = '#413091'; // news-violet-70
const NEWS_MONOCHROME_3 = '#694bd7'; // news-violet-50
const NEWS_MONOCHROME_4 = '#9479fb'; // news-violet-30
const NEWS_MONOCHROME_5 = '#b7a8fa'; // news-violet-20
const NEWS_MONOCHROME_6 = '#d3cbfb'; // news-violet-10
const SPORTS_DEFAULT_1 = '#5541ed'; // sports-violet-50
const SPORTS_DEFAULT_2 = '#ea3e85'; // sports-pink-40
const SPORTS_DEFAULT_3 = '#7a9a2c'; // sports-lime-70
const SPORTS_DEFAULT_4 = '#6553ef'; // sports-violet-40
const SPORTS_DEFAULT_5 = '#f273a8'; // sports-pink-30
const SPORTS_DEFAULT_6 = '#46690b'; // sports-lime-90
const SPORTS_MONOCHROME_1 = '#1a1476'; // sports-violet-80
const SPORTS_MONOCHROME_2 = '#372bb1'; // sports-violet-60
const SPORTS_MONOCHROME_3 = '#5541ed'; // sports-violet-50
const SPORTS_MONOCHROME_4 = '#8578f2'; // sports-violet-30
const SPORTS_MONOCHROME_5 = '#b3abf7'; // sports-violet-20
const SPORTS_MONOCHROME_6 = '#ddd9fc'; // sports-violet-10
const ACCENT_NEWS = '#f26659'; // news-orange-50

var infographicLight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ACCENT_NEWS: ACCENT_NEWS,
  BACKGROUND: BACKGROUND,
  GRIDLINE: GRIDLINE,
  NEWS_DEFAULT_1: NEWS_DEFAULT_1,
  NEWS_DEFAULT_2: NEWS_DEFAULT_2,
  NEWS_DEFAULT_3: NEWS_DEFAULT_3,
  NEWS_DEFAULT_4: NEWS_DEFAULT_4,
  NEWS_DEFAULT_5: NEWS_DEFAULT_5,
  NEWS_DEFAULT_6: NEWS_DEFAULT_6,
  NEWS_MONOCHROME_1: NEWS_MONOCHROME_1,
  NEWS_MONOCHROME_2: NEWS_MONOCHROME_2,
  NEWS_MONOCHROME_3: NEWS_MONOCHROME_3,
  NEWS_MONOCHROME_4: NEWS_MONOCHROME_4,
  NEWS_MONOCHROME_5: NEWS_MONOCHROME_5,
  NEWS_MONOCHROME_6: NEWS_MONOCHROME_6,
  SPORTS_DEFAULT_1: SPORTS_DEFAULT_1,
  SPORTS_DEFAULT_2: SPORTS_DEFAULT_2,
  SPORTS_DEFAULT_3: SPORTS_DEFAULT_3,
  SPORTS_DEFAULT_4: SPORTS_DEFAULT_4,
  SPORTS_DEFAULT_5: SPORTS_DEFAULT_5,
  SPORTS_DEFAULT_6: SPORTS_DEFAULT_6,
  SPORTS_MONOCHROME_1: SPORTS_MONOCHROME_1,
  SPORTS_MONOCHROME_2: SPORTS_MONOCHROME_2,
  SPORTS_MONOCHROME_3: SPORTS_MONOCHROME_3,
  SPORTS_MONOCHROME_4: SPORTS_MONOCHROME_4,
  SPORTS_MONOCHROME_5: SPORTS_MONOCHROME_5,
  SPORTS_MONOCHROME_6: SPORTS_MONOCHROME_6,
  TEXT_DARK: TEXT_DARK,
  TEXT_DEFAULT: TEXT_DEFAULT,
  TEXT_LIGHT: TEXT_LIGHT,
  TEXT_NEGATIVE: TEXT_NEGATIVE,
  TEXT_SECONDARY: TEXT_SECONDARY,
  TOOLTIP_BACKGROUND: TOOLTIP_BACKGROUND,
  WEATHER_ICON_CLOUD_DARK: WEATHER_ICON_CLOUD_DARK,
  WEATHER_ICON_CLOUD_LIGHT: WEATHER_ICON_CLOUD_LIGHT,
  WEATHER_ICON_CLOUD_MID: WEATHER_ICON_CLOUD_MID,
  WEATHER_ICON_DROPLET: WEATHER_ICON_DROPLET,
  WEATHER_ICON_MOON: WEATHER_ICON_MOON,
  WEATHER_ICON_SUN: WEATHER_ICON_SUN
});

/**
 * Yle Design System
 * v1.2.4
 */

var themeLightCssFragment = `--yds-color-background: #ffffff; /* white */
  --yds-color-background-variant: #f8f9fa; /* gray-5 */
  --yds-color-background-negative: #131415; /* gray-95 */
  --yds-color-background-navigation: #ffffff; /* white */
  --yds-color-background-control: rgba(0, 0, 0, 0.41); /* black-opacity-50 */
  --yds-color-background-control-disabled: rgba(0, 0, 0, 0.15); /* black-opacity-30 */
  --yds-color-background-input: #ffffff; /* white */
  --yds-color-background-highlight: #e8e9eb; /* gray-20 */
  --yds-color-background-interactive: #f1f2f4; /* gray-10 */
  --yds-color-background-dialog: #ffffff; /* white */
  --yds-color-background-dialog-overlay: rgba(0, 0, 0, 0.41); /* black-opacity-50 */
  --yds-color-background-info-primary: #9fc8ee; /* blue-20 */
  --yds-color-background-info-secondary: #f1f2f4; /* gray-10 */
  --yds-color-background-success: #62f9c2; /* green-20 */
  --yds-color-background-warning: #ffd199; /* info-orange-20 */
  --yds-color-background-error: #f99fb5; /* red-20 */
  --yds-color-background-opinion-article: #3d5483; /* info-deep-blue-60 */
  --yds-color-text-default: #131415; /* gray-95 */
  --yds-color-text-negative: #f8f9fa; /* gray-5 */
  --yds-color-text-input-placeholder: #4a4f54; /* gray-60 */
  --yds-color-text-high-emphasis: rgba(0, 0, 0, 0.79); /* black-opacity-70 */
  --yds-color-text-medium-emphasis: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-text-disabled: rgba(0, 0, 0, 0.29); /* black-opacity-40 */
  --yds-color-text-light: #f8f9fa; /* gray-5 */
  --yds-color-text-dark: #131415; /* gray-95 */
  --yds-color-action-primary: #131415; /* gray-95 */
  --yds-color-action-primary-variant: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-action-secondary: rgba(0, 0, 0, 0.05); /* black-opacity-10 */
  --yds-color-action-secondary-variant: rgba(0, 0, 0, 0.09); /* black-opacity-20 */
  --yds-color-action-disabled: rgba(0, 0, 0, 0.15); /* black-opacity-30 */
  --yds-color-border: #131415; /* gray-95 */
  --yds-color-border-disabled: rgba(0, 0, 0, 0.29); /* black-opacity-40 */
  --yds-color-border-primary-focus: #009cb5; /* turquoise-60 */
  --yds-color-border-secondary-focus: #131415; /* gray-95 */
  --yds-color-border-separator: #e8e9eb; /* gray-20 */
  --yds-color-illustrative-icons-icon-primary: #131415; /* gray-95 */
  --yds-color-illustrative-icons-icon-secondary: #5ddbe9; /* turquoise-30 */
  --yds-color-player-progress-bar: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-player-progress-indicator: #29ccde; /* turquoise-40 */
  --yds-color-spinner-default: #131415; /* gray-95 */
  --yds-color-spinner-negative: #ffffff; /* white */
  --yds-color-spinner-highlight-default: #009cb5; /* turquoise-60 */
  --yds-color-spinner-highlight-negative: #29ccde; /* turquoise-40 */
  --yds-color-spinner-background-default: #d8d9db; /* gray-30 */
  --yds-color-spinner-background-negative: #292b2d; /* gray-80 */
  --yds-color-feedback-highlight: #009cb5; /* turquoise-60 */
  --yds-color-feedback-error: #d10b3d; /* red-60 */
  --yds-color-feedback-warning: #f1722a; /* orange-60 */
  --yds-color-feedback-success: #058657; /* green-70 */
  --yds-color-feedback-live: #e90e43; /* red-50 */
  --yds-color-logo-yle: #00b4c8; /* turquoise-50 */
  --yds-color-logo-tv1: #008ac7; /* yle-tv-1 */
  --yds-color-logo-tv-2: #cb0fd0; /* yle-tv-2 */
  --yds-color-logo-yle-teema: #fe8300; /* yle-teema */
  --yds-color-logo-yle-fem: #a3bd2f; /* yle-fem */
  --yds-color-logo-lastenareena: #feb500; /* lastenareena */
  --yds-color-logo-yle-radio-1: #dc006a; /* yle-radio-1 */
  --yds-color-logo-yle-radio-suomi: #0000e6; /* yle-radio-suomi */
  --yds-color-logo-yle-x: #fd2b77; /* yle-x */
  --yds-color-logo-yle-x3m: #ff4c20; /* yle-x3m */
  --yds-color-logo-yle-vega: #169bd4; /* yle-vega */
  --yds-color-logo-yle-klassinen: #0f7b87; /* yle-klassinen */
  --yds-color-logo-yle-sami-radio: #0049bf; /* yle-sami-radio */
  --yds-color-logo-areena: #29ccde; /* turquoise-40 */
  --yds-color-brand-yle: #00b4c8; /* turquoise-50 */
  --yds-color-tag-live: #e90e43; /* red-50 */
  --yds-color-tag-default: #131415; /* gray-95 */
  --yds-color-tag-opinion: #3d5483; /* info-deep-blue-60 */
  --yds-color-tag-yle-corporate: #00809c; /* turquoise-70 */
  --yds-color-tag-primary-action: #131415; /* gray-95 */
  --yds-color-tag-primary-action-variant: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-tag-secondary-action: rgba(0, 0, 0, 0.05); /* black-opacity-10 */
  --yds-color-tag-secondary-action-variant: rgba(0, 0, 0, 0.02); /* black-opacity-5 */`;

/**
 * Yle Design System
 * v1.2.4
 */

var themeDarkCssFragment = `--yds-color-background: #131415; /* gray-95 */
  --yds-color-background-variant: #1f2123; /* gray-90 */
  --yds-color-background-negative: #ffffff; /* white */
  --yds-color-background-navigation: #000000; /* black */
  --yds-color-background-control: rgba(255, 255, 255, 0.59); /* white-opacity-50 */
  --yds-color-background-control-disabled: rgba(255, 255, 255, 0.21); /* white-opacity-30 */
  --yds-color-background-input: #131415; /* gray-95 */
  --yds-color-background-highlight: #0b3f4b; /* turquoise-95 */
  --yds-color-background-interactive: #292b2d; /* gray-80 */
  --yds-color-background-dialog: #1f2123; /* gray-90 */
  --yds-color-background-dialog-overlay: rgba(0, 0, 0, 0.7); /* black-opacity-60 */
  --yds-color-background-info-primary: #d8d9db; /* gray-30 */
  --yds-color-background-info-secondary: #292b2d; /* gray-80 */
  --yds-color-background-success: #33d59b; /* info-green-40 */
  --yds-color-background-warning: #feb054; /* info-orange-40 */
  --yds-color-background-error: #f5517a; /* red-40 */
  --yds-color-background-opinion-article: #3d5483; /* info-deep-blue-60 */
  --yds-color-text-default: #f8f9fa; /* gray-5 */
  --yds-color-text-negative: #131415; /* gray-95 */
  --yds-color-text-input-placeholder: #949697; /* gray-50 */
  --yds-color-text-high-emphasis: rgba(255, 255, 255, 0.85); /* white-opacity-70 */
  --yds-color-text-medium-emphasis: rgba(255, 255, 255, 0.71); /* white-opacity-60 */
  --yds-color-text-disabled: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-text-light: #f8f9fa; /* gray-5 */
  --yds-color-text-dark: #131415; /* gray-95 */
  --yds-color-action-primary: #f8f9fa; /* gray-5 */
  --yds-color-action-primary-variant: rgba(255, 255, 255, 0.71); /* white-opacity-60 */
  --yds-color-action-secondary: rgba(255, 255, 255, 0.08); /* white-opacity-5 */
  --yds-color-action-secondary-variant: rgba(255, 255, 255, 0.17); /* white-opacity-20 */
  --yds-color-action-disabled: rgba(255, 255, 255, 0.21); /* white-opacity-30 */
  --yds-color-border: #f8f9fa; /* gray-5 */
  --yds-color-border-disabled: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-border-primary-focus: #29ccde; /* turquoise-40 */
  --yds-color-border-secondary-focus: #f8f9fa; /* gray-5 */
  --yds-color-border-separator: #4a4f54; /* gray-60 */
  --yds-color-illustrative-icons-icon-primary: #f8f9fa; /* gray-5 */
  --yds-color-illustrative-icons-icon-secondary: #009cb5; /* turquoise-60 */
  --yds-color-player-progress-bar: rgba(255, 255, 255, 0.3); /* white-opacity-40 */
  --yds-color-player-progress-indicator: #29ccde; /* turquoise-40 */
  --yds-color-spinner-default: #ffffff; /* white */
  --yds-color-spinner-negative: #131415; /* gray-95 */
  --yds-color-spinner-highlight-default: #29ccde; /* turquoise-40 */
  --yds-color-spinner-highlight-negative: #009cb5; /* turquoise-60 */
  --yds-color-spinner-background-default: #292b2d; /* gray-80 */
  --yds-color-spinner-background-negative: #d8d9db; /* gray-30 */
  --yds-color-feedback-highlight: #29ccde; /* turquoise-40 */
  --yds-color-feedback-error: #f5517a; /* red-40 */
  --yds-color-feedback-warning: #ff9c31; /* orange-40 */
  --yds-color-feedback-success: #03e592; /* green-40 */
  --yds-color-feedback-live: #e90e43; /* red-50 */
  --yds-color-logo-yle: #f8f9fa; /* gray-5 */
  --yds-color-logo-tv1: #008ac7; /* yle-tv-1 */
  --yds-color-logo-tv-2: #cb0fd0; /* yle-tv-2 */
  --yds-color-logo-yle-teema: #fe8300; /* yle-teema */
  --yds-color-logo-yle-fem: #a3bd2f; /* yle-fem */
  --yds-color-logo-lastenareena: #feb500; /* lastenareena */
  --yds-color-logo-yle-radio-1: #dc006a; /* yle-radio-1 */
  --yds-color-logo-yle-radio-suomi: #00b9eb; /* yle-radio-suomi-2 */
  --yds-color-logo-yle-x: #fd2b77; /* yle-x */
  --yds-color-logo-yle-x3m: #ff4c20; /* yle-x3m */
  --yds-color-logo-yle-vega: #169bd4; /* yle-vega */
  --yds-color-logo-yle-klassinen: #0f7b87; /* yle-klassinen */
  --yds-color-logo-yle-sami-radio: #0049bf; /* yle-sami-radio */
  --yds-color-logo-areena: #29ccde; /* turquoise-40 */
  --yds-color-brand-yle: #00b4c8; /* turquoise-50 */
  --yds-color-tag-live: #e90e43; /* red-50 */
  --yds-color-tag-default: #ffffff; /* white */
  --yds-color-tag-opinion: #3d5483; /* info-deep-blue-60 */
  --yds-color-tag-yle-corporate: #00809c; /* turquoise-70 */
  --yds-color-tag-primary-action: #f8f9fa; /* gray-5 */
  --yds-color-tag-primary-action-variant: rgba(255, 255, 255, 0.71); /* white-opacity-60 */
  --yds-color-tag-secondary-action: rgba(255, 255, 255, 0.13); /* white-opacity-10 */
  --yds-color-tag-secondary-action-variant: rgba(255, 255, 255, 0.08); /* white-opacity-5 */`;

/**
 * Yle Design System
 * v1.2.4
 */

var shadowLightCssFragment = `--yds-shadow-sm: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  --yds-shadow-md: 0 0 16px 0 rgba(0, 0, 0, 0.15);
  --yds-shadow-lg: 0 0 24px 0 rgba(0, 0, 0, 0.41);`;

/**
 * Yle Design System
 * v1.2.4
 */

var shadowDarkCssFragment = `--yds-shadow-sm: 0 0 8px 0 rgba(0, 0, 0, 0.70);
  --yds-shadow-md: 0 0 16px 0 rgba(0, 0, 0, 0.70);
  --yds-shadow-lg: 0 0 24px 0 rgba(0, 0, 0, 0.87);`;

/**
 * Yle Design System
 * v1.2.4
 */

var infographicLightCssFragment = `--yds-infographic-weather-icon-cloud-light: #d8d9db; /* gray-30 */
  --yds-infographic-weather-icon-cloud-mid: #949697; /* gray-50 */
  --yds-infographic-weather-icon-cloud-dark: #4a4f54; /* gray-60 */
  --yds-infographic-weather-icon-moon: #95c6ff; /* info-blue-20 */
  --yds-infographic-weather-icon-droplet: #2684ff; /* info-blue-50 */
  --yds-infographic-weather-icon-sun: #ffc400; /* info-yellow-50 */
  --yds-infographic-text-default: #131415; /* default-text */
  --yds-infographic-background: #ffffff; /* background */
  --yds-infographic-tooltip-background: #131415; /* negative-background */
  --yds-infographic-gridline: #b4b6b7; /* gray-40 */
  --yds-infographic-text-negative: #f8f9fa; /* negative-text */
  --yds-infographic-text-secondary: #4a4f54; /* gray-60 */
  --yds-infographic-text-dark: #131415; /* dark-text */
  --yds-infographic-text-light: #f8f9fa; /* light-text */
  --yds-infographic-news-default-1: #7c59fa; /* news-violet-40 */
  --yds-infographic-news-default-2: #009cb5; /* turquoise-60 */
  --yds-infographic-news-default-3: #0b54b4; /* info-blue-90 */
  --yds-infographic-news-default-4: #f56a1b; /* info-orange-60 */
  --yds-infographic-news-default-5: #80259f; /* info-purple-60 */
  --yds-infographic-news-default-6: #2f2372; /* news-violet-80 */
  --yds-infographic-news-monochrome-1: #1e1753; /* news-violet-90 */
  --yds-infographic-news-monochrome-2: #413091; /* news-violet-70 */
  --yds-infographic-news-monochrome-3: #694bd7; /* news-violet-50 */
  --yds-infographic-news-monochrome-4: #9479fb; /* news-violet-30 */
  --yds-infographic-news-monochrome-5: #b7a8fa; /* news-violet-20 */
  --yds-infographic-news-monochrome-6: #d3cbfb; /* news-violet-10 */
  --yds-infographic-sports-default-1: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-default-2: #ea3e85; /* sports-pink-40 */
  --yds-infographic-sports-default-3: #7a9a2c; /* sports-lime-70 */
  --yds-infographic-sports-default-4: #6553ef; /* sports-violet-40 */
  --yds-infographic-sports-default-5: #f273a8; /* sports-pink-30 */
  --yds-infographic-sports-default-6: #46690b; /* sports-lime-90 */
  --yds-infographic-sports-monochrome-1: #1a1476; /* sports-violet-80 */
  --yds-infographic-sports-monochrome-2: #372bb1; /* sports-violet-60 */
  --yds-infographic-sports-monochrome-3: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-monochrome-4: #8578f2; /* sports-violet-30 */
  --yds-infographic-sports-monochrome-5: #b3abf7; /* sports-violet-20 */
  --yds-infographic-sports-monochrome-6: #ddd9fc; /* sports-violet-10 */
  --yds-infographic-accent-news: #f26659; /* news-orange-50 */`;

/**
 * Yle Design System
 * v1.2.4
 */

var infographicDarkCssFragment = `--yds-infographic-weather-icon-cloud-light: #d8d9db; /* gray-30 */
  --yds-infographic-weather-icon-cloud-mid: #949697; /* gray-50 */
  --yds-infographic-weather-icon-cloud-dark: #4a4f54; /* gray-60 */
  --yds-infographic-weather-icon-moon: #95c6ff; /* info-blue-20 */
  --yds-infographic-weather-icon-droplet: #ffffff; /* white */
  --yds-infographic-weather-icon-sun: #ffc400; /* info-yellow-50 */
  --yds-infographic-text-default: #f8f9fa; /* default-text */
  --yds-infographic-background: #131415; /* background */
  --yds-infographic-tooltip-background: #ffffff; /* negative-background */
  --yds-infographic-gridline: #4a4f54; /* gray-60 */
  --yds-infographic-text-negative: #131415; /* negative-text */
  --yds-infographic-text-secondary: #b4b6b7; /* gray-40 */
  --yds-infographic-text-dark: #131415; /* dark-text */
  --yds-infographic-text-light: #f8f9fa; /* light-text */
  --yds-infographic-news-default-1: #7c59fa; /* news-violet-40 */
  --yds-infographic-news-default-2: #29ccde; /* turquoise-40 */
  --yds-infographic-news-default-3: #ffe387; /* info-yellow-20 */
  --yds-infographic-news-default-4: #ff8f33; /* info-orange-50 */
  --yds-infographic-news-default-5: #9436b5; /* info-purple-50 */
  --yds-infographic-news-default-6: #fff3e2; /* info-orange-5 */
  --yds-infographic-news-monochrome-1: #e6e5ff; /* news-violet-5 */
  --yds-infographic-news-monochrome-2: #d3cbfb; /* news-violet-10 */
  --yds-infographic-news-monochrome-3: #b7a8fa; /* news-violet-20 */
  --yds-infographic-news-monochrome-4: #9479fb; /* news-violet-30 */
  --yds-infographic-news-monochrome-5: #694bd7; /* news-violet-50 */
  --yds-infographic-news-monochrome-6: #413091; /* news-violet-70 */
  --yds-infographic-sports-default-1: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-default-2: #ea3e85; /* sports-pink-40 */
  --yds-infographic-sports-default-3: #d4ff42; /* sports-lime-30 */
  --yds-infographic-sports-default-4: #8578f2; /* sports-violet-30 */
  --yds-infographic-sports-default-5: #f7abcb; /* sports-pink-20 */
  --yds-infographic-sports-default-6: #ebfe8d; /* sports-lime-20 */
  --yds-infographic-sports-monochrome-1: #eeeeff; /* sports-violet-5 */
  --yds-infographic-sports-monochrome-2: #ddd9fc; /* sports-violet-10 */
  --yds-infographic-sports-monochrome-3: #b3abf7; /* sports-violet-20 */
  --yds-infographic-sports-monochrome-4: #8578f2; /* sports-violet-30 */
  --yds-infographic-sports-monochrome-5: #5541ed; /* sports-violet-50 */
  --yds-infographic-sports-monochrome-6: #372bb1; /* sports-violet-60 */
  --yds-infographic-accent-news: #f26659; /* news-orange-50 */`;

export { border, colorsChannel as channelColors, colors as color, shadowDark as darkShadow, shadowDarkCssFragment as darkShadowCssFragment, themeDark as darkTheme, themeDarkCssFragment as darkThemeCssFragment, shadowDefault as defaultShadow, themeDefault as defaultTheme, infographicDark, infographicDarkCssFragment, infographicDefault, infographicLight, infographicLightCssFragment, shadowLight as lightShadow, shadowLightCssFragment as lightShadowCssFragment, themeLight as lightTheme, themeLightCssFragment as lightThemeCssFragment, colorsPolitical as politicalColors, borderRadius as radius, spacing, typography, typographyTokens };
